
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lg88L", function(module, exports) {

$parcel$export(module.exports, "default", () => $af6f2bb965ff2236$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $bjGdd = parcelRequire("bjGdd");

var $1pSis = parcelRequire("1pSis");

var $creTd = parcelRequire("creTd");

var $h6hny = parcelRequire("h6hny");

var $aq1l9 = parcelRequire("aq1l9");

var $4pRS2 = parcelRequire("4pRS2");

var $jiOMJ = parcelRequire("jiOMJ");

var $5gZus = parcelRequire("5gZus");

var $1qYGk = parcelRequire("1qYGk");

var $3uoJx = parcelRequire("3uoJx");

var $dYJ87 = parcelRequire("dYJ87");
/**
 * Synchronous renderer node mapping for "small" / simple nodes
 *
 * WARNING: This is an EXPERIMENTAL entry point and may change without notice in the future. Use it only at your own risk!
 *
 * Context: https://hello.atlassian.net/wiki/spaces/JIE/pages/5342146338 (Atlassian-internal)
 */ const $af6f2bb965ff2236$var$nodeToReact = {
    codeBlock: (0, $bjGdd.default),
    date: (0, $1pSis.default),
    decisionList: (0, $creTd.default),
    decisionItem: (0, $h6hny.default),
    emoji: (0, $aq1l9.default),
    mention: (0, $4pRS2.default),
    panel: (0, $jiOMJ.default),
    status: (0, $5gZus.default),
    taskItem: (0, $1qYGk.default),
    taskList: (0, $3uoJx.default),
    expand: (0, $dYJ87.default)
};
var $af6f2bb965ff2236$export$2e2bcd8739ae039 = $af6f2bb965ff2236$var$nodeToReact;

});
parcelRegister("bjGdd", function(module, exports) {

$parcel$export(module.exports, "default", () => $da85bd2ab17dd79c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $9r347 = parcelRequire("9r347");

var $2ySph = parcelRequire("2ySph");

var $8MzFo = parcelRequire("8MzFo");

var $3kW9T = parcelRequire("3kW9T");
function $da85bd2ab17dd79c$var$CodeBlock(props) {
    const { text: text, language: language, allowCopyToClipboard: allowCopyToClipboard = false, allowWrapCodeBlock: allowWrapCodeBlock = false, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled } = props;
    const codeBidiWarningLabel = props.intl.formatMessage((0, $8MzFo.codeBidiWarningMessages).label);
    const className = [
        (0, $9r347.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER,
        props.className
    ].join(' ');
    const [wrapLongLines, setWrapLongLines] = (0, $5uXOq.useState)(false);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3kW9T.default), {
        allowCopyToClipboard: allowCopyToClipboard,
        allowWrapCodeBlock: allowWrapCodeBlock,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        setWrapLongLines: setWrapLongLines,
        text: text,
        wrapLongLines: wrapLongLines
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2ySph.default), {
        testId: "renderer-code-block",
        language: language,
        text: text,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
        shouldWrapLongLines: allowWrapCodeBlock && wrapLongLines
    }));
}
var $da85bd2ab17dd79c$export$2e2bcd8739ae039 = (0, $8RXs9.default)($da85bd2ab17dd79c$var$CodeBlock);

});
parcelRegister("2ySph", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e7e54ced825739b$export$2e2bcd8739ae039);
/* code-block.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cBeZP = parcelRequire("cBeZP");

var $7nRxN = parcelRequire("7nRxN");

var $4BpJg = parcelRequire("4BpJg");

var $hznOI = parcelRequire("hznOI");

var $7PIrw = parcelRequire("7PIrw");

var $6F3fT = parcelRequire("6F3fT");
const $9e7e54ced825739b$var$getCodeBlockStyles = {
    root: "_2rkoglpi _1dqoglyw _1wyb1crf _k48pi7a9 _1e0c1txw _vwz4gktf _1reo1wug _o572qvpr _1eimjvyg _bfhktkvp _syaz1fxt _ect41odn _1ozdn7od _7xinn7od _t7aun7od _1v15u2gc _ilvcu2gc _m29uu2gc _17wyu2gc _pn28u2gc _gz9fu2gc _1hmyegat _vblregat _vbulegat _wozj1yev _1agb1yev _lkm81yev _tv41hkgb _1hmimyb0 _1ra01n1a _1d4j1y44 _1f8gstnw _1pzyb3bt _j1w0ww7y _13cdh2mm _15ba126e _zvy9f705 _qcxof705 _14y71a66 _j0l11wug _1weckb7n _1na21hna _1xx2grf3 _x7c815vq _lh0y15vq _1m3815vq _qk1e15vq _12l6ysn8 _uga3ysn8 _mx8b7mnp _1kr87mnp _xo19t94y _1bemt94y _nalpstnw _151dstnw _1exb1q9c _1hgu1q9c _1mgnt94y _nhket94y _h909m7j4 _scgayz1z _ipl81e17 _jeky1l04 _1gec1a66 _1gx21e5h _1ls0df4r _vm2c1rh5 _12ok1rh5 _1ls01ule _rude1ule _1q16glyw _1io6glyw _juomusic _lcwuusic _1552u2gc _12afu2gc _28ddu2gc _1i8zu2gc _12tu1a66 _zu0j1a66 _euyxusvi _cahfusvi _zhnuidpf _1amdidpf _mbgcpf9b _bu7zpf9b _131n1giz _gy101giz _1wfuwrk5 _16kzwrk5 _9kk3moej _cjus1w1g _9k2r1m30 _nhmw1m30 _yl021m30 _eiht5x2v _t9zb5x2v _mqok1w1g _3hsg1w1g _i7ngn7od _9wu1fb2s _1xcoh55r _1t361fxt _137bh55r _1k7d1fxt _97lipnps _12nh9lu1 _1g0517qg _i2ig10m5 _326z1fxt _113p131l _1n6tpnps _tgu817qg _1k47pnps _g0lx1fxt _ys4e131l _7gp8h55r _1yvq10m5 _1vww10m5 _1rju10m5 _1v0lh55r _wmyy17qg _748n17qg _1mfn17qg _1d7e17qg _p2vr17qg _19o610m5 _kxov17qg _1np517qg _m2f517qg _1b9tpnps _1tq6pnps _1rd2pnps _1pbkpnps _k3lipnps _13zt131l _2g12fb2s _k86b10m5 _b5iy131l _gti3131l _1f0gpnps _9d3e17qg _qdiapnps _72uvpnps",
    showLineNumbers: "_170714ej _1i3h1txw _1huoidpf _1a9lidpf _20bqidpf _1oggidpf _bympidpf _9nnjidpf",
    dontShowLineNumbers: "_1i3h1ule _1huou2gc _1a9lu2gc _20bqu2gc _1oggu2gc _bympu2gc _9nnju2gc",
    shouldWrapLongLines: "_13dgkb7n",
    dontWrapLongLines: "_13dgkb7n"
};
/**
 * __Code block__
 *
 * A code block highlights an entire block of code and keeps the formatting.
 *
 * - [Examples](https://atlassian.design/components/code/code-block/examples)
 * - [Code](https://atlassian.design/components/code/code-block/code)
 * - [Usage](https://atlassian.design/components/code/code-block/usage)
 */ const $9e7e54ced825739b$var$CodeBlock = /*#__PURE__*/ (0, $5uXOq.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, shouldWrapLongLines: shouldWrapLongLines = false, label: label = 'Scrollable content' }) {
    const scrollableRef = (0, $5uXOq.useRef)(null);
    const [showContentFocus, setShowContentFocus] = (0, $5uXOq.useState)(false);
    const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
    const lineNumberWidth = numLines ? (0, $hznOI.getLineNumWidth)(numLines) : 0;
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $5uXOq.useEffect)(()=>{
        const schedule = (0, $7nRxN.default)(()=>{
            const target = scrollableRef.current;
            target && setShowContentFocus(target.scrollWidth > target.clientWidth);
        });
        schedule();
        const unbindWindowEvent = (0, $cBeZP.bind)(window, {
            type: 'resize',
            listener: schedule
        });
        return unbindWindowEvent;
    }, [
        scrollableRef
    ]);
    const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, $4BpJg.useHighlightLines)({
        highlight: highlight,
        testId: testId
    });
    const getLineProps = (0, $5uXOq.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
        getHighlightStyles,
        highlightedLines
    ]);
    const language = (0, $5uXOq.useMemo)(()=>(0, $7PIrw.normalizeLanguage)(providedLanguage), [
        providedLanguage
    ]);
    // https://product-fabric.atlassian.net/browse/DST-2472
    const languageToUse = text ? language : 'text';
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6F3fT.default), {
        "data-code-lang": language,
        "data-ds--code--code-block": "",
        testId: testId,
        language: languageToUse,
        style: {
            '--ads-code-line-number-width': `calc(${lineNumberWidth} + 16px)`,
            '--ads-highlighted-start-text': highlightedStartText,
            '--ads-highlighted-end-text': highlightedEndText
        },
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber,
        lineProps: getLineProps,
        // shouldCreateParentElementForLines is needed to pass down props to each line.
        // This is necessary for both line highlighting and testId's, as each of
        // these rely on a data attribute being passed down to lines.
        shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
        shouldWrapLongLines: shouldWrapLongLines,
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
        text: text,
        tabIndex: showContentFocus ? '0' : undefined,
        "aria-label": showContentFocus ? label : undefined,
        role: showContentFocus ? 'region' : undefined,
        scrollRef: scrollableRef,
        className: (0, $bwpsq.default)([
            $9e7e54ced825739b$var$getCodeBlockStyles.root,
            shouldWrapLongLines ? $9e7e54ced825739b$var$getCodeBlockStyles.shouldWrapLongLines : $9e7e54ced825739b$var$getCodeBlockStyles.dontWrapLongLines,
            showLineNumbers ? $9e7e54ced825739b$var$getCodeBlockStyles.showLineNumbers : $9e7e54ced825739b$var$getCodeBlockStyles.dontShowLineNumbers
        ])
    });
});
var $9e7e54ced825739b$export$2e2bcd8739ae039 = $9e7e54ced825739b$var$CodeBlock;

});
parcelRegister("4BpJg", function(module, exports) {

$parcel$export(module.exports, "useHighlightLines", () => $7f53800d84dbb853$export$84415a200bdf33ed);

var $5uXOq = parcelRequire("5uXOq");
const $7f53800d84dbb853$var$DEFAULT_LINE_EL_ATTR_OBJ = {
    'data-ds--code--row': ''
};
const $7f53800d84dbb853$var$getLineStyleObject = (lineNumber, testId)=>{
    return testId ? {
        'data-testid': `${testId}-line-${lineNumber}`,
        ...$7f53800d84dbb853$var$DEFAULT_LINE_EL_ATTR_OBJ
    } : $7f53800d84dbb853$var$DEFAULT_LINE_EL_ATTR_OBJ;
};
const $7f53800d84dbb853$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
    const highlightedLines = (0, $5uXOq.useMemo)(()=>{
        if (!highlight) return [];
        return highlight.split(',').map((num)=>{
            if (num.indexOf('-') > 0) {
                // We found a line group, e.g. 1-3
                const [from, to] = num.split('-').map(Number)// Sort by lowest value first, highest value last.
                .sort((a, b)=>a - b);
                return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
            }
            return Number(num);
        }).reduce((acc, val)=>acc.concat(val), []) || [];
    }, [
        highlight
    ]);
    const getHighlightStyles = (0, $5uXOq.useCallback)((lineNumber, highlightedLines)=>{
        if (!highlight || highlightedLines.length === 0) return $7f53800d84dbb853$var$getLineStyleObject(lineNumber, testId);
        if (highlightedLines.includes(lineNumber)) {
            const highlightedDataAttrObj = {
                'data-ds--code--row--highlight': ''
            };
            return {
                ...highlightedDataAttrObj,
                ...$7f53800d84dbb853$var$getLineStyleObject(lineNumber, testId)
            };
        }
        return $7f53800d84dbb853$var$getLineStyleObject(lineNumber, testId);
    }, [
        highlight,
        testId
    ]);
    return {
        getHighlightStyles: getHighlightStyles,
        highlightedLines: highlightedLines
    };
};

});

parcelRegister("hznOI", function(module, exports) {

$parcel$export(module.exports, "getLineNumWidth", () => $15fdbbc6481ecd68$export$cb7aec0206b595d2);
const $15fdbbc6481ecd68$export$cb7aec0206b595d2 = (numLines)=>{
    return !numLines ? '1ch' : `${numLines.toFixed(0).length}ch`;
};

});

parcelRegister("7PIrw", function(module, exports) {

$parcel$export(module.exports, "normalizeLanguage", () => $ca362246ce2683d1$export$f38728011c178796);

var $8QpSo = parcelRequire("8QpSo");

var $hrH4x = parcelRequire("hrH4x");
const $ca362246ce2683d1$export$f38728011c178796 = (0, $8QpSo.default)((language)=>{
    if (!language) return '';
    const match = (0, $hrH4x.SUPPORTED_LANGUAGES).find((val)=>{
        return val.name === language || val.alias.includes(language);
    });
    // Fallback to plain monospaced text if language passed but not supported
    return match ? match.value : 'text';
});

});
parcelRegister("hrH4x", function(module, exports) {

$parcel$export(module.exports, "SUPPORTED_LANGUAGES", () => $d08a76531d004155$export$7c77c3a9bb93870d);
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $d08a76531d004155$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    }
];

});


parcelRegister("6F3fT", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d29f9567ac74ce3$export$2e2bcd8739ae039);
/**
 * Original library: https://github.com/react-syntax-highlighter/react-syntax-highlighter
 * All modifications by Atlassian
 */ /**
 * MIT License
 *
 * Copyright (c) 2019 Conor Hastings
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * __Syntax Highlighter__
 *
 * A syntax highlighter based on top of [refractor](https://github.com/wooorm/refractor).
 * @atlaskit/code uses this under-the-hood, but it is not intended for public consumption.
 * You should be using @atlaskit/code directly.
 */ 
var $c5xJy = parcelRequire("c5xJy");
var $1d29f9567ac74ce3$export$2e2bcd8739ae039 = (0, $c5xJy.default);

});
parcelRegister("c5xJy", function(module, exports) {

$parcel$export(module.exports, "default", () => $09cb7f35b876acc9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6z3CT = parcelRequire("6z3CT");
// Uses the loader method of async bundling
// Instantiates highligher as a singleton, loading refractor only once per page (refractor/prism are singleton modules)
const $09cb7f35b876acc9$var$generator = (options)=>{
    const { loader: loader } = options;
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class AsyncHighlighter extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
        static{
            this.astGenerator = null;
        }
        static{
            this.highlightInstance = (0, $6z3CT.default);
        }
        // Useful in tests
        static preload() {
            return AsyncHighlighter.loadAstGenerator();
        }
        static loadAstGenerator() {
            AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                AsyncHighlighter.astGenerator = astGenerator;
                return astGenerator;
            });
            return AsyncHighlighter.astGeneratorPromise;
        }
        componentDidMount() {
            if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
            if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                this.forceUpdate();
            });
        }
        render() {
            return /*#__PURE__*/ (0, $2OMIu.jsx)(AsyncHighlighter.highlightInstance, {
                ...this.props,
                astGenerator: AsyncHighlighter.astGenerator
            });
        }
    }
    return AsyncHighlighter;
};

const $09cb7f35b876acc9$var$asyncGenerator = $09cb7f35b876acc9$var$generator({
    loader: ()=>(parcelRequire("7UGL1")).then((module)=>{
            // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
            return module.default || module;
        })
});
var $09cb7f35b876acc9$export$2e2bcd8739ae039 = $09cb7f35b876acc9$var$asyncGenerator;

});
parcelRegister("6z3CT", function(module, exports) {

$parcel$export(module.exports, "default", () => $64d2f55138e56e0f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2xWXR = parcelRequire("2xWXR");

var $Ln73j = parcelRequire("Ln73j");
/**
 * Takes in a code string and (in the default behaviour):
 * - Uses refractor to turn it into a tree structure with highlighting metadata
 * - Collapses this tree into lines for a renderer
 * - Passes these lines to a React renderer
 *
 * In future, the final step could have a custom renderer.
 */ const $64d2f55138e56e0f$var$Highlight = /*#__PURE__*/ (0, $5uXOq.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
    className: `language-${language}`
}, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
    // TODO maybe we call this code or text everywhere; for now we match the API in
    // @atlaskit/codeblock
    const code = text;
    const generatorClassName = 'prismjs';
    const containerProps = {
        ...rest,
        ref: rest.scrollRef,
        'data-testid': testId,
        className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
    };
    if (containerProps.hasOwnProperty('scrollRef')) delete containerProps['scrollRef'];
    if (shouldWrapLongLines) codeTagProps.style = {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
    };
    else codeTagProps.style = {
        whiteSpace: 'pre'
    };
    const codeBidiWarningConfig = {
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    };
    // Tree + logic into rows
    const rows = (0, $2xWXR.default)({
        astGenerator: astGenerator,
        code: code,
        language: language,
        shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
        lineProps: lineProps,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber
    });
    // Rows + logic into a renderer
    return (0, $Ln73j.default)({
        containerProps: containerProps,
        codeTagProps: codeTagProps,
        rows: rows,
        codeBidiWarningConfig: codeBidiWarningConfig
    });
});
var $64d2f55138e56e0f$export$2e2bcd8739ae039 = $64d2f55138e56e0f$var$Highlight;

});
parcelRegister("2xWXR", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc5147079d8cf249$export$2e2bcd8739ae039);

var $8UEbV = parcelRequire("8UEbV");

var $4xv0L = parcelRequire("4xv0L");

var $lr39k = parcelRequire("lr39k");

var $2XA2b = parcelRequire("2XA2b");
const $cc5147079d8cf249$var$newLineRegex = /\n/g;
function $cc5147079d8cf249$var$getNewLines(str) {
    return str.match($cc5147079d8cf249$var$newLineRegex);
}
function $cc5147079d8cf249$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
    const codeTree = (0, $2XA2b.default)(language, code, astGenerator);
    const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
    const createLine = (0, $8UEbV.default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
    const newTree = [];
    let lastLineBreakIndex = -1;
    let index = 0;
    // Seems odd we flatten the tree immediately - what work could we do on it more performantly than on the lines?
    const tree = (0, $lr39k.default)(codeTree);
    while(index < tree.length){
        const testNode = tree[index];
        if (testNode.type === 'text') {
            index++;
            continue;
        }
        const node = testNode;
        const firstChildNode = node.children[0];
        if (firstChildNode.type === 'text') {
            const { value: value } = firstChildNode;
            const newLines = $cc5147079d8cf249$var$getNewLines(value);
            if (newLines) {
                const splitValue = value.split('\n');
                splitValue.forEach((text, i)=>{
                    const lineNumber = newTree.length + startingLineNumber;
                    const newChild = {
                        type: 'text',
                        value: `${text}\n`
                    };
                    // if it's the first line
                    if (i === 0) {
                        const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, $4xv0L.default)({
                            children: [
                                newChild
                            ],
                            className: node.properties.className,
                            lineNumber: lineNumber
                        }));
                        const line = createLine(children, lineNumber);
                        newTree.push(line);
                    // if it's the last line
                    } else if (i === splitValue.length - 1) {
                        const nextNode = tree[index + 1];
                        const stringChild = nextNode && nextNode.children && nextNode.children[0];
                        // Similar to newChild above, but no newline
                        const lastLineInPreviousSpan = {
                            type: 'text',
                            value: `${text}`
                        };
                        if (stringChild) {
                            const newElem = (0, $4xv0L.default)({
                                children: [
                                    lastLineInPreviousSpan
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            });
                            tree.splice(index + 1, 0, newElem);
                        } else {
                            const children = [
                                lastLineInPreviousSpan
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    // if it's neither the first nor the last line
                    } else {
                        const children = [
                            newChild
                        ];
                        const line = createLine(children, lineNumber, node.properties.className);
                        newTree.push(line);
                    }
                });
                lastLineBreakIndex = index;
            }
        }
        index++;
    }
    if (lastLineBreakIndex !== tree.length - 1) {
        const children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            const lineNumber = newTree.length + startingLineNumber;
            const line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    if (shouldCreateParentElementForLines) return newTree;
    // If shouldCreateParentElementForLines was off, we still have a tree structure we need to flatten
    // We have (RefractorNode | RefractorNode[])[] but need RefractorNode[]
    // This seems like a code smell to review
    return newTree.flat(1);
}

});
parcelRegister("8UEbV", function(module, exports) {

$parcel$export(module.exports, "default", () => $918b588591c0d527$export$2e2bcd8739ae039);

var $4xv0L = parcelRequire("4xv0L");

var $7oEaO = parcelRequire("7oEaO");
function $918b588591c0d527$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
    return (children, lineNumber, className = [])=>{
        // Needed for more complex line creation
        if (shouldCreateParentElementForLines || className.length > 0) return (0, $4xv0L.default)({
            children: children,
            lineNumber: lineNumber,
            showLineNumbers: showLineNumbers,
            lineProps: lineProps,
            className: className
        });
        else {
            // Simple line creation without the bells and whistles
            if (showLineNumbers && lineNumber) children.unshift((0, $7oEaO.default)(lineNumber));
            return children;
        }
    };
}
var $918b588591c0d527$export$2e2bcd8739ae039 = $918b588591c0d527$var$createLineGenerator;

});
parcelRegister("4xv0L", function(module, exports) {

$parcel$export(module.exports, "default", () => $400cccfb64235f13$export$2e2bcd8739ae039);

var $7oEaO = parcelRequire("7oEaO");
function $400cccfb64235f13$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
    const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
    const properties = {
        ...propsPassedInFromCodeBlock,
        className: className
    };
    let currentChildren = children;
    if (lineNumber && showLineNumbers) {
        // When syntax highlighting is NOT turned on, the entire LOC is just a single
        // child. We can then happily create the line number and the LOC as siblings...
        if (currentChildren.length === 1) currentChildren = [
            (0, $7oEaO.default)(lineNumber),
            ...currentChildren
        ];
        else // ... However, when syntax highlighting IS on, a span is created for each
        // tokenised node in the AST (eg. <span>import</span><span>React</span>).
        // When shouldWrapLongLines is true, the row becomes `display: flex` and
        // forces all its children to be equal height. This can be a source of
        // visual bugs where a LOC is broken up weirdly into segments.
        //
        //  +---------------------------------------+
        //  | row                                   |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  |  |line| |key    | |keywords| |key   | |
        //  |  |no. | |word   | |        | |word  | |
        //  |  |    | |       | |        | |      | |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  +---------------------------------------+
        //
        // Nesting the children one layer deeper (i.e. creating an extra span)
        // ensures that the line number and the ENTIRE line of code are aligned by
        // the parent flexbox (the row).
        //
        //  +---------------------------------------------+
        //  | row                                         |
        //  | +----+  +--------------------------------+  |
        //  | |line|  | extra span we are creating     |  |
        //  | |no. |  |  +-------+ +--------+ +------+ |  |
        //  | |    |  |  |key    | |keywords| |key   | |  |
        //  | |    |  |  |word   | |        | |word  | |  |
        //  | |    |  |  |       | |        | |      | |  |
        //  | |    |  |  +-------+ +--------+ +------+ |  |
        //  | +----+  +--------------------------------+  |
        //  +---------------------------------------------+
        //
        currentChildren = [
            (0, $7oEaO.default)(lineNumber),
            {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: []
                },
                children: currentChildren
            }
        ];
    }
    return {
        type: 'element',
        tagName: 'span',
        properties: properties,
        children: currentChildren
    };
}

});
parcelRegister("7oEaO", function(module, exports) {

$parcel$export(module.exports, "default", () => $15150bf13d425416$export$2e2bcd8739ae039);
function $15150bf13d425416$export$2e2bcd8739ae039(lineNumber) {
    return {
        type: 'element',
        tagName: 'span',
        properties: {
            key: `line-number--${lineNumber}`,
            className: [
                'comment',
                'linenumber',
                'ds-line-number'
            ],
            // We're placing the lineNumber in a data-attr on an empty span (hence the
            // empty children array below). This allows CodeBlock to use CSS to
            // generate the content in a pseudo-element, which is a fix for a bug
            // where line numbers were being copied (CSS content can't be copied)
            // https://product-fabric.atlassian.net/browse/DSP-2729
            'data-ds--line-number': lineNumber
        },
        children: []
    };
}

});



parcelRegister("lr39k", function(module, exports) {

$parcel$export(module.exports, "default", () => $499c34f72d4f8fe9$export$2e2bcd8739ae039);

var $4xv0L = parcelRequire("4xv0L");
function $499c34f72d4f8fe9$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
    let newTree = [];
    for(let i = 0; i < tree.length; i++){
        const node = tree[i];
        if (node.type === 'text') newTree.push((0, $4xv0L.default)({
            children: [
                node
            ],
            lineNumber: offset,
            className: className
        }));
        else if (node.children) {
            const classNames = className.concat(node.properties.className || []);
            $499c34f72d4f8fe9$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
        }
    }
    return newTree;
}

});

parcelRegister("2XA2b", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc823adabbc5d375$export$2e2bcd8739ae039);
function $cc823adabbc5d375$export$2e2bcd8739ae039(language, code, astGenerator) {
    if (language === 'text' || !astGenerator) return [
        {
            type: 'text',
            value: code
        }
    ];
    try {
        return astGenerator.highlight(code, language);
    } catch (e) {
        return [
            {
                type: 'text',
                value: code
            }
        ];
    }
}

});


parcelRegister("Ln73j", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c696bea45e3d494$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $lYxWw = parcelRequire("lYxWw");
function $1c696bea45e3d494$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
    const renderedRows = rows.map((node, i)=>(0, $lYxWw.default)({
            node: node,
            codeBidiWarningConfig: codeBidiWarningConfig,
            key: `code-segment${i}`
        }));
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...containerProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("code", {
            ...codeTagProps,
            children: renderedRows
        })
    });
}

});
parcelRegister("lYxWw", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c0e2a43de708c87$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $aaGb5 = parcelRequire("aaGb5");

var $fS4SY = parcelRequire("fS4SY");

var $4dfgq = parcelRequire("4dfgq");
function $9c0e2a43de708c87$var$createClassNameString(classNames) {
    return classNames ? classNames.join(' ') : '';
}
function $9c0e2a43de708c87$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
    if (node.type === 'text') {
        const { value: value } = node;
        // occasionally a numeric value is passed when the type is text
        const textValue = `${value}`;
        if (codeBidiWarningConfig.codeBidiWarnings) {
            const decorated = (0, $fS4SY.default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $aaGb5.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningConfig.codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        return textValue;
    } else {
        const { properties: properties, tagName: tagName } = node;
        const childrenCreator = (0, $4dfgq.default)(codeBidiWarningConfig);
        const props = {
            ...properties,
            className: $9c0e2a43de708c87$var$createClassNameString(properties.className)
        };
        const children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(tagName, {
            key: key,
            ...props
        }, children);
    }
}

});
parcelRegister("4dfgq", function(module, exports) {

$parcel$export(module.exports, "default", () => $07b0ea1324f366d8$export$2e2bcd8739ae039);

var $lYxWw = parcelRequire("lYxWw");
function $07b0ea1324f366d8$export$2e2bcd8739ae039(codeBidiWarningConfig) {
    let childrenCount = 0;
    return (children)=>{
        childrenCount += 1;
        return children.map((child, i)=>(0, $lYxWw.default)({
                node: child,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment-${childrenCount}-${i}`
            }));
    };
}

});




parcelRegister("7UGL1", function(module, exports) {

let $5c2eee132ac8edb3$var$load = (parcelRequire("loK1v"))(4);
module.exports = $5c2eee132ac8edb3$var$load("6bPZj").then(()=>parcelRequire('5zvIl'));

});




parcelRegister("3kW9T", function(module, exports) {

$parcel$export(module.exports, "default", () => $78e20e4231d93416$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");


var $9r347 = parcelRequire("9r347");

var $a1mC1 = parcelRequire("a1mC1");
const $78e20e4231d93416$var$codeBlockStyleOverrides = /*#__PURE__*/ (0, $f8Sb3.css)({
    tabSize: 4,
    backgroundColor: `var(--ds-surface-raised, ${(0, $dbda9f692ace54dd$export$9fdfb749e33cdf97)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    button: {
        opacity: 0,
        transition: 'opacity 0.2s ease 0s'
    },
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        button: {
            opacity: 1
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`${(0, $9r347.CodeBlockSharedCssClassName).DS_CODEBLOCK}`]: {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${0.875}rem`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '1.5rem',
        backgroundImage: `linear-gradient(
			to right,
			${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-300, 24px)"},
			transparent ${"var(--ds-space-300, 24px)"}
			),linear-gradient(
			to right,
			${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
			transparent ${"var(--ds-space-300, 24px)"}
			),linear-gradient(
			to left,
			${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-100, 8px)"},
			transparent ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to left,
			${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
			transparent ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to left,
			${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to left,
			${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to right,
			${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to right,
			${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			)`,
        backgroundAttachment: 'local, local, local, local, scroll, scroll, scroll, scroll',
        backgroundPosition: '0 0, 0 0, 100% 0, 100% 0, 100% 0, 100% 0, 0 0, 0 0'
    }
});
const $78e20e4231d93416$var$CodeBlockContainer = ({ allowCopyToClipboard: allowCopyToClipboard, allowWrapCodeBlock: allowWrapCodeBlock, children: children, className: className, setWrapLongLines: setWrapLongLines, text: text, wrapLongLines: wrapLongLines })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        css: $78e20e4231d93416$var$codeBlockStyleOverrides
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $a1mC1.default), {
        allowCopyToClipboard: allowCopyToClipboard,
        allowWrapCodeBlock: allowWrapCodeBlock,
        setWrapLongLines: setWrapLongLines,
        text: text,
        wrapLongLines: wrapLongLines
    }), children);
};
var $78e20e4231d93416$export$2e2bcd8739ae039 = $78e20e4231d93416$var$CodeBlockContainer;

});
var $dbda9f692ace54dd$exports = {};

$parcel$export($dbda9f692ace54dd$exports, "R50", () => $dbda9f692ace54dd$export$4b84fd0e2c617bd);
$parcel$export($dbda9f692ace54dd$exports, "R75", () => $dbda9f692ace54dd$export$b34b069eff244586);
$parcel$export($dbda9f692ace54dd$exports, "R100", () => $dbda9f692ace54dd$export$be802dd0d8b57f35);
$parcel$export($dbda9f692ace54dd$exports, "R200", () => $dbda9f692ace54dd$export$60847d42f9da92a6);
$parcel$export($dbda9f692ace54dd$exports, "R300", () => $dbda9f692ace54dd$export$4a7404f376229999);
$parcel$export($dbda9f692ace54dd$exports, "R400", () => $dbda9f692ace54dd$export$2010d0fb4295b346);
$parcel$export($dbda9f692ace54dd$exports, "R500", () => $dbda9f692ace54dd$export$2837b5a1a71d5c02);
$parcel$export($dbda9f692ace54dd$exports, "Y50", () => $dbda9f692ace54dd$export$8d9596b529bbb9cf);
$parcel$export($dbda9f692ace54dd$exports, "Y75", () => $dbda9f692ace54dd$export$41060a744ab0b7ae);
$parcel$export($dbda9f692ace54dd$exports, "Y100", () => $dbda9f692ace54dd$export$1cc05bbbf340e559);
$parcel$export($dbda9f692ace54dd$exports, "Y200", () => $dbda9f692ace54dd$export$5aae31392d72caaa);
$parcel$export($dbda9f692ace54dd$exports, "Y300", () => $dbda9f692ace54dd$export$c6930421db9fa514);
$parcel$export($dbda9f692ace54dd$exports, "Y400", () => $dbda9f692ace54dd$export$59619663aa6500fb);
$parcel$export($dbda9f692ace54dd$exports, "Y500", () => $dbda9f692ace54dd$export$874739ea9e379ab6);
$parcel$export($dbda9f692ace54dd$exports, "G50", () => $dbda9f692ace54dd$export$8a6341c32b6a3ee6);
$parcel$export($dbda9f692ace54dd$exports, "G75", () => $dbda9f692ace54dd$export$69a3bf21b9686c2b);
$parcel$export($dbda9f692ace54dd$exports, "G100", () => $dbda9f692ace54dd$export$afbce1382ec95f73);
$parcel$export($dbda9f692ace54dd$exports, "G200", () => $dbda9f692ace54dd$export$747d86715d4175de);
$parcel$export($dbda9f692ace54dd$exports, "G300", () => $dbda9f692ace54dd$export$940e1f69e873f202);
$parcel$export($dbda9f692ace54dd$exports, "G400", () => $dbda9f692ace54dd$export$a49394138f7b8e85);
$parcel$export($dbda9f692ace54dd$exports, "G500", () => $dbda9f692ace54dd$export$6fa04827ac68a4fb);
$parcel$export($dbda9f692ace54dd$exports, "B50", () => $dbda9f692ace54dd$export$226de0355ed012f8);
$parcel$export($dbda9f692ace54dd$exports, "B75", () => $dbda9f692ace54dd$export$8c13c2ee36917869);
$parcel$export($dbda9f692ace54dd$exports, "B100", () => $dbda9f692ace54dd$export$ecfc1dff386a3e7a);
$parcel$export($dbda9f692ace54dd$exports, "B200", () => $dbda9f692ace54dd$export$215b7063051591f1);
$parcel$export($dbda9f692ace54dd$exports, "B300", () => $dbda9f692ace54dd$export$e62e8919cca44969);
$parcel$export($dbda9f692ace54dd$exports, "B400", () => $dbda9f692ace54dd$export$b3de0ae08da2ce64);
$parcel$export($dbda9f692ace54dd$exports, "B500", () => $dbda9f692ace54dd$export$a6ee3d71bc067634);
$parcel$export($dbda9f692ace54dd$exports, "B600", () => $dbda9f692ace54dd$export$67f15409e87642a1);
$parcel$export($dbda9f692ace54dd$exports, "B700", () => $dbda9f692ace54dd$export$f0539dbc42dbb067);
$parcel$export($dbda9f692ace54dd$exports, "P50", () => $dbda9f692ace54dd$export$363e4475840015bb);
$parcel$export($dbda9f692ace54dd$exports, "P75", () => $dbda9f692ace54dd$export$4b0a4417ed59760f);
$parcel$export($dbda9f692ace54dd$exports, "P100", () => $dbda9f692ace54dd$export$6011520a64d9a187);
$parcel$export($dbda9f692ace54dd$exports, "P200", () => $dbda9f692ace54dd$export$a7175d4e9206bc80);
$parcel$export($dbda9f692ace54dd$exports, "P300", () => $dbda9f692ace54dd$export$b48405b95304b5a1);
$parcel$export($dbda9f692ace54dd$exports, "P400", () => $dbda9f692ace54dd$export$c71e4279dd54a18d);
$parcel$export($dbda9f692ace54dd$exports, "P500", () => $dbda9f692ace54dd$export$147899de772240ec);
$parcel$export($dbda9f692ace54dd$exports, "T50", () => $dbda9f692ace54dd$export$2cf711fe14c66f06);
$parcel$export($dbda9f692ace54dd$exports, "T75", () => $dbda9f692ace54dd$export$7a8f4d33f6f9772c);
$parcel$export($dbda9f692ace54dd$exports, "T100", () => $dbda9f692ace54dd$export$776c9c497ef08533);
$parcel$export($dbda9f692ace54dd$exports, "T200", () => $dbda9f692ace54dd$export$69cb3ca10c1e330e);
$parcel$export($dbda9f692ace54dd$exports, "T300", () => $dbda9f692ace54dd$export$9dc1ef0f3f48059b);
$parcel$export($dbda9f692ace54dd$exports, "T400", () => $dbda9f692ace54dd$export$7c835c78b6fcdef8);
$parcel$export($dbda9f692ace54dd$exports, "T500", () => $dbda9f692ace54dd$export$6036577f95c3877e);
$parcel$export($dbda9f692ace54dd$exports, "N0", () => $dbda9f692ace54dd$export$29a4f05edc054374);
$parcel$export($dbda9f692ace54dd$exports, "N10", () => $dbda9f692ace54dd$export$e655ef011c4aa1a2);
$parcel$export($dbda9f692ace54dd$exports, "N20", () => $dbda9f692ace54dd$export$9fdfb749e33cdf97);
$parcel$export($dbda9f692ace54dd$exports, "N30", () => $dbda9f692ace54dd$export$3e51e8f1440314ba);
$parcel$export($dbda9f692ace54dd$exports, "N40", () => $dbda9f692ace54dd$export$1ce2d1575d444ceb);
$parcel$export($dbda9f692ace54dd$exports, "N50", () => $dbda9f692ace54dd$export$8754fc7e6d8b3000);
$parcel$export($dbda9f692ace54dd$exports, "N60", () => $dbda9f692ace54dd$export$c2e91cbeada39b8b);
$parcel$export($dbda9f692ace54dd$exports, "N70", () => $dbda9f692ace54dd$export$5f71e19f3a7ad9de);
$parcel$export($dbda9f692ace54dd$exports, "N80", () => $dbda9f692ace54dd$export$eaa8c8a70ac22806);
$parcel$export($dbda9f692ace54dd$exports, "N90", () => $dbda9f692ace54dd$export$7c87d337fb91a97d);
$parcel$export($dbda9f692ace54dd$exports, "N100", () => $dbda9f692ace54dd$export$d6447c357493214f);
$parcel$export($dbda9f692ace54dd$exports, "N200", () => $dbda9f692ace54dd$export$f563ee71e9ee74cd);
$parcel$export($dbda9f692ace54dd$exports, "N300", () => $dbda9f692ace54dd$export$e2ef2124cf4024b1);
$parcel$export($dbda9f692ace54dd$exports, "N400", () => $dbda9f692ace54dd$export$eece5f492e429f08);
$parcel$export($dbda9f692ace54dd$exports, "N500", () => $dbda9f692ace54dd$export$c39c0fe0f26207ae);
$parcel$export($dbda9f692ace54dd$exports, "N600", () => $dbda9f692ace54dd$export$7090862dc3038a9f);
$parcel$export($dbda9f692ace54dd$exports, "N700", () => $dbda9f692ace54dd$export$ad0bacf983b7ddaa);
$parcel$export($dbda9f692ace54dd$exports, "N800", () => $dbda9f692ace54dd$export$7d61b15e0da132af);
$parcel$export($dbda9f692ace54dd$exports, "N900", () => $dbda9f692ace54dd$export$fbda843f0a27fe96);
$parcel$export($dbda9f692ace54dd$exports, "N10A", () => $dbda9f692ace54dd$export$791e57b27ca738ef);
$parcel$export($dbda9f692ace54dd$exports, "N20A", () => $dbda9f692ace54dd$export$8d43898f60b96a82);
$parcel$export($dbda9f692ace54dd$exports, "N30A", () => $dbda9f692ace54dd$export$920c0d5c49070351);
$parcel$export($dbda9f692ace54dd$exports, "N40A", () => $dbda9f692ace54dd$export$46987b49aab6d1a8);
$parcel$export($dbda9f692ace54dd$exports, "N50A", () => $dbda9f692ace54dd$export$7d3359664e8bb0e5);
$parcel$export($dbda9f692ace54dd$exports, "N60A", () => $dbda9f692ace54dd$export$d2d3bedfb276cac0);
$parcel$export($dbda9f692ace54dd$exports, "N70A", () => $dbda9f692ace54dd$export$6e5e7499ff054f6d);
$parcel$export($dbda9f692ace54dd$exports, "N80A", () => $dbda9f692ace54dd$export$59264b346c877fa7);
$parcel$export($dbda9f692ace54dd$exports, "N90A", () => $dbda9f692ace54dd$export$d092757d7c64925c);
$parcel$export($dbda9f692ace54dd$exports, "N100A", () => $dbda9f692ace54dd$export$486ab785e4bac3c6);
$parcel$export($dbda9f692ace54dd$exports, "N200A", () => $dbda9f692ace54dd$export$fba592bbc6419fea);
$parcel$export($dbda9f692ace54dd$exports, "N300A", () => $dbda9f692ace54dd$export$13609db0e6812ab8);
$parcel$export($dbda9f692ace54dd$exports, "N400A", () => $dbda9f692ace54dd$export$fbae4efaa892d883);
$parcel$export($dbda9f692ace54dd$exports, "N500A", () => $dbda9f692ace54dd$export$f13946d26f440ce6);
$parcel$export($dbda9f692ace54dd$exports, "N600A", () => $dbda9f692ace54dd$export$19f58225ac52a306);
$parcel$export($dbda9f692ace54dd$exports, "N700A", () => $dbda9f692ace54dd$export$6384f09da70e7b62);
$parcel$export($dbda9f692ace54dd$exports, "N800A", () => $dbda9f692ace54dd$export$d0dccc730683edc2);
$parcel$export($dbda9f692ace54dd$exports, "DN900", () => $dbda9f692ace54dd$export$2f6319cf7d736c2a);
$parcel$export($dbda9f692ace54dd$exports, "DN800", () => $dbda9f692ace54dd$export$95126bc8884d6634);
$parcel$export($dbda9f692ace54dd$exports, "DN700", () => $dbda9f692ace54dd$export$8338d8c35d44ff1);
$parcel$export($dbda9f692ace54dd$exports, "DN600", () => $dbda9f692ace54dd$export$5368d76ae4fbbda7);
$parcel$export($dbda9f692ace54dd$exports, "DN500", () => $dbda9f692ace54dd$export$9f0a771d16ec8d36);
$parcel$export($dbda9f692ace54dd$exports, "DN400", () => $dbda9f692ace54dd$export$abcf8c38338b4aa5);
$parcel$export($dbda9f692ace54dd$exports, "DN300", () => $dbda9f692ace54dd$export$97e81faa16a182c7);
$parcel$export($dbda9f692ace54dd$exports, "DN200", () => $dbda9f692ace54dd$export$bfe21c59123ecf33);
$parcel$export($dbda9f692ace54dd$exports, "DN100", () => $dbda9f692ace54dd$export$ee82aa2ea6a1558);
$parcel$export($dbda9f692ace54dd$exports, "DN90", () => $dbda9f692ace54dd$export$682927c6ed76be02);
$parcel$export($dbda9f692ace54dd$exports, "DN80", () => $dbda9f692ace54dd$export$91fd9994c5be9757);
$parcel$export($dbda9f692ace54dd$exports, "DN70", () => $dbda9f692ace54dd$export$d281fbfe3cff2df6);
$parcel$export($dbda9f692ace54dd$exports, "DN60", () => $dbda9f692ace54dd$export$3902c91d8b98a753);
$parcel$export($dbda9f692ace54dd$exports, "DN50", () => $dbda9f692ace54dd$export$8e8133c1ba5845b5);
$parcel$export($dbda9f692ace54dd$exports, "DN40", () => $dbda9f692ace54dd$export$33ff357f6620b39);
$parcel$export($dbda9f692ace54dd$exports, "DN30", () => $dbda9f692ace54dd$export$633847cf062b69e0);
$parcel$export($dbda9f692ace54dd$exports, "DN20", () => $dbda9f692ace54dd$export$9776a6e503bdbf76);
$parcel$export($dbda9f692ace54dd$exports, "DN10", () => $dbda9f692ace54dd$export$6c813d5160dff5db);
$parcel$export($dbda9f692ace54dd$exports, "DN0", () => $dbda9f692ace54dd$export$3d4f271a500072a);
$parcel$export($dbda9f692ace54dd$exports, "DN800A", () => $dbda9f692ace54dd$export$fe151285c22759ec);
$parcel$export($dbda9f692ace54dd$exports, "DN700A", () => $dbda9f692ace54dd$export$a101c6190d0da34);
$parcel$export($dbda9f692ace54dd$exports, "DN600A", () => $dbda9f692ace54dd$export$4b16f52932fda51);
$parcel$export($dbda9f692ace54dd$exports, "DN500A", () => $dbda9f692ace54dd$export$a74bcd7b9845b0d8);
$parcel$export($dbda9f692ace54dd$exports, "DN400A", () => $dbda9f692ace54dd$export$9209c179316d1751);
$parcel$export($dbda9f692ace54dd$exports, "DN300A", () => $dbda9f692ace54dd$export$88f55133f636c8dd);
$parcel$export($dbda9f692ace54dd$exports, "DN200A", () => $dbda9f692ace54dd$export$51126f85d1009512);
$parcel$export($dbda9f692ace54dd$exports, "DN100A", () => $dbda9f692ace54dd$export$a069b547bd23af78);
$parcel$export($dbda9f692ace54dd$exports, "DN90A", () => $dbda9f692ace54dd$export$40cce05af3b2600a);
$parcel$export($dbda9f692ace54dd$exports, "DN80A", () => $dbda9f692ace54dd$export$b78942185925a0d);
$parcel$export($dbda9f692ace54dd$exports, "DN70A", () => $dbda9f692ace54dd$export$e058fb44b8eaafca);
$parcel$export($dbda9f692ace54dd$exports, "DN60A", () => $dbda9f692ace54dd$export$92b0b8de26920c18);
$parcel$export($dbda9f692ace54dd$exports, "DN50A", () => $dbda9f692ace54dd$export$67564f7459d3fc9e);
$parcel$export($dbda9f692ace54dd$exports, "DN40A", () => $dbda9f692ace54dd$export$77868e1ca884ffa3);
$parcel$export($dbda9f692ace54dd$exports, "DN30A", () => $dbda9f692ace54dd$export$2afd71d7d3ea2cd5);
$parcel$export($dbda9f692ace54dd$exports, "DN20A", () => $dbda9f692ace54dd$export$f2a0acaab9972c70);
$parcel$export($dbda9f692ace54dd$exports, "DN10A", () => $dbda9f692ace54dd$export$9ab70e67d6475361);
$parcel$export($dbda9f692ace54dd$exports, "T30", () => $dbda9f692ace54dd$export$d2adc5dedf09fced);
$parcel$export($dbda9f692ace54dd$exports, "L50", () => $dbda9f692ace54dd$export$f51762073d2bb381);
$parcel$export($dbda9f692ace54dd$exports, "L75", () => $dbda9f692ace54dd$export$95e26d54def96891);
// Reds
const $dbda9f692ace54dd$export$4b84fd0e2c617bd = '#FFEBE6';
const $dbda9f692ace54dd$export$b34b069eff244586 = '#FFBDAD';
const $dbda9f692ace54dd$export$be802dd0d8b57f35 = '#FF8F73';
const $dbda9f692ace54dd$export$60847d42f9da92a6 = '#FF7452';
const $dbda9f692ace54dd$export$4a7404f376229999 = '#FF5630';
const $dbda9f692ace54dd$export$2010d0fb4295b346 = '#DE350B';
const $dbda9f692ace54dd$export$2837b5a1a71d5c02 = '#BF2600';
const $dbda9f692ace54dd$export$8d9596b529bbb9cf = '#FFFAE6';
const $dbda9f692ace54dd$export$41060a744ab0b7ae = '#FFF0B3';
const $dbda9f692ace54dd$export$1cc05bbbf340e559 = '#FFE380';
const $dbda9f692ace54dd$export$5aae31392d72caaa = '#FFC400';
const $dbda9f692ace54dd$export$c6930421db9fa514 = '#FFAB00';
const $dbda9f692ace54dd$export$59619663aa6500fb = '#FF991F';
const $dbda9f692ace54dd$export$874739ea9e379ab6 = '#FF8B00';
const $dbda9f692ace54dd$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $dbda9f692ace54dd$export$69a3bf21b9686c2b = '#ABF5D1';
const $dbda9f692ace54dd$export$afbce1382ec95f73 = '#79F2C0';
const $dbda9f692ace54dd$export$747d86715d4175de = '#57D9A3';
const $dbda9f692ace54dd$export$940e1f69e873f202 = '#36B37E';
const $dbda9f692ace54dd$export$a49394138f7b8e85 = '#00875A';
const $dbda9f692ace54dd$export$6fa04827ac68a4fb = '#006644';
const $dbda9f692ace54dd$export$226de0355ed012f8 = '#DEEBFF';
const $dbda9f692ace54dd$export$8c13c2ee36917869 = '#B3D4FF';
const $dbda9f692ace54dd$export$ecfc1dff386a3e7a = '#4C9AFF';
const $dbda9f692ace54dd$export$215b7063051591f1 = '#2684FF';
const $dbda9f692ace54dd$export$e62e8919cca44969 = '#0065FF';
const $dbda9f692ace54dd$export$b3de0ae08da2ce64 = '#0052CC';
const $dbda9f692ace54dd$export$a6ee3d71bc067634 = '#0747A6';
const $dbda9f692ace54dd$export$67f15409e87642a1 = '#669DF1';
const $dbda9f692ace54dd$export$f0539dbc42dbb067 = '#8FB8F6';
const $dbda9f692ace54dd$export$363e4475840015bb = '#EAE6FF';
const $dbda9f692ace54dd$export$4b0a4417ed59760f = '#C0B6F2';
const $dbda9f692ace54dd$export$6011520a64d9a187 = '#998DD9';
const $dbda9f692ace54dd$export$a7175d4e9206bc80 = '#8777D9';
const $dbda9f692ace54dd$export$b48405b95304b5a1 = '#6554C0';
const $dbda9f692ace54dd$export$c71e4279dd54a18d = '#5243AA';
const $dbda9f692ace54dd$export$147899de772240ec = '#403294';
const $dbda9f692ace54dd$export$2cf711fe14c66f06 = '#E6FCFF';
const $dbda9f692ace54dd$export$7a8f4d33f6f9772c = '#B3F5FF';
const $dbda9f692ace54dd$export$776c9c497ef08533 = '#79E2F2';
const $dbda9f692ace54dd$export$69cb3ca10c1e330e = '#00C7E6';
const $dbda9f692ace54dd$export$9dc1ef0f3f48059b = '#00B8D9';
const $dbda9f692ace54dd$export$7c835c78b6fcdef8 = '#00A3BF';
const $dbda9f692ace54dd$export$6036577f95c3877e = '#008DA6';
const $dbda9f692ace54dd$export$29a4f05edc054374 = '#FFFFFF';
const $dbda9f692ace54dd$export$e655ef011c4aa1a2 = '#FAFBFC';
const $dbda9f692ace54dd$export$9fdfb749e33cdf97 = '#F4F5F7';
const $dbda9f692ace54dd$export$3e51e8f1440314ba = '#EBECF0';
const $dbda9f692ace54dd$export$1ce2d1575d444ceb = '#DFE1E6';
const $dbda9f692ace54dd$export$8754fc7e6d8b3000 = '#C1C7D0';
const $dbda9f692ace54dd$export$c2e91cbeada39b8b = '#B3BAC5';
const $dbda9f692ace54dd$export$5f71e19f3a7ad9de = '#A5ADBA';
const $dbda9f692ace54dd$export$eaa8c8a70ac22806 = '#97A0AF';
const $dbda9f692ace54dd$export$7c87d337fb91a97d = '#8993A4';
const $dbda9f692ace54dd$export$d6447c357493214f = '#7A869A';
const $dbda9f692ace54dd$export$f563ee71e9ee74cd = '#6B778C';
const $dbda9f692ace54dd$export$e2ef2124cf4024b1 = '#5E6C84';
const $dbda9f692ace54dd$export$eece5f492e429f08 = '#505F79';
const $dbda9f692ace54dd$export$c39c0fe0f26207ae = '#42526E';
const $dbda9f692ace54dd$export$7090862dc3038a9f = '#344563';
const $dbda9f692ace54dd$export$ad0bacf983b7ddaa = '#253858';
const $dbda9f692ace54dd$export$7d61b15e0da132af = '#172B4D';
const $dbda9f692ace54dd$export$fbda843f0a27fe96 = '#091E42';
const $dbda9f692ace54dd$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $dbda9f692ace54dd$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $dbda9f692ace54dd$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $dbda9f692ace54dd$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $dbda9f692ace54dd$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $dbda9f692ace54dd$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $dbda9f692ace54dd$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $dbda9f692ace54dd$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $dbda9f692ace54dd$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $dbda9f692ace54dd$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $dbda9f692ace54dd$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $dbda9f692ace54dd$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $dbda9f692ace54dd$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $dbda9f692ace54dd$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $dbda9f692ace54dd$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $dbda9f692ace54dd$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $dbda9f692ace54dd$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $dbda9f692ace54dd$export$2f6319cf7d736c2a = '#E6EDFA';
const $dbda9f692ace54dd$export$95126bc8884d6634 = '#DCE5F5';
const $dbda9f692ace54dd$export$8338d8c35d44ff1 = '#CED9EB';
const $dbda9f692ace54dd$export$5368d76ae4fbbda7 = '#B8C7E0';
const $dbda9f692ace54dd$export$9f0a771d16ec8d36 = '#ABBBD6';
const $dbda9f692ace54dd$export$abcf8c38338b4aa5 = '#9FB0CC';
const $dbda9f692ace54dd$export$97e81faa16a182c7 = '#8C9CB8';
const $dbda9f692ace54dd$export$bfe21c59123ecf33 = '#7988A3';
const $dbda9f692ace54dd$export$ee82aa2ea6a1558 = '#67758F';
const $dbda9f692ace54dd$export$682927c6ed76be02 = '#56637A';
const $dbda9f692ace54dd$export$91fd9994c5be9757 = '#455166';
const $dbda9f692ace54dd$export$d281fbfe3cff2df6 = '#3B475C';
const $dbda9f692ace54dd$export$3902c91d8b98a753 = '#313D52';
const $dbda9f692ace54dd$export$8e8133c1ba5845b5 = '#283447';
const $dbda9f692ace54dd$export$33ff357f6620b39 = '#202B3D';
const $dbda9f692ace54dd$export$633847cf062b69e0 = '#1B2638';
const $dbda9f692ace54dd$export$9776a6e503bdbf76 = '#121A29';
const $dbda9f692ace54dd$export$6c813d5160dff5db = '#0E1624';
const $dbda9f692ace54dd$export$3d4f271a500072a = '#0D1424';
const $dbda9f692ace54dd$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $dbda9f692ace54dd$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $dbda9f692ace54dd$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $dbda9f692ace54dd$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $dbda9f692ace54dd$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $dbda9f692ace54dd$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $dbda9f692ace54dd$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $dbda9f692ace54dd$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $dbda9f692ace54dd$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $dbda9f692ace54dd$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $dbda9f692ace54dd$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $dbda9f692ace54dd$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $dbda9f692ace54dd$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $dbda9f692ace54dd$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $dbda9f692ace54dd$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $dbda9f692ace54dd$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $dbda9f692ace54dd$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $dbda9f692ace54dd$export$d2adc5dedf09fced = '#292A2E';
const $dbda9f692ace54dd$export$f51762073d2bb381 = '#94C748';
const $dbda9f692ace54dd$export$95e26d54def96891 = '#B3DF72';

parcelRegister("a1mC1", function(module, exports) {

$parcel$export(module.exports, "default", () => $26a1eb025410757e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $6m2Lh = parcelRequire("6m2Lh");

var $jxeEL = parcelRequire("jxeEL");

const $26a1eb025410757e$var$codeBlockButtonsWrapper = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'sticky',
    top: '0px',
    background: `${`var(--ds-surface, ${(0, $dbda9f692ace54dd$export$9fdfb749e33cdf97)})`}`
});
const $26a1eb025410757e$var$codeBlockButtonsStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    justifyContent: 'flex-end',
    position: 'absolute',
    height: '0',
    width: '100%',
    right: "var(--ds-space-075, 6px)",
    top: "var(--ds-space-050, 4px)",
    padding: "var(--ds-space-025, 2px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    button: {
        height: '32px',
        width: '32px',
        border: `2px solid ${`var(--ds-border, ${(0, $dbda9f692ace54dd$export$29a4f05edc054374)})`}`,
        borderRadius: '4px',
        marginLeft: "var(--ds-space-050, 4px)",
        padding: "var(--ds-space-025, 2px)",
        background: `${`var(--ds-surface-overlay, ${(0, $dbda9f692ace54dd$export$9fdfb749e33cdf97)})`}`,
        color: `${"var(--ds-icon, rgb(66, 82, 110))"}`,
        '&:hover': {
            borderWidth: '2px',
            backgroundColor: `${`var(--ds-surface-overlay-hovered, ${(0, $dbda9f692ace54dd$export$3e51e8f1440314ba)})`}`,
            height: '32px',
            width: '32px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.clicked': {
            backgroundColor: `${`var(--ds-background-neutral-bold-pressed, ${(0, $dbda9f692ace54dd$export$ad0bacf983b7ddaa)})`}`,
            borderRadius: '4px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            color: `${`var(--ds-icon-inverse, ${(0, $dbda9f692ace54dd$export$29a4f05edc054374)})`} !important`
        }
    }
});
const $26a1eb025410757e$var$CodeBlockButtonContainer = ({ allowCopyToClipboard: allowCopyToClipboard, allowWrapCodeBlock: allowWrapCodeBlock, setWrapLongLines: setWrapLongLines, text: text, wrapLongLines: wrapLongLines })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $26a1eb025410757e$var$codeBlockButtonsWrapper
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $26a1eb025410757e$var$codeBlockButtonsStyle
    }, allowWrapCodeBlock && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jxeEL.default), {
        setWrapLongLines: setWrapLongLines,
        wrapLongLines: wrapLongLines
    }), allowCopyToClipboard && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6m2Lh.default), {
        content: text
    })));
};
var $26a1eb025410757e$export$2e2bcd8739ae039 = $26a1eb025410757e$var$CodeBlockButtonContainer;

});
parcelRegister("6m2Lh", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3aa5b0eaa26b756$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $74FvT = parcelRequire("74FvT");

var $kYnb5 = parcelRequire("kYnb5");

var $2E3pS = parcelRequire("2E3pS");

var $9fYN9 = parcelRequire("9fYN9");

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $bI0np = parcelRequire("bI0np");

var $3j5o6 = parcelRequire("3j5o6");

var $7ka9M = parcelRequire("7ka9M");
const $e3aa5b0eaa26b756$var$CopyButton = ({ content: content, intl: intl })=>{
    const [tooltip, setTooltip] = (0, $5uXOq.useState)(intl.formatMessage((0, $kYnb5.codeBlockButtonMessages).copyCodeToClipboard));
    const [className, setClassName] = (0, $5uXOq.useState)('copy-to-clipboard');
    const onMouseLeave = ()=>{
        setTooltip(intl.formatMessage((0, $kYnb5.codeBlockButtonMessages).copyCodeToClipboard));
        setClassName('copy-to-clipboard');
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bI0np.default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("span", null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9fYN9.default), {
            content: tooltip,
            hideTooltipOnClick: false,
            position: "top"
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            onMouseLeave: onMouseLeave
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $74FvT.default), {
            appearance: "subtle",
            "aria-haspopup": true,
            "aria-label": tooltip,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            iconBefore: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2E3pS))), {
                label: tooltip
            }),
            onClick: (event)=>{
                fireAnalyticsEvent({
                    // @ts-expect-error - Type 'ACTION.CLICKED' is not assignable to type 'ACTION.CLICKED | ACTION.MEDIA_LINK_TRANSFORMED | ACTION.STARTED | ACTION.TOGGLE_EXPAND | ACTION.UNSUPPORTED_CONTENT_ENCOUNTERED | ACTION.VISITED | ACTION.RENDERED | ACTION.INVALID_PROSEMIRROR_DOCUMENT | ACTION.CRASHED | ... 6 more ... | AnnotationActionType'.
                    // This error was introduced after upgrading to TypeScript 5
                    action: (0, $3j5o6.ACTION).CLICKED,
                    actionSubject: (0, $3j5o6.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $3j5o6.ACTION_SUBJECT_ID).CODEBLOCK_COPY,
                    eventType: (0, $3j5o6.EVENT_TYPE).UI
                });
                (0, $7ka9M.copyTextToClipboard)(content);
                setTooltip(intl.formatMessage((0, $kYnb5.codeBlockButtonMessages).copiedCodeToClipboard));
                setClassName('copy-to-clipboard clicked');
                event.stopPropagation();
            },
            spacing: "compact"
        })))));
};
var $e3aa5b0eaa26b756$export$2e2bcd8739ae039 = (0, $8RXs9.default)($e3aa5b0eaa26b756$var$CopyButton);

});
parcelRegister("2E3pS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::746afd86dff7a846534476462b8fe4e7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1ed1f7a0294a5e93$var$_react = $1ed1f7a0294a5e93$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1ed1f7a0294a5e93$var$_copy = $1ed1f7a0294a5e93$var$_interopRequireDefault((parcelRequire("aqrFt")));

var $1ed1f7a0294a5e93$var$_copy2 = $1ed1f7a0294a5e93$var$_interopRequireDefault((parcelRequire("hu33e")));
function $1ed1f7a0294a5e93$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CopyIcon.
 * This component is CopyIcon, with `UNSAFE_fallbackIcon` set to "CopyIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1ed1f7a0294a5e93$var$CopyIcon = (props)=>/*#__PURE__*/ $1ed1f7a0294a5e93$var$_react.default.createElement($1ed1f7a0294a5e93$var$_copy.default, Object.assign({
        LEGACY_fallbackIcon: $1ed1f7a0294a5e93$var$_copy2.default
    }, props));
$1ed1f7a0294a5e93$var$CopyIcon.Name = 'CopyIconMigration';
var $1ed1f7a0294a5e93$var$_default = module.exports.default = $1ed1f7a0294a5e93$var$CopyIcon;

});
parcelRegister("aqrFt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cbd1068d7fb082440154244857d12f2c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7971cb5fd0a3c4f5$var$_react = $7971cb5fd0a3c4f5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7971cb5fd0a3c4f5$var$_baseNew = $7971cb5fd0a3c4f5$var$_interopRequireDefault((parcelRequire("9ogAd")));
function $7971cb5fd0a3c4f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7971cb5fd0a3c4f5$var$CopyIcon = (props)=>/*#__PURE__*/ $7971cb5fd0a3c4f5$var$_react.default.createElement($7971cb5fd0a3c4f5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$7971cb5fd0a3c4f5$var$CopyIcon.displayName = 'CopyIcon';
var $7971cb5fd0a3c4f5$var$_default = module.exports.default = $7971cb5fd0a3c4f5$var$CopyIcon;

});

parcelRegister("hu33e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cba79ae2b60c685a$var$_react = $cba79ae2b60c685a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $hD6Dj = parcelRequire("hD6Dj");

var $cba79ae2b60c685a$var$_copy = $cba79ae2b60c685a$var$_interopRequireDefault((parcelRequire("aqrFt")));
function $cba79ae2b60c685a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cba79ae2b60c685a$var$CopyIcon = (props)=>/*#__PURE__*/ $cba79ae2b60c685a$var$_react.default.createElement($hD6Dj.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props, {
        newIcon: $cba79ae2b60c685a$var$_copy.default
    }));
$cba79ae2b60c685a$var$CopyIcon.displayName = 'CopyIcon';
var $cba79ae2b60c685a$var$_default = module.exports.default = $cba79ae2b60c685a$var$CopyIcon;

});



parcelRegister("jxeEL", function(module, exports) {

$parcel$export(module.exports, "default", () => $1eb0d48c27087bca$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $74FvT = parcelRequire("74FvT");

var $kYnb5 = parcelRequire("kYnb5");

var $NpTs5 = parcelRequire("NpTs5");

var $9fYN9 = parcelRequire("9fYN9");

var $bI0np = parcelRequire("bI0np");

var $3j5o6 = parcelRequire("3j5o6");
const $1eb0d48c27087bca$var$WrapIcon = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("svg", {
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("g", {
        fill: "currentColor",
        clipPath: "url(#clip0_654_431)"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("path", {
        d: "M20 4h-1v16h1V4ZM3 8a1 1 0 0 1 1-1h9.5a4.5 4.5 0 1 1 0 9h-2.086l.293.293a1 1 0 0 1-1.414 1.414l-2-2a1 1 0 0 1 0-1.414l2-2a1 1 0 0 1 1.414 1.414l-.293.293H13.5a2.5 2.5 0 0 0 0-5H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd",
        fillRule: "evenodd"
    })));
};
const $1eb0d48c27087bca$var$CodeBlockWrapButton = ({ setWrapLongLines: setWrapLongLines, wrapLongLines: wrapLongLines, intl: intl })=>{
    const wrapMessage = intl.formatMessage(wrapLongLines ? (0, $kYnb5.codeBlockButtonMessages).unwrapCode : (0, $kYnb5.codeBlockButtonMessages).wrapCode);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bI0np.default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("span", null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9fYN9.default), {
            content: wrapMessage,
            hideTooltipOnClick: false,
            position: "top"
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $74FvT.default), {
            appearance: "subtle",
            "aria-haspopup": true,
            "aria-label": wrapMessage,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `wrap-code ${wrapLongLines ? 'clicked' : ''}`,
            iconBefore: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $NpTs5.default), {
                glyph: $1eb0d48c27087bca$var$WrapIcon,
                label: ""
            }),
            isSelected: wrapLongLines,
            onClick: (event)=>{
                fireAnalyticsEvent({
                    // @ts-expect-error - Type 'ACTION.CLICKED' is not assignable to type 'ACTION.CLICKED | ACTION.MEDIA_LINK_TRANSFORMED | ACTION.STARTED | ACTION.TOGGLE_EXPAND | ACTION.UNSUPPORTED_CONTENT_ENCOUNTERED | ACTION.VISITED | ACTION.RENDERED | ACTION.INVALID_PROSEMIRROR_DOCUMENT | ACTION.CRASHED | ... 6 more ... | AnnotationActionType'
                    // This error was introduced after upgrading to TypeScript 5
                    action: (0, $3j5o6.ACTION).CLICKED,
                    actionSubject: (0, $3j5o6.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $3j5o6.ACTION_SUBJECT_ID).CODEBLOCK_WRAP,
                    attributes: {
                        wrapped: !wrapLongLines
                    },
                    eventType: (0, $3j5o6.EVENT_TYPE).UI
                });
                setWrapLongLines(!wrapLongLines);
                event.stopPropagation();
            },
            spacing: "compact"
        }))));
};
var $1eb0d48c27087bca$export$2e2bcd8739ae039 = (0, $8RXs9.default)($1eb0d48c27087bca$var$CodeBlockWrapButton);

});




parcelRegister("1pSis", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac64a22a08329725$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kFCJY = parcelRequire("kFCJY");

var $e9MpH = parcelRequire("e9MpH");

var $8RXs9 = parcelRequire("8RXs9");

var $jqKBT = parcelRequire("jqKBT");

var $gJUKS = parcelRequire("gJUKS");
const $ac64a22a08329725$var$Date = /*#__PURE__*/ (0, $5uXOq.memo)(function Date(props) {
    const inlineAnnotationProps = (0, $gJUKS.useInlineAnnotationProps)(props);
    const { timestamp: timestamp, parentIsIncompleteTask: parentIsIncompleteTask, intl: intl } = props;
    const className = !!parentIsIncompleteTask && (0, $e9MpH.isPastDate)(timestamp) ? 'date-node date-node-highlighted' : 'date-node';
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $kFCJY.DateSharedCssClassName).DATE_WRAPPER,
        ...inlineAnnotationProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-node-type": "date",
            "data-timestamp": timestamp,
            children: parentIsIncompleteTask ? (0, $e9MpH.timestampToTaskContext)(timestamp, intl) : (0, $e9MpH.timestampToString)(timestamp, intl)
        })
    });
});
const $ac64a22a08329725$export$19285a5b05c4ea7c = (0, $8RXs9.default)($ac64a22a08329725$var$Date);
function $ac64a22a08329725$var$DateWithFormatContext(props) {
    const [isChecked] = (0, $jqKBT.useTaskItemsFormatContext)();
    let parentIsIncompleteTask = props.parentIsIncompleteTask;
    if (typeof isChecked !== 'undefined') parentIsIncompleteTask = !isChecked;
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)($ac64a22a08329725$export$19285a5b05c4ea7c, {
        ...props,
        parentIsIncompleteTask: parentIsIncompleteTask
    });
}
var $ac64a22a08329725$export$2e2bcd8739ae039 = $ac64a22a08329725$var$DateWithFormatContext;

});
parcelRegister("e9MpH", function(module, exports) {

$parcel$export(module.exports, "timestampToUTCDate", () => $c2d059989f85d080$export$56c3660a4ee2196a);
$parcel$export(module.exports, "todayTimestampInUTC", () => $c2d059989f85d080$export$6297728405c48562);
$parcel$export(module.exports, "timestampToString", () => $c2d059989f85d080$export$48755a044ef883a0);
$parcel$export(module.exports, "timestampToIsoFormat", () => $c2d059989f85d080$export$70a1b7b6fffe4dd1);
$parcel$export(module.exports, "isPastDate", () => $c2d059989f85d080$export$e6cc7bfc6e0e363e);
$parcel$export(module.exports, "timestampToTaskContext", () => $c2d059989f85d080$export$fbc04a9e57b04a80);

var $SzDmm = parcelRequire("SzDmm");

var $kUxFz = parcelRequire("kUxFz");
var $c2d059989f85d080$var$FORMATS = /*#__PURE__*/ function(FORMATS) {
    FORMATS["ISO_FORMAT"] = "YYYY-MM-DD";
    FORMATS["LOCALIZED_FORMAT"] = "LOCALIZED_FORMAT";
    return FORMATS;
}($c2d059989f85d080$var$FORMATS || {});
const $c2d059989f85d080$export$56c3660a4ee2196a = (timestamp)=>{
    const date = new Date(Number(timestamp));
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();
    return {
        day: day,
        month: month,
        year: year
    };
};
const $c2d059989f85d080$export$6297728405c48562 = ()=>{
    const today = new Date(Date.now());
    const todayInUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
    return todayInUTC.toString();
};
const $c2d059989f85d080$var$addLeadingZero = (val)=>{
    if (val < 10) return `0${val}`;
    return val;
};
const $c2d059989f85d080$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $c2d059989f85d080$export$48755a044ef883a0 = (timestamp, intl, pattern)=>{
    if (!intl || pattern === "YYYY-MM-DD") return $c2d059989f85d080$export$70a1b7b6fffe4dd1(timestamp);
    const date = new Date(Number(timestamp));
    return intl.formatDate(date, {
        timeZone: 'UTC',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        formatMatcher: 'best fit'
    });
};
const $c2d059989f85d080$export$70a1b7b6fffe4dd1 = (timestamp)=>{
    const date = new Date(Number(timestamp));
    return `${date.getUTCFullYear()}-${$c2d059989f85d080$var$addLeadingZero(date.getUTCMonth() + 1)}-${$c2d059989f85d080$var$addLeadingZero(date.getUTCDate())}`;
};
const $c2d059989f85d080$export$e6cc7bfc6e0e363e = (timestamp)=>{
    return (0, $kUxFz.default)(new Date(Number(timestamp)), new Date(Number($c2d059989f85d080$export$6297728405c48562())));
};
const $c2d059989f85d080$export$fbc04a9e57b04a80 = (timestamp, intl)=>{
    const curDate = new Date(Number($c2d059989f85d080$export$6297728405c48562()));
    const givenDate = new Date(Number(timestamp));
    const distance = (0, $SzDmm.default)(givenDate, curDate);
    if (intl && [
        -1,
        0,
        1
    ].indexOf(distance) > -1) return $c2d059989f85d080$var$capitalizeFirstLetter(intl.formatRelativeTime(distance, 'day', {
        numeric: 'auto'
    }));
    return $c2d059989f85d080$export$48755a044ef883a0(timestamp, intl, "LOCALIZED_FORMAT");
};

});

parcelRegister("jqKBT", function(module, exports) {

$parcel$export(module.exports, "TaskItemsFormatProvider", () => $ce02eb37f3c557e0$export$1ca88acfa8fef6b0);
$parcel$export(module.exports, "useTaskItemsFormatContext", () => $ce02eb37f3c557e0$export$617439880b48c653);
$parcel$export(module.exports, "TaskItemsFormatConsumer", () => $ce02eb37f3c557e0$export$be32c078f3ebeea0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $ce02eb37f3c557e0$var$defaultValue = [
    undefined,
    ()=>{}
];
const $ce02eb37f3c557e0$var$TaskItemsFormatContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($ce02eb37f3c557e0$var$defaultValue);
const $ce02eb37f3c557e0$var$reducer = (_state, action)=>{
    return action;
};
function $ce02eb37f3c557e0$export$1ca88acfa8fef6b0({ children: children }) {
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useReducer($ce02eb37f3c557e0$var$reducer, undefined);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($ce02eb37f3c557e0$var$TaskItemsFormatContext.Provider, {
        value: value,
        children: children
    });
}
function $ce02eb37f3c557e0$export$617439880b48c653() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($ce02eb37f3c557e0$var$TaskItemsFormatContext);
}
function $ce02eb37f3c557e0$export$be32c078f3ebeea0({ children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($ce02eb37f3c557e0$var$TaskItemsFormatContext.Consumer, {
        children: children
    });
}

});

parcelRegister("gJUKS", function(module, exports) {

$parcel$export(module.exports, "useInlineAnnotationProps", () => $f7c78ab6fbfef0b1$export$11564cda945bb3c9);

var $hFKXd = parcelRequire("hFKXd");

var $2VAFB = parcelRequire("2VAFB");
function $f7c78ab6fbfef0b1$export$11564cda945bb3c9(props) {
    const { selectionDraftDocumentPosition: draftPosition } = (0, $2VAFB.useAnnotationRangeState)();
    if (!(0, $hFKXd.fg)('editor_inline_comments_on_inline_nodes')) return {};
    if (!props.dataAttributes) // the inlineCard component is currently used by the block card, embed card and card error boundary components
    // when used via these components, no dataAttributes are passed (and we don't want it setup for inline comments)
    return {};
    const inlineCardPosition = props.dataAttributes['data-renderer-start-pos'] - 1;
    const hasDraft = draftPosition && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    draftPosition?.from <= inlineCardPosition && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    draftPosition?.to >= inlineCardPosition + 1;
    if (hasDraft) return {
        'data-renderer-mark': true,
        'data-annotation-draft-mark': true,
        'data-annotation-inline-node': true,
        'data-renderer-start-pos': inlineCardPosition
    };
    return {
        'data-annotation-inline-node': true,
        'data-annotation-mark': true,
        'data-renderer-start-pos': inlineCardPosition
    };
}

});


parcelRegister("creTd", function(module, exports) {

$parcel$export(module.exports, "default", () => $43c69d0cb547b1ac$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lC6Wo = parcelRequire("lC6Wo");
class $43c69d0cb547b1ac$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    render() {
        const { children: children } = this.props;
        if ((0, $5uXOq.Children).count(children) === 0) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lC6Wo.default), {
            children: children
        });
    }
}

});
parcelRegister("lC6Wo", function(module, exports) {

$parcel$export(module.exports, "default", () => $a99f975538dfd447$export$2e2bcd8739ae039);
/* DecisionList.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
/*
	Increasing specificity with double ampersand to ensure these rules take
	priority over the global styles applied to 'ol' elements.
*/ const $a99f975538dfd447$var$listStyles = null;
class $a99f975538dfd447$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    render() {
        const { children: children } = this.props;
        if (!children) return null;
        // Data attributes are required for copy and paste from rendered content
        // to the editor to preserve the decision.
        // This allows the editor to differentiate between numbered and ordered lists,
        // and action items, which all share the common `<li>` element.
        // The value of `data-decision-local-id` should be discarded upon paste, with a
        // a new uuid generated by the editor for the cloned content.
        return /*#__PURE__*/ (0, $2OMIu.jsx)("ol", {
            "data-decision-list-local-id": "",
            "data-node-type": "decisionList",
            className: (0, $bwpsq.default)([
                "_1braglyw _1yxxidpf"
            ]),
            children: (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (child, idx)=>{
                const { localId: localId } = child.props;
                return /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
                    "data-decision-local-id": localId || '',
                    "data-decision-state": "DECIDED",
                    children: child
                }, idx);
            })
        });
    }
}

});


parcelRegister("h6hny", function(module, exports) {

$parcel$export(module.exports, "default", () => $729f12d7b334598b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cgXkz = parcelRequire("cgXkz");
function $729f12d7b334598b$export$2e2bcd8739ae039({ children: children, dataAttributes: dataAttributes }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgXkz.default), {
        dataAttributes: dataAttributes,
        children: children
    });
}

});
parcelRegister("cgXkz", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb56ab84c9986f70$export$2e2bcd8739ae039);
/* DecisionItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jtBmS = parcelRequire("jtBmS");

var $1QcGX = parcelRequire("1QcGX");
const $fb56ab84c9986f70$var$iconStyles = null;
const $fb56ab84c9986f70$var$iconStylesWithPlaceholder = null;
const $fb56ab84c9986f70$var$DecisionItem = ({ appearance: appearance, children: children, contentRef: contentRef, placeholder: placeholder, showPlaceholder: showPlaceholder, dataAttributes: dataAttributes })=>{
    const icon = /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        contentEditable: false,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dlexct _4t3i7vkz _1bsb7vkz _19pk1b66 _2hwxutpp _otyridpf _18u0idpf _syaz1yjp _1e0c1txw _4cvr1h6o _1bah1h6o",
            showPlaceholder && "_syaz1oju"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jtBmS))), {
            label: "Decision",
            spacing: "spacious",
            color: "currentColor",
            LEGACY_size: "large"
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1QcGX.default), {
        appearance: appearance,
        contentRef: contentRef,
        icon: icon,
        placeholder: placeholder,
        showPlaceholder: showPlaceholder,
        itemType: "DECISION",
        dataAttributes: dataAttributes,
        children: children
    });
};
var $fb56ab84c9986f70$export$2e2bcd8739ae039 = $fb56ab84c9986f70$var$DecisionItem;

});
parcelRegister("jtBmS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d9c2fe4153711de61c73f11b1bae070a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e2ddb6420761a541$var$_react = $e2ddb6420761a541$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e2ddb6420761a541$var$_decision = $e2ddb6420761a541$var$_interopRequireDefault((parcelRequire("9Cwms")));

var $e2ddb6420761a541$var$_decision2 = $e2ddb6420761a541$var$_interopRequireDefault((parcelRequire("3oBZD")));
function $e2ddb6420761a541$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DecisionIcon.
 * This component is DecisionIcon, with `UNSAFE_fallbackIcon` set to "EditorDecisionIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e2ddb6420761a541$var$DecisionIcon = (props)=>/*#__PURE__*/ $e2ddb6420761a541$var$_react.default.createElement($e2ddb6420761a541$var$_decision.default, Object.assign({
        LEGACY_fallbackIcon: $e2ddb6420761a541$var$_decision2.default
    }, props));
$e2ddb6420761a541$var$DecisionIcon.Name = 'DecisionIconMigration';
var $e2ddb6420761a541$var$_default = module.exports.default = $e2ddb6420761a541$var$DecisionIcon;

});
parcelRegister("9Cwms", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be0b9c9537e0b69b1d3c8d2587861fe5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7010c3ee6d90a756$var$_react = $7010c3ee6d90a756$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7010c3ee6d90a756$var$_baseNew = $7010c3ee6d90a756$var$_interopRequireDefault((parcelRequire("9ogAd")));
function $7010c3ee6d90a756$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Decision".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7010c3ee6d90a756$var$DecisionIcon = (props)=>/*#__PURE__*/ $7010c3ee6d90a756$var$_react.default.createElement($7010c3ee6d90a756$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m13.97.97-4.5 4.5 1.06 1.06 4.5-4.5zM3.56 2.5H8V1H1.75a.75.75 0 0 0-.75.75V8h1.5V3.56l4.604 4.604a.5.5 0 0 1 .146.354V15h1.5V8.518a2 2 0 0 0-.586-1.414z" clip-rule="evenodd"/>`
    }, props));
$7010c3ee6d90a756$var$DecisionIcon.displayName = 'DecisionIcon';
var $7010c3ee6d90a756$var$_default = module.exports.default = $7010c3ee6d90a756$var$DecisionIcon;

});

parcelRegister("3oBZD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $279115a5a2f0cf25$var$_react = $279115a5a2f0cf25$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $hD6Dj = parcelRequire("hD6Dj");

var $279115a5a2f0cf25$var$_decision = $279115a5a2f0cf25$var$_interopRequireDefault((parcelRequire("9Cwms")));
function $279115a5a2f0cf25$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $279115a5a2f0cf25$var$EditorDecisionIcon = (props)=>/*#__PURE__*/ $279115a5a2f0cf25$var$_react.default.createElement($hD6Dj.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.414 8 3.293 3.293c.187.187.293.442.293.707v5a1 1 0 0 1-2 0v-4.586l-3-3V10.5a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2zm8.293-1.707a1 1 0 0 1 0 1.414l-2.5 2.5a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l2.5-2.5a1 1 0 0 1 1.414 0"/></svg>`
    }, props, {
        newIcon: $279115a5a2f0cf25$var$_decision.default
    }));
$279115a5a2f0cf25$var$EditorDecisionIcon.displayName = 'EditorDecisionIcon';
var $279115a5a2f0cf25$var$_default = module.exports.default = $279115a5a2f0cf25$var$EditorDecisionIcon;

});


parcelRegister("1QcGX", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbbe8d14319e139b$export$2e2bcd8739ae039);
/* Item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $dbbe8d14319e139b$var$placeholderStyles = null;
const $dbbe8d14319e139b$var$placeholderTaskStyles = null;
const $dbbe8d14319e139b$var$decisionStyles = null;
const $dbbe8d14319e139b$var$contentStyles = null;
const $dbbe8d14319e139b$var$taskStyles = null;
class $dbbe8d14319e139b$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            appearance: 'inline'
        };
    }
    renderPlaceholder() {
        const { children: children, placeholder: placeholder, showPlaceholder: showPlaceholder, itemType: itemType } = this.props;
        if (!showPlaceholder || !placeholder || children) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            "data-testid": "task-decision-item-placeholder",
            "data-component": "placeholder",
            contentEditable: false,
            className: (0, $bwpsq.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0tu8f _1reo15vq _18m915vq _kqswstnw _syaz131l _lcxvglyw _1bto1l2s _o5721q9c _p12f1dza",
                itemType === 'TASK' && "_19pkidpf _2hwxidpf _otyridpf _18u0hwpb"
            ]),
            children: placeholder
        });
    }
    renderMessageAppearance() {
        const { contentRef: contentRef, children: children, icon: icon, itemType: itemType, checkBoxId: checkBoxId, dataAttributes: dataAttributes } = this.props;
        if (itemType === 'TASK') return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            id: `${checkBoxId}-wrapper`,
            className: (0, $bwpsq.default)([
                "_1e0c1txw _2lx2vrvc _kqswh2mm"
            ]),
            children: [
                icon,
                this.renderPlaceholder(),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    "data-component": "content",
                    ref: contentRef,
                    ...dataAttributes,
                    className: (0, $bwpsq.default)([
                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1wug _slp31hna _1ul9idpf"
                    ]),
                    children: children
                })
            ]
        });
        else if (itemType === 'DECISION') return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            "data-testid": "elements-decision-item",
            "data-decision-wrapper": "true",
            className: (0, $bwpsq.default)([
                "_2rkosqtm _1e0c1txw _2lx2vrvc _19pku2gc _2hwxidpf _otyridpf _18u0idpf _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvutpp _bfhkm7j4 _kqswh2mm _14hd1wug"
            ]),
            children: [
                icon,
                this.renderPlaceholder(),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    "data-component": "content",
                    ref: contentRef,
                    ...dataAttributes,
                    className: (0, $bwpsq.default)([
                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1wug _slp31hna _1ul9idpf"
                    ]),
                    children: children
                })
            ]
        });
        return null;
    }
    render() {
        return this.renderMessageAppearance();
    }
}

});



parcelRegister("aq1l9", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b1b43b8c14f2146$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $hFKXd = parcelRequire("hFKXd");

var $aeZts = parcelRequire("aeZts");

var $5uXOq = parcelRequire("5uXOq");

var $4b4i9 = parcelRequire("4b4i9");
var $hiA9t = parcelRequire("hiA9t");

var $gJUKS = parcelRequire("gJUKS");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $8b1b43b8c14f2146$var$EmojiNode extends (0, $5uXOq.PureComponent) {
    static{
        this.displayName = 'EmojiNode';
    }
    static{
        this.defaultProps = {
            showTooltip: true
        };
    }
    constructor(props){
        super(props), this.renderWithProvider = (providers)=>{
            const { allowTextFallback: allowTextFallback, shortName: shortName, id: id, fallback: fallback, fitToHeight: fitToHeight, showTooltip: showTooltip, resourceConfig: resourceConfig } = this.props;
            if (allowTextFallback && !providers.emojiProvider) return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                "data-emoji-id": id,
                "data-emoji-short-name": shortName,
                "data-emoji-text": fallback || shortName
            }, fallback || shortName);
            if (!providers.emojiProvider) return null;
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aeZts.default), {
                emojiId: {
                    id: id,
                    fallback: fallback,
                    shortName: shortName
                },
                emojiProvider: providers.emojiProvider,
                showTooltip: showTooltip,
                fitToHeight: fitToHeight,
                optimistic: true,
                optimisticImageURL: resourceConfig?.optimisticImageApi?.getUrl({
                    id: id,
                    fallback: fallback,
                    shortName: shortName
                }),
                editorEmoji: true,
                onEmojiLoadSuccess: resourceConfig?.onEmojiLoadSuccess,
                onEmojiLoadFail: resourceConfig?.onEmojiLoadFail
            });
        };
        this.providerFactory = props.providers || new (0, $4b4i9.default)();
    }
    componentWillUnmount() {
        if (!this.props.providers) // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
    }
    render() {
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $hiA9t.WithProviders), {
            providers: [
                'emojiProvider'
            ],
            providerFactory: this.providerFactory,
            renderNode: this.renderWithProvider
        });
    }
}
function $8b1b43b8c14f2146$var$EmojiItem(props) {
    const { id: id, providers: providers, shortName: shortName, text: text, fitToHeight: fitToHeight, resourceConfig: resourceConfig } = props;
    const inlineAnnotationProps = (0, $gJUKS.useInlineAnnotationProps)(props);
    if ((0, $hFKXd.fg)('editor_inline_comments_on_inline_nodes')) return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", inlineAnnotationProps, /*#__PURE__*/ (0, $f8Sb3.jsx)($8b1b43b8c14f2146$var$EmojiNode, {
        allowTextFallback: true,
        id: id,
        shortName: shortName,
        fallback: text,
        providers: providers,
        fitToHeight: fitToHeight,
        resourceConfig: resourceConfig
    })));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($8b1b43b8c14f2146$var$EmojiNode, {
        allowTextFallback: true,
        id: id,
        shortName: shortName,
        fallback: text,
        providers: providers,
        fitToHeight: fitToHeight,
        resourceConfig: resourceConfig
    });
}
// Working around an issue with pre existing tests using react-test-renderer
// https://github.com/facebook/react/issues/17301#issuecomment-557765213
$8b1b43b8c14f2146$var$EmojiItem.defaultProps = {};
var $8b1b43b8c14f2146$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($8b1b43b8c14f2146$var$EmojiItem);

});
parcelRegister("aeZts", function(module, exports) {

$parcel$export(module.exports, "default", () => $9905a40c4ba4c381$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fMbOJ = parcelRequire("fMbOJ");

var $3UZxO = parcelRequire("3UZxO");

var $4v9rR = parcelRequire("4v9rR");

var $bwwQh = parcelRequire("bwwQh");
const $9905a40c4ba4c381$var$ResourcedEmoji = (props)=>{
    const { emojiId: emojiId, optimisticImageURL: optimisticImageURL } = props;
    (0, $5uXOq.useEffect)(()=>{
        if (!emojiId) return;
        (0, $4v9rR.sampledUfoRenderedEmoji)(emojiId).start({
            samplingRate: (0, $bwwQh.SAMPLING_RATE_EMOJI_RENDERED_EXP)
        });
        (0, $4v9rR.ufoExperiences)['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName).addMetadata({
            source: 'ResourcedEmoji',
            emojiId: emojiId.id,
            isOptimisticImageURL: !!optimisticImageURL
        });
        return ()=>{
            (0, $4v9rR.sampledUfoRenderedEmoji)(emojiId).abort({
                metadata: {
                    source: 'ResourcedEmoji',
                    reason: 'unmount'
                }
            });
        };
    }, [
        emojiId,
        optimisticImageURL
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3UZxO.UfoErrorBoundary), {
        experiences: [
            (0, $4v9rR.ufoExperiences)['emoji-rendered'].getInstance(props.emojiId.id || props.emojiId.shortName)
        ],
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fMbOJ.ResourcedEmojiComponent), {
            ...props
        })
    });
};
var $9905a40c4ba4c381$export$2e2bcd8739ae039 = $9905a40c4ba4c381$var$ResourcedEmoji;

});
parcelRegister("fMbOJ", function(module, exports) {

$parcel$export(module.exports, "ResourcedEmojiComponent", () => $b63d5ef26291fdcf$export$7bfde52eceb3e2f6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwwQh = parcelRequire("bwwQh");

var $bwbaR = parcelRequire("bwbaR");

var $9NDjD = parcelRequire("9NDjD");

var $eu9s5 = parcelRequire("eu9s5");

var $lEPER = parcelRequire("lEPER");

var $4v9rR = parcelRequire("4v9rR");

var $9VLPC = parcelRequire("9VLPC");

var $4v9rR = parcelRequire("4v9rR");
var $b63d5ef26291fdcf$var$ResourcedEmojiComponentRenderStatesEnum = /*#__PURE__*/ function(ResourcedEmojiComponentRenderStatesEnum) {
    ResourcedEmojiComponentRenderStatesEnum["INITIAL"] = "INITIAL";
    ResourcedEmojiComponentRenderStatesEnum["FALLBACK"] = "FALLBACK";
    ResourcedEmojiComponentRenderStatesEnum["EMOJI"] = "EMOJI";
    return ResourcedEmojiComponentRenderStatesEnum;
}($b63d5ef26291fdcf$var$ResourcedEmojiComponentRenderStatesEnum || {});
const $b63d5ef26291fdcf$export$7bfde52eceb3e2f6 = (props)=>{
    const { emojiProvider: emojiProvider, emojiId: emojiId, showTooltip: showTooltip = false, customFallback: customFallback, fitToHeight: fitToHeight = (0, $bwwQh.defaultEmojiHeight), optimistic: optimistic = false, optimisticImageURL: optimisticImageURL, editorEmoji: editorEmoji, onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail } = props;
    const { shortName: shortName, id: id, fallback: fallback } = emojiId;
    const [emoji, setEmoji] = (0, $5uXOq.useState)();
    const [loaded, setLoaded] = (0, $5uXOq.useState)(false);
    const [imageLoadError, setImageLoadError] = (0, $5uXOq.useState)(false);
    const [resolvedEmojiProvider, setResolvedEmojiProvider] = (0, $5uXOq.useState)();
    const fetchOrGetEmoji = (0, $5uXOq.useCallback)(async (_emojiProvider, emojiId, optimisticFetch = false)=>{
        if (!_emojiProvider.fetchByEmojiId) {
            setEmoji(undefined);
            const reason = 'missing fetchByEmojiId interface';
            onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
            (0, $4v9rR.sampledUfoRenderedEmoji)(emojiId).failure({
                metadata: {
                    reason: reason,
                    source: 'ResourcedEmojiComponent'
                }
            });
        }
        const foundEmoji = _emojiProvider.fetchByEmojiId(emojiId, optimisticFetch);
        (0, $4v9rR.sampledUfoRenderedEmoji)(emojiId).mark((0, $9NDjD.UfoEmojiTimings).METADATA_START);
        if ((0, $bwbaR.isPromise)(foundEmoji)) {
            setLoaded(false);
            foundEmoji.then((emoji)=>{
                setEmoji(emoji);
                if (!emoji) {
                    const reason = 'failed to find';
                    onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
                    // emoji is undefined
                    (0, $4v9rR.sampledUfoRenderedEmoji)(emojiId).failure({
                        metadata: {
                            reason: reason,
                            source: 'ResourcedEmojiComponent',
                            data: {
                                emoji: {
                                    id: emojiId.id,
                                    shortName: emojiId.shortName
                                }
                            }
                        }
                    });
                }
            }).catch(()=>{
                setEmoji(undefined);
                const reason = 'failed to load';
                onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
                (0, $4v9rR.sampledUfoRenderedEmoji)(emojiId).failure({
                    metadata: {
                        reason: reason,
                        source: 'ResourcedEmojiComponent',
                        data: {
                            emoji: {
                                id: emojiId.id,
                                shortName: emojiId.shortName
                            }
                        }
                    }
                });
            }).finally(()=>{
                setLoaded(true);
                (0, $4v9rR.sampledUfoRenderedEmoji)(emojiId).mark((0, $9NDjD.UfoEmojiTimings).METADATA_END);
            });
        } else {
            setEmoji(foundEmoji);
            setLoaded(true);
            (0, $4v9rR.sampledUfoRenderedEmoji)(emojiId).mark((0, $9NDjD.UfoEmojiTimings).METADATA_END);
        }
    }, [
        onEmojiLoadFail
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!emojiId) return;
        if (!(0, $4v9rR.hasUfoMarked)((0, $4v9rR.sampledUfoRenderedEmoji)(emojiId), (0, $9NDjD.UfoEmojiTimings).FMP_END)) (0, $4v9rR.sampledUfoRenderedEmoji)(emojiId).markFMP();
    }, [
        emojiId
    ]);
    (0, $5uXOq.useMemo)(()=>{
        if (!resolvedEmojiProvider || !emojiId) return;
        fetchOrGetEmoji(resolvedEmojiProvider, emojiId, optimistic);
    }, [
        resolvedEmojiProvider,
        emojiId,
        optimistic,
        fetchOrGetEmoji
    ]);
    /**
	 * Setting resolved emoji provider for optimistic rendering
	 */ (0, $5uXOq.useEffect)(()=>{
        Promise.resolve(emojiProvider).then((emojiProvider)=>{
            setResolvedEmojiProvider(emojiProvider);
        });
    }, [
        emojiProvider
    ]);
    const emojiRenderState = (0, $5uXOq.useMemo)(()=>{
        if (!emoji && !loaded && !optimisticImageURL) return "INITIAL";
        else if (!emoji && loaded || imageLoadError) return "FALLBACK";
        return "EMOJI";
    }, [
        emoji,
        loaded,
        optimisticImageURL,
        imageLoadError
    ]);
    const optimisticEmojiDescription = (0, $5uXOq.useMemo)(()=>{
        if (optimisticImageURL) {
            if (emoji && ((0, $bwbaR.isImageRepresentation)(emoji.representation) || (0, $bwbaR.isMediaRepresentation)(emoji?.representation))) {
                const { width: width, height: height } = emoji.representation;
                return {
                    ...emoji,
                    representation: {
                        width: width,
                        height: height,
                        imagePath: optimisticImageURL
                    }
                };
            } else return {
                id: id,
                shortName: shortName,
                fallback: fallback,
                type: '',
                category: '',
                representation: {
                    height: fitToHeight || (0, $bwwQh.defaultEmojiHeight),
                    width: fitToHeight || (0, $bwwQh.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true
            };
        }
        return emoji;
    }, [
        emoji,
        optimisticImageURL,
        fallback,
        fitToHeight,
        id,
        shortName
    ]);
    const handleOnLoadError = (0, $5uXOq.useCallback)((emojiId)=>{
        setImageLoadError(true);
        const reason = 'load error';
        onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
        (0, $4v9rR.sampledUfoRenderedEmoji)(emojiId).failure({
            metadata: {
                reason: reason,
                source: 'ResourcedEmojiComponent',
                emojiId: emojiId.id
            }
        });
    }, [
        onEmojiLoadFail
    ]);
    const handleOnLoadSuccess = (0, $5uXOq.useCallback)((emojiId)=>{
        onEmojiLoadSuccess && onEmojiLoadSuccess(emojiId.id);
    }, [
        onEmojiLoadSuccess
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9VLPC.EmojiCommonProvider), {
        emojiProvider: resolvedEmojiProvider,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
            "data-emoji-id": id,
            "data-emoji-short-name": shortName,
            "data-emoji-text": fallback || shortName,
            "data-ssr-placeholder": `emoji-${id ?? shortName}`,
            "data-ssr-placeholder-replace": `emoji-${id ?? shortName}`,
            children: [
                emojiRenderState === "INITIAL" && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lEPER.default), {
                    shortName: shortName,
                    showTooltip: showTooltip,
                    size: fitToHeight || (0, $bwwQh.defaultEmojiHeight),
                    loading: true
                }),
                emojiRenderState === "FALLBACK" && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: customFallback || fallback || shortName
                }),
                emojiRenderState === "EMOJI" && optimisticEmojiDescription && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eu9s5.default), {
                    emoji: optimisticEmojiDescription,
                    onLoadError: handleOnLoadError,
                    onLoadSuccess: handleOnLoadSuccess,
                    showTooltip: showTooltip,
                    fitToHeight: fitToHeight,
                    autoWidth: !!emoji ? false : true,
                    editorEmoji: editorEmoji
                })
            ]
        })
    });
};
var $b63d5ef26291fdcf$export$2e2bcd8739ae039 = $b63d5ef26291fdcf$export$7bfde52eceb3e2f6;

});
parcelRegister("bwwQh", function(module, exports) {

$parcel$export(module.exports, "customCategory", () => $8d42bc92fbe9374a$export$5e4e3d1c3e43156a);
$parcel$export(module.exports, "frequentCategory", () => $8d42bc92fbe9374a$export$78ccdc4be403c468);
$parcel$export(module.exports, "searchCategory", () => $8d42bc92fbe9374a$export$1b0258512be88334);
$parcel$export(module.exports, "yourUploadsCategory", () => $8d42bc92fbe9374a$export$42b510423367f354);
$parcel$export(module.exports, "customTitle", () => $8d42bc92fbe9374a$export$5d0f2d8ee50f86f5);
$parcel$export(module.exports, "userCustomTitle", () => $8d42bc92fbe9374a$export$1debc2f10cc69389);
$parcel$export(module.exports, "dataURLPrefix", () => $8d42bc92fbe9374a$export$8ac325bfd32359b0);
$parcel$export(module.exports, "deleteEmojiLabel", () => $8d42bc92fbe9374a$export$a330961542edfe6f);
$parcel$export(module.exports, "MAX_ORDINAL", () => $8d42bc92fbe9374a$export$1a817f1886276c6d);
$parcel$export(module.exports, "defaultEmojiHeight", () => $8d42bc92fbe9374a$export$3f99ac31dc0406db);
$parcel$export(module.exports, "emojiPickerWidth", () => $8d42bc92fbe9374a$export$d171dc12fee2b1da);
$parcel$export(module.exports, "sizeGap", () => $8d42bc92fbe9374a$export$c10ac8125a260041);
$parcel$export(module.exports, "defaultEmojiPickerSize", () => $8d42bc92fbe9374a$export$5248fb9e0cccc41f);
$parcel$export(module.exports, "emojiPickerListHeight", () => $8d42bc92fbe9374a$export$7722b8e9522021df);
$parcel$export(module.exports, "localStoragePrefix", () => $8d42bc92fbe9374a$export$e394a0c530ae5631);
$parcel$export(module.exports, "selectedToneStorageKey", () => $8d42bc92fbe9374a$export$79ee4ef84c545f8f);
$parcel$export(module.exports, "defaultCategories", () => $8d42bc92fbe9374a$export$d7ab74456f1aa1ad);
$parcel$export(module.exports, "KeyboardKeys", () => $8d42bc92fbe9374a$export$70f9e5bc10d7eac);
$parcel$export(module.exports, "KeyboardNavigationDirection", () => $8d42bc92fbe9374a$export$1c4f2adc1f8e19d3);
$parcel$export(module.exports, "CATEGORYSELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $8d42bc92fbe9374a$export$99130b698ea188ae);
$parcel$export(module.exports, "EMOJI_KEYBOARD_KEYS_SUPPORTED", () => $8d42bc92fbe9374a$export$84b035f8d01101cc);
$parcel$export(module.exports, "TONESELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $8d42bc92fbe9374a$export$e27d4e477c0cd4ec);
$parcel$export(module.exports, "EMOJIPICKERLIST_KEYBOARD_KEYS_SUPPORTED", () => $8d42bc92fbe9374a$export$97027974dc06eeee);
$parcel$export(module.exports, "DEFAULT_TONE", () => $8d42bc92fbe9374a$export$4f0ee90b28d6efc5);
$parcel$export(module.exports, "EMOJI_LIST_COLUMNS", () => $8d42bc92fbe9374a$export$2829f3ec323f8ec0);
$parcel$export(module.exports, "EMOJI_LIST_PAGE_COUNT", () => $8d42bc92fbe9374a$export$ce3a0e7d2d7d6ba2);
$parcel$export(module.exports, "EMOJI_SEARCH_DEBOUNCE", () => $8d42bc92fbe9374a$export$858e8dc100a97278);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RENDERED_EXP", () => $8d42bc92fbe9374a$export$83aab2ae64548423);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP", () => $8d42bc92fbe9374a$export$66cabad5e268b05e);
const $8d42bc92fbe9374a$export$5e4e3d1c3e43156a = 'CUSTOM';
const $8d42bc92fbe9374a$export$78ccdc4be403c468 = 'FREQUENT';
const $8d42bc92fbe9374a$export$2c4b04c3aacdf1b3 = 'SITE';
const $8d42bc92fbe9374a$export$1b0258512be88334 = 'SEARCH';
const $8d42bc92fbe9374a$export$42b510423367f354 = 'USER_CUSTOM';
const $8d42bc92fbe9374a$export$5d0f2d8ee50f86f5 = 'allUploadsCustomCategory';
const $8d42bc92fbe9374a$export$1debc2f10cc69389 = 'userUploadsCustomCategory';
const $8d42bc92fbe9374a$export$8ac325bfd32359b0 = 'data:';
const $8d42bc92fbe9374a$export$a330961542edfe6f = 'delete-emoji';
const $8d42bc92fbe9374a$export$1a817f1886276c6d = 100000;
const $8d42bc92fbe9374a$export$3f99ac31dc0406db = 20;
const $8d42bc92fbe9374a$export$d171dc12fee2b1da = 350;
const $8d42bc92fbe9374a$export$c10ac8125a260041 = 80;
const $8d42bc92fbe9374a$export$5248fb9e0cccc41f = 'medium';
const $8d42bc92fbe9374a$export$94f75d625e7801d3 = 260;
const $8d42bc92fbe9374a$export$7ed599d166d65aea = 295;
const $8d42bc92fbe9374a$export$7722b8e9522021df = $8d42bc92fbe9374a$export$7ed599d166d65aea - 58; // picker height - actions height
const $8d42bc92fbe9374a$export$e218e5cb105a0e22 = 54;
const $8d42bc92fbe9374a$export$e67f617938b111f1 = $8d42bc92fbe9374a$export$7ed599d166d65aea + $8d42bc92fbe9374a$export$e218e5cb105a0e22;
const $8d42bc92fbe9374a$export$e394a0c530ae5631 = 'fabric.emoji';
const $8d42bc92fbe9374a$export$79ee4ef84c545f8f = `${$8d42bc92fbe9374a$export$e394a0c530ae5631}.selectedTone`;
const $8d42bc92fbe9374a$export$d7ab74456f1aa1ad = [
    'PEOPLE',
    'NATURE',
    'FOODS',
    'ACTIVITY',
    'PLACES',
    'OBJECTS',
    'SYMBOLS',
    'FLAGS'
];
var $8d42bc92fbe9374a$export$70f9e5bc10d7eac = /*#__PURE__*/ function(KeyboardKeys) {
    KeyboardKeys["ArrowLeft"] = "ArrowLeft";
    KeyboardKeys["ArrowRight"] = "ArrowRight";
    KeyboardKeys["ArrowUp"] = "ArrowUp";
    KeyboardKeys["ArrowDown"] = "ArrowDown";
    KeyboardKeys["PageUp"] = "PageUp";
    KeyboardKeys["PageDown"] = "PageDown";
    KeyboardKeys["Home"] = "Home";
    KeyboardKeys["End"] = "End";
    KeyboardKeys["Enter"] = "Enter";
    KeyboardKeys["Tab"] = "Tab";
    KeyboardKeys["Space"] = " ";
    KeyboardKeys["Backspace"] = "Backspace";
    return KeyboardKeys;
}({});
var $8d42bc92fbe9374a$export$1c4f2adc1f8e19d3 = /*#__PURE__*/ function(KeyboardNavigationDirection) {
    KeyboardNavigationDirection["Down"] = "Down";
    KeyboardNavigationDirection["Up"] = "Up";
    KeyboardNavigationDirection["Left"] = "Left";
    KeyboardNavigationDirection["Right"] = "Right";
    return KeyboardNavigationDirection;
}({});
const $8d42bc92fbe9374a$export$99130b698ea188ae = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End"
];
const $8d42bc92fbe9374a$export$84b035f8d01101cc = [
    "Enter",
    "Backspace",
    " "
];
const $8d42bc92fbe9374a$export$e27d4e477c0cd4ec = [
    "Enter",
    "Tab",
    " "
];
const $8d42bc92fbe9374a$export$97027974dc06eeee = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End",
    "ArrowUp",
    "ArrowDown",
    "PageUp",
    "PageDown"
];
const $8d42bc92fbe9374a$export$4f0ee90b28d6efc5 = 0;
const $8d42bc92fbe9374a$export$9f7de4293d27f3aa = 50;
const $8d42bc92fbe9374a$export$41388d9a435030e6 = 'hipchat_migration_emoticons';
const $8d42bc92fbe9374a$export$273d18db3ba5f6b1 = 'atlassian.fabric.emoji.picker';
const $8d42bc92fbe9374a$export$2829f3ec323f8ec0 = 8;
const $8d42bc92fbe9374a$export$ce3a0e7d2d7d6ba2 = 5;
const $8d42bc92fbe9374a$export$858e8dc100a97278 = 150;
const $8d42bc92fbe9374a$export$83aab2ae64548423 = 20;
const $8d42bc92fbe9374a$export$66cabad5e268b05e = 100;

});

parcelRegister("bwbaR", function(module, exports) {

$parcel$export(module.exports, "isSpriteServiceRepresentation", () => $8ed4b44a892db4a2$export$1c52f72b88b558e8);
$parcel$export(module.exports, "isSpriteRepresentation", () => $8ed4b44a892db4a2$export$a194199d673d75de);
$parcel$export(module.exports, "isImageRepresentation", () => $8ed4b44a892db4a2$export$90b099a26fbd8b41);
$parcel$export(module.exports, "isMediaRepresentation", () => $8ed4b44a892db4a2$export$979133dc1df141c6);
$parcel$export(module.exports, "isPromise", () => $8ed4b44a892db4a2$export$4369c812aac99591);
$parcel$export(module.exports, "isEmojiDescription", () => $8ed4b44a892db4a2$export$378ed2c87d03531c);
$parcel$export(module.exports, "isMediaEmoji", () => $8ed4b44a892db4a2$export$a7e82c67204c73a1);
$parcel$export(module.exports, "isLoadedMediaEmoji", () => $8ed4b44a892db4a2$export$d25a80b2c86d7fdf);
$parcel$export(module.exports, "isEmojiDescriptionWithVariations", () => $8ed4b44a892db4a2$export$b0ed6d8df471f3cc);
$parcel$export(module.exports, "isEmojiVariationDescription", () => $8ed4b44a892db4a2$export$82a0350e1f6b5c0a);
$parcel$export(module.exports, "isMessagesKey", () => $8ed4b44a892db4a2$export$dddfba07c16c94d2);
$parcel$export(module.exports, "toEmojiId", () => $8ed4b44a892db4a2$export$8d7d3de6b5b305d1);
$parcel$export(module.exports, "containsEmojiId", () => $8ed4b44a892db4a2$export$39ed0ad389e58ef7);
$parcel$export(module.exports, "convertImageToMediaRepresentation", () => $8ed4b44a892db4a2$export$20a1bd1d33069ce7);
$parcel$export(module.exports, "convertMediaToImageEmoji", () => $8ed4b44a892db4a2$export$f1a89a11f425faaa);
$parcel$export(module.exports, "buildEmojiDescriptionWithAltRepresentation", () => $8ed4b44a892db4a2$export$a48c58c688a3131);
$parcel$export(module.exports, "getCategoryId", () => $8ed4b44a892db4a2$export$4bcbf61cb6832a8e);

var $bjC98 = parcelRequire("bjC98");

var $bwwQh = parcelRequire("bwwQh");
const $8ed4b44a892db4a2$export$1c52f72b88b558e8 = (rep)=>!!(rep && rep.spriteRef);
const $8ed4b44a892db4a2$export$a194199d673d75de = (rep)=>!!(rep && rep.sprite);
const $8ed4b44a892db4a2$export$90b099a26fbd8b41 = (rep)=>!!(rep && rep.imagePath);
const $8ed4b44a892db4a2$export$979133dc1df141c6 = (rep)=>!!(rep && rep.mediaPath);
const $8ed4b44a892db4a2$export$4369c812aac99591 = (p)=>!!(p && p.then);
const $8ed4b44a892db4a2$export$378ed2c87d03531c = (possibleEmojiDescription)=>possibleEmojiDescription && possibleEmojiDescription.shortName && possibleEmojiDescription.type;
const $8ed4b44a892db4a2$export$a7e82c67204c73a1 = (emoji)=>$8ed4b44a892db4a2$export$979133dc1df141c6(emoji.representation);
const $8ed4b44a892db4a2$export$7720a4954d6f75f8 = (rep)=>$8ed4b44a892db4a2$export$90b099a26fbd8b41(rep) && rep.imagePath.indexOf((0, $bwwQh.dataURLPrefix)) === 0;
const $8ed4b44a892db4a2$export$d25a80b2c86d7fdf = (emoji)=>emoji.category === (0, $bwwQh.customCategory) && $8ed4b44a892db4a2$export$7720a4954d6f75f8(emoji.representation);
const $8ed4b44a892db4a2$export$b0ed6d8df471f3cc = (emoji)=>!!(emoji && emoji.skinVariations);
const $8ed4b44a892db4a2$export$82a0350e1f6b5c0a = (object)=>{
    return 'baseId' in object;
};
const $8ed4b44a892db4a2$export$dddfba07c16c94d2 = (key)=>key in (0, $bjC98.messages);
const $8ed4b44a892db4a2$export$8d7d3de6b5b305d1 = (emoji)=>({
        shortName: emoji.shortName,
        id: emoji.id,
        fallback: emoji.fallback
    });
const $8ed4b44a892db4a2$export$2dbfa5a5d35af350 = (emoji)=>{
    if (!emoji) return undefined;
    return $8ed4b44a892db4a2$export$8d7d3de6b5b305d1(emoji);
};
const $8ed4b44a892db4a2$export$92ad509d7c96b723 = (l, r)=>l === r || l && r && l.id === r.id && l.shortName === r.shortName;
const $8ed4b44a892db4a2$export$39ed0ad389e58ef7 = (emojis, emojiId)=>{
    if (!emojiId) return false;
    for(let i = 0; i < emojis.length; i++){
        if ($8ed4b44a892db4a2$export$92ad509d7c96b723(emojis[i], emojiId)) return true;
    }
    return false;
};
const $8ed4b44a892db4a2$export$20a1bd1d33069ce7 = (rep)=>({
        mediaPath: rep.imagePath,
        height: rep.height,
        width: rep.width
    });
const $8ed4b44a892db4a2$export$3197405d49d2e298 = (rep, newImagePath)=>({
        imagePath: newImagePath || rep.mediaPath,
        height: rep.height,
        width: rep.width
    });
const $8ed4b44a892db4a2$export$f1a89a11f425faaa = (emoji, newImagePath, useAlt)=>{
    const mediaRepresentation = emoji.representation;
    const mediaAltRepresentation = emoji.altRepresentation;
    const imgPath = !useAlt ? newImagePath : undefined;
    const altImgPath = useAlt ? newImagePath : undefined;
    if (!$8ed4b44a892db4a2$export$979133dc1df141c6(mediaRepresentation) && !$8ed4b44a892db4a2$export$979133dc1df141c6(mediaAltRepresentation)) return emoji;
    const representation = $8ed4b44a892db4a2$export$979133dc1df141c6(mediaRepresentation) ? $8ed4b44a892db4a2$export$3197405d49d2e298(mediaRepresentation, imgPath) : mediaRepresentation;
    const altRepresentation = $8ed4b44a892db4a2$export$979133dc1df141c6(mediaAltRepresentation) ? $8ed4b44a892db4a2$export$3197405d49d2e298(mediaAltRepresentation, altImgPath) : mediaAltRepresentation;
    const baseEmoji = {
        ...emoji,
        representation: representation
    };
    return $8ed4b44a892db4a2$export$a48c58c688a3131(baseEmoji, altRepresentation);
};
const $8ed4b44a892db4a2$export$a48c58c688a3131 = (emoji, altRepresentation)=>{
    if (!altRepresentation) return emoji;
    return {
        ...emoji,
        altRepresentation: altRepresentation
    };
};
const $8ed4b44a892db4a2$export$4bcbf61cb6832a8e = (emoji)=>emoji.category;

});
parcelRegister("bjC98", function(module, exports) {

$parcel$export(module.exports, "messages", () => $36a37086ffb266b6$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $36a37086ffb266b6$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    deleteEmojiTooltip: {
        id: 'fabric.emoji.delete.tooltip',
        defaultMessage: 'Delete',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTooltipForScreenreader: {
        id: 'fabric.emoji.delete.screenreader.tooltip',
        defaultMessage: 'To delete {shortName} emoji, press Backspace',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTitle: {
        id: 'fabric.emoji.delete.title',
        defaultMessage: 'Remove emoji',
        description: 'Title for emoji removal dialog'
    },
    deleteEmojiDescription: {
        id: 'fabric.emoji.delete.description',
        defaultMessage: 'All existing instances of this emoji will be replaced with {emojiShortName}',
        description: 'Description for emoji removal dialog'
    },
    deleteEmojiLabel: {
        id: 'fabric.emoji.delete.label',
        defaultMessage: 'Remove',
        description: 'Button label to remove emoji'
    },
    addCustomEmojiLabel: {
        id: 'fabric.emoji.add.custom.emoji.label',
        defaultMessage: 'Add your own emoji',
        description: 'Button label to add custom emoji'
    },
    emojiPlaceholder: {
        id: 'fabric.emoji.placeholder',
        defaultMessage: 'e.g. hello',
        description: 'Placeholder for emoji that provides an example for emoji name'
    },
    emojiNameAriaLabel: {
        id: 'fabric.emoji.name.ariaLabel',
        defaultMessage: 'Enter a name for the new emoji',
        description: 'Explains to enter a name for a new emoji'
    },
    emojiChooseFileTitle: {
        id: 'fabric.emoji.choose.file.title',
        defaultMessage: 'Choose file',
        description: 'Choose custom emoji file'
    },
    emojiChooseFileScreenReaderDescription: {
        id: 'fabric.emoji.choose.file.screenReaderDescription',
        defaultMessage: 'Choose a file for the emoji. JPG, PNG or GIF. Max size 1 MB',
        description: 'Message indicating the purpose of choosing the file and requirements for the file'
    },
    emojiSelectSkinToneButtonAriaLabelText: {
        id: 'fabric.emoji.select.skin.tone.ariaLabel',
        defaultMessage: 'Choose your skin tone, {selectedTone} selected',
        description: 'Message indicating the purpose of the skin tone selection button and the selected tone'
    },
    emojiSelectSkinToneListAriaLabelText: {
        id: 'fabric.emoji.select.skin.list.ariaLabel',
        defaultMessage: 'Skin tone selector',
        description: 'Message indicating the purpose of the skin tone list and make user to choose one tone'
    },
    emojiImageRequirements: {
        id: 'fabric.emoji.image.requirements',
        defaultMessage: 'JPG, PNG or GIF. Max size 1 MB.',
        description: 'Message for emoji image requirements and maximum file size'
    },
    emojiPreviewTitle: {
        id: 'fabric.emoji.preview.title',
        defaultMessage: 'Preview',
        description: 'Emoji preview title'
    },
    emojiPreview: {
        id: 'fabric.emoji.preview',
        defaultMessage: 'Your new emoji {emoji} looks great',
        description: 'Emoji preview'
    },
    addEmojiLabel: {
        id: 'fabric.emoji.add.label',
        defaultMessage: 'Add emoji',
        description: 'verb - Button label to add emoji'
    },
    retryLabel: {
        id: 'fabric.emoji.retry.label',
        defaultMessage: 'Retry',
        description: 'verb - Button label to retry upload'
    },
    cancelLabel: {
        id: 'fabric.emoji.cancel.label',
        defaultMessage: 'Cancel',
        description: 'verb - button label to cancel operation'
    },
    searchPlaceholder: {
        id: 'fabric.emoji.search.placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder for search emoji field'
    },
    searchLabel: {
        id: 'fabric.emoji.search.label',
        defaultMessage: 'Emoji name',
        description: 'verb - button label to search'
    },
    searchResultsStatus: {
        id: 'fabric.emoji.search.status.count',
        defaultMessage: 'Found {count} emojis',
        description: 'search results status for screenreader to read out'
    },
    searchResultsStatusSeeAll: {
        id: 'fabric.emoji.search.status',
        defaultMessage: 'Seeing all emojis',
        description: 'search results status when no search query for screenreader to read out'
    },
    categoriesSelectorLabel: {
        id: 'fabric.emoji.categories.label',
        defaultMessage: 'Choose an emoji category',
        description: 'Aria label for Emoji categories selector at the top of emoji picker'
    },
    categoriesSearchResults: {
        id: 'fabric.emoji.categories.search.results',
        defaultMessage: 'Search results',
        description: 'Emoji categories search results'
    },
    frequentCategory: {
        id: 'fabric.emoji.category.frequent',
        defaultMessage: 'Frequent',
        description: 'Emoji frequent category'
    },
    peopleCategory: {
        id: 'fabric.emoji.category.people',
        defaultMessage: 'People',
        description: 'Emoji frequent category'
    },
    natureCategory: {
        id: 'fabric.emoji.category.nature',
        defaultMessage: 'Nature',
        description: 'Emoji nature category'
    },
    foodsCategory: {
        id: 'fabric.emoji.category.foods',
        defaultMessage: 'Food & Drink',
        description: 'Emoji Foods category'
    },
    activityCategory: {
        id: 'fabric.emoji.category.activity',
        defaultMessage: 'Activity',
        description: 'Emoji activity category'
    },
    placesCategory: {
        id: 'fabric.emoji.category.places',
        defaultMessage: 'Travel & Places',
        description: 'Emoji Places category'
    },
    objectsCategory: {
        id: 'fabric.emoji.category.objects',
        defaultMessage: 'Objects',
        description: 'Emoji objects category'
    },
    symbolsCategory: {
        id: 'fabric.emoji.category.symbols',
        defaultMessage: 'Symbols',
        description: 'Emoji symbols category'
    },
    flagsCategory: {
        id: 'fabric.emoji.category.flags',
        defaultMessage: 'Flags',
        description: 'Emoji flags category'
    },
    productivityCategory: {
        id: 'fabric.emoji.category.productivity',
        defaultMessage: 'Productivity',
        description: 'Emoji productivity category'
    },
    userUploadsCustomCategory: {
        id: 'fabric.emoji.category.user.uploads',
        defaultMessage: 'Your uploads',
        description: 'User uploads in the custom category'
    },
    allUploadsCustomCategory: {
        id: 'fabric.emoji.category.all.uploads',
        defaultMessage: 'All uploads',
        description: 'All uploads in the custom category'
    },
    deleteEmojiFailed: {
        id: 'fabric.emoji.error.delete.failed',
        defaultMessage: 'Remove failed',
        description: 'Error message when custom emoji failed to be removed'
    },
    emojiInvalidImage: {
        id: 'fabric.emoji.error.invalid.image',
        defaultMessage: 'Selected image is invalid',
        description: 'Error message for invalid selected image'
    },
    emojiUploadFailed: {
        id: 'fabric.emoji.error.upload.failed',
        defaultMessage: 'Upload failed',
        description: 'Failed to upload emoji image'
    },
    emojiUploadTimeout: {
        id: 'fabric.emoji.error.upload.timeout',
        defaultMessage: 'Upload timed out',
        description: 'Failed to upload emoji image'
    },
    emojiImageTooBig: {
        id: 'fabric.emoji.error.image.too.big',
        defaultMessage: 'Selected image is more than 1 MB',
        description: 'Error message for image too big, beyond the size limit'
    },
    emojiPickerTitle: {
        id: 'fabric.emoji.picker',
        defaultMessage: 'Emoji picker',
        description: 'Aria label for emoji picker'
    },
    emojiPickerListPanel: {
        id: 'fabric.emoji.pickerlist.tabpanel',
        defaultMessage: 'Emojis actions and list panel',
        description: 'Aria lable for tabpanel of emoji picker, which shows emojis actions and list'
    },
    emojiPickerGrid: {
        id: 'fabric.emoji.pickerlist.grid',
        defaultMessage: '{showSearchResults, select, true{Search results} other{Emojis}}',
        description: `Aria label for emoji picker grid, showSearchResults is a boolean variable, message will be "Entering Emojis table", or "Leaving Emojis"`
    },
    emojiButtonRoleDescription: {
        id: 'fabric.emoji.emojipicker.emoi.roledescription',
        defaultMessage: 'emoji button',
        description: `Aria roledescription for emoji button, used in emoji picker.`
    },
    error: {
        id: 'fabric.emoji.emojipicker.error',
        defaultMessage: 'Error!',
        description: `Aria label for error icon, apperaed in emoji uploader screens and delete emoji screens of emoji picker`
    }
});

});


parcelRegister("9NDjD", function(module, exports) {

$parcel$export(module.exports, "SearchSort", () => $06a3a811e7eeb71f$export$a15e9a4340d08b2e);
$parcel$export(module.exports, "SearchSourceTypes", () => $06a3a811e7eeb71f$export$db41220f541db607);
$parcel$export(module.exports, "ProviderTypes", () => $06a3a811e7eeb71f$export$bf337c9223e5c8b);
$parcel$export(module.exports, "UfoExperienceName", () => $06a3a811e7eeb71f$export$d0d1c9cd31a11a64);
$parcel$export(module.exports, "UfoComponentName", () => $06a3a811e7eeb71f$export$122ce5c8fda96269);
$parcel$export(module.exports, "UfoEmojiTimingsKeys", () => $06a3a811e7eeb71f$export$265ee18146a6885e);
$parcel$export(module.exports, "UfoEmojiTimings", () => $06a3a811e7eeb71f$export$482549d945a3723);
var $06a3a811e7eeb71f$export$a15e9a4340d08b2e = /*#__PURE__*/ function(SearchSort) {
    // no sort - just the default ordering of emoji
    SearchSort[SearchSort["None"] = 0] = "None";
    // a sort taking into account a number of factors including, usage, closeness of match to the query, etc
    SearchSort[SearchSort["Default"] = 1] = "Default";
    // sort such that the most frequently used emoji come first, and then standard, service defined ordering is preserved.
    SearchSort[SearchSort["UsageFrequency"] = 2] = "UsageFrequency";
    return SearchSort;
}({});
var $06a3a811e7eeb71f$export$db41220f541db607 = /*#__PURE__*/ function(SearchSourceTypes) {
    SearchSourceTypes["PICKER"] = "picker";
    SearchSourceTypes["TYPEAHEAD"] = "typeahead";
    return SearchSourceTypes;
}({});
var $06a3a811e7eeb71f$export$bf337c9223e5c8b = /*#__PURE__*/ function(ProviderTypes) {
    ProviderTypes["SITE"] = "SITE";
    ProviderTypes["STANDARD"] = "STANDARD";
    ProviderTypes["ATLASSIAN"] = "ATLASSIAN";
    ProviderTypes["UNKNOWN"] = "UNKNOWN";
    ProviderTypes["SINGLE"] = "SINGLE";
    return ProviderTypes;
}({});
var $06a3a811e7eeb71f$export$d0d1c9cd31a11a64 = /*#__PURE__*/ function(UfoExperienceName) {
    UfoExperienceName["EMOJI_RENDERED"] = "emoji-rendered";
    UfoExperienceName["EMOJI_RESOURCE_FETCHED"] = "emoji-resource-fetched";
    UfoExperienceName["EMOJI_PICKER_OPENED"] = "emoji-picker-opened";
    UfoExperienceName["EMOJI_SELECTION_RECORDED"] = "emoji-selection-recorded";
    UfoExperienceName["EMOJI_UPLOADED"] = "emoji-uploaded";
    UfoExperienceName["EMOJI_SEARCHED"] = "emoji-searched";
    return UfoExperienceName;
}({});
var $06a3a811e7eeb71f$export$122ce5c8fda96269 = /*#__PURE__*/ function(UfoComponentName) {
    UfoComponentName["EMOJI"] = "emoji";
    UfoComponentName["EMOJI_PICKER"] = "emoji-picker";
    UfoComponentName["EMOJI_PROVIDER"] = "emoji-provider";
    return UfoComponentName;
}({});
var $06a3a811e7eeb71f$export$265ee18146a6885e = /*#__PURE__*/ function(UfoEmojiTimingsKeys) {
    UfoEmojiTimingsKeys["FMP"] = "fmp";
    UfoEmojiTimingsKeys["MOUNTED"] = "emoji-mount";
    UfoEmojiTimingsKeys["METADATA"] = "emoji-metadata";
    UfoEmojiTimingsKeys["MEDIADATA"] = "emoji-media";
    UfoEmojiTimingsKeys["ONLOAD"] = "emoji-onload";
    return UfoEmojiTimingsKeys;
}({});
var $06a3a811e7eeb71f$export$482549d945a3723 = /*#__PURE__*/ function(UfoEmojiTimings) {
    UfoEmojiTimings["FMP_END"] = "fmp";
    UfoEmojiTimings["MOUNTED_END"] = "emoji-mount_end";
    UfoEmojiTimings["METADATA_START"] = "emoji-metadata_start";
    UfoEmojiTimings["METADATA_END"] = "emoji-metadata_end";
    UfoEmojiTimings["MEDIA_START"] = "emoji-media_start";
    UfoEmojiTimings["MEDIA_END"] = "emoji-media_end";
    UfoEmojiTimings["ONLOAD_START"] = "emoji-onload_start";
    UfoEmojiTimings["ONLOAD_END"] = "emoji-onload_end";
    return UfoEmojiTimings;
}({});

});

parcelRegister("eu9s5", function(module, exports) {

$parcel$export(module.exports, "EmojiNodeWrapper", () => $d76808996c28e793$export$ce5eef59d8e46687);
$parcel$export(module.exports, "default", () => $d76808996c28e793$export$2e2bcd8739ae039);
/* Emoji.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $9fYN9 = parcelRequire("9fYN9");

var $9w8A4 = parcelRequire("9w8A4");

var $bwwQh = parcelRequire("bwwQh");

var $bwbaR = parcelRequire("bwbaR");

var $9NDjD = parcelRequire("9NDjD");

var $cfDJ6 = parcelRequire("cfDJ6");

var $POaM3 = parcelRequire("POaM3");


var $4v9rR = parcelRequire("4v9rR");
var $k4VWQ = parcelRequire("k4VWQ");

var $4TD8f = parcelRequire("4TD8f");

var $734pQ = parcelRequire("734pQ");

var $4v9rR = parcelRequire("4v9rR");

var $lu2ov = parcelRequire("lu2ov");

var $by6z1 = parcelRequire("by6z1");
const $d76808996c28e793$var$emojiSpriteContainer = null;
const $d76808996c28e793$var$emojiImageContainer = null;
const $d76808996c28e793$var$handleMouseDown = (props, event)=>{
    // Clicked emoji delete button
    if (event.target instanceof Element && event.target.getAttribute('aria-label') === (0, $bwwQh.deleteEmojiLabel)) return;
    const { emoji: emoji, onSelected: onSelected } = props;
    if (onSelected && (0, $cfDJ6.leftClick)(event)) onSelected((0, $bwbaR.toEmojiId)(emoji), emoji, event);
};
const $d76808996c28e793$var$handleKeyDown = (props, event)=>{
    if (!(0, $bwwQh.EMOJI_KEYBOARD_KEYS_SUPPORTED).includes(event.key)) return;
    event.preventDefault();
    event.stopPropagation();
    const { emoji: emoji, onSelected: onSelected, showDelete: showDelete } = props;
    if (onSelected && (event.key === (0, $bwwQh.KeyboardKeys).Enter || event.key === (0, $bwwQh.KeyboardKeys).Space)) onSelected((0, $bwbaR.toEmojiId)(emoji), emoji, event);
    if (showDelete && event.key === (0, $bwwQh.KeyboardKeys).Backspace) $d76808996c28e793$var$handleDelete(props, event);
};
const $d76808996c28e793$var$handleMouseMove = (props, event)=>{
    const { emoji: emoji, onMouseMove: onMouseMove } = props;
    if (onMouseMove) onMouseMove((0, $bwbaR.toEmojiId)(emoji), emoji, event);
};
const $d76808996c28e793$var$handleFocus = (props, event)=>{
    const { emoji: emoji, onFocus: onFocus } = props;
    if (onFocus) onFocus((0, $bwbaR.toEmojiId)(emoji), emoji, event);
};
const $d76808996c28e793$var$handleDelete = (props, event)=>{
    const { emoji: emoji, onDelete: onDelete } = props;
    if (onDelete) onDelete((0, $bwbaR.toEmojiId)(emoji), emoji, event);
};
const $d76808996c28e793$var$handleImageError = (props, event)=>{
    const { emoji: emoji, onLoadError: onLoadError } = props;
    // Hide error state (but keep space for it)
    if (event.target) {
        const target = event.target;
        target.style.visibility = 'hidden';
    }
    if (onLoadError) onLoadError((0, $bwbaR.toEmojiId)(emoji), emoji, event);
};
const $d76808996c28e793$export$ef49ddbb198ce334 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className } = props;
    const representation = emoji.representation;
    const sprite = representation.sprite;
    const classes = `${(0, $c7ea896bb618f785$export$b06c4aab1d012063)} ${selected ? (0, $c7ea896bb618f785$export$8633a0edef8e95dd) : ''} ${selectOnHover ? (0, $c7ea896bb618f785$export$860109dfd198259b) : ''} ${className ? className : ''}`;
    let sizing = {};
    if (fitToHeight) sizing = {
        width: `${fitToHeight}px`,
        height: `${fitToHeight}px`,
        minHeight: `${fitToHeight}px`,
        minWidth: `${fitToHeight}px`
    };
    const xPositionInPercent = 100 / (sprite.column - 1) * (representation.xIndex - 0);
    const yPositionInPercent = 100 / (sprite.row - 1) * (representation.yIndex - 0);
    const style = {
        backgroundImage: `url(${sprite.url})`,
        backgroundPosition: `${xPositionInPercent}% ${yPositionInPercent}%`,
        backgroundSize: `${sprite.column * 100}% ${sprite.row * 100}%`,
        ...sizing
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)($d76808996c28e793$export$ce5eef59d8e46687, {
        ...props,
        type: "sprite",
        className: classes,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            className: (0, $c7ea896bb618f785$export$1c10634420a08d8a),
            style: style
        })
    }));
};
const $d76808996c28e793$export$99dfeb9d71c11788 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showDelete: showDelete, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth } = props;
    const [ref, inView] = (0, $734pQ.useInView)({
        triggerOnce: true
    });
    const ufoExp = (0, $4v9rR.sampledUfoRenderedEmoji)(emoji);
    const classes = `${(0, $c7ea896bb618f785$export$11462c0756c24ab6)} ${(0, $c7ea896bb618f785$export$b06c4aab1d012063)} ${selected ? (0, $c7ea896bb618f785$export$8633a0edef8e95dd) : ''} ${selectOnHover ? (0, $c7ea896bb618f785$export$860109dfd198259b) : ''} ${(0, $c7ea896bb618f785$export$da61cef1c8919f7c)} ${className ? className : ''} ${showDelete ? (0, $c7ea896bb618f785$export$22b19c311e9caa4) : ''}`;
    let width;
    let height;
    let src;
    const representation = (0, $9w8A4.shouldUseAltRepresentation)(emoji, fitToHeight) ? emoji.altRepresentation : emoji.representation;
    if ((0, $bwbaR.isImageRepresentation)(representation)) {
        src = representation.imagePath;
        width = representation.width;
        height = representation.height;
    } else if ((0, $bwbaR.isMediaRepresentation)(representation)) {
        src = representation.mediaPath;
        width = representation.width;
        height = representation.height;
    }
    let sizing = {};
    if (fitToHeight && width && height) // Presize image, to prevent reflow due to size changes after loading
    sizing = {
        // Size of <img> needs to be deterministic when rendered on server-side. Auto will cause width to be 0 before image is loaded.
        width: autoWidth && !(0, $by6z1.isSSR)() ? 'auto' : fitToHeight / height * width,
        height: fitToHeight
    };
    const onError = (0, $5uXOq.useCallback)((event)=>{
        $d76808996c28e793$var$handleImageError(props, event);
    }, [
        props
    ]);
    const onLoad = (0, $5uXOq.useCallback)(()=>{
        const mountedMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $9NDjD.UfoEmojiTimings).MOUNTED_END);
        // onload could trigger before onBeforeLoad when emojis in viewport at start, so we need to mark onload start manually.
        if (!(0, $4v9rR.hasUfoMarked)(ufoExp, (0, $9NDjD.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $9NDjD.UfoEmojiTimings).ONLOAD_START, mountedMark?.time);
        const loadedStartMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $9NDjD.UfoEmojiTimings).ONLOAD_START);
        if (mountedMark && loadedStartMark) ufoExp.addMetadata({
            lazyLoad: loadedStartMark.time > mountedMark.time
        });
        // onload_start
        if (!(0, $4v9rR.hasUfoMarked)(ufoExp, (0, $9NDjD.UfoEmojiTimings).ONLOAD_END)) ufoExp.mark((0, $9NDjD.UfoEmojiTimings).ONLOAD_END);
        ufoExp.success({
            metadata: {
                IBSupported: (0, $4TD8f.default).supportsIntersectionObserver
            }
        });
        if (onLoadSuccess) onLoadSuccess(emoji);
    }, [
        emoji,
        onLoadSuccess,
        ufoExp
    ]);
    const onBeforeLoad = (0, $5uXOq.useCallback)(()=>{
        if (!(0, $4v9rR.hasUfoMarked)(ufoExp, (0, $9NDjD.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $9NDjD.UfoEmojiTimings).ONLOAD_START);
    }, [
        ufoExp
    ]);
    const onMouseOver = (0, $5uXOq.useCallback)((e)=>{
        // only disable tooltip when not on focus
        if (!document.activeElement?.contains(e.target)) e.stopPropagation();
    }, []);
    // because of the lack of browser support of on before load natively, used IntersectionObserver helper hook to mimic the before load time mark for UFO.
    (0, $5uXOq.useEffect)(()=>{
        if (inView) onBeforeLoad();
    }, [
        inView,
        onBeforeLoad
    ]);
    const emojiNode = /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        //@ts-ignore
        loading: disableLazyLoad ? 'eager' : 'lazy',
        src: src,
        alt: emoji.name || emoji.shortName,
        "data-emoji-short-name": emoji.shortName,
        "data-emoji-id": emoji.id,
        "data-emoji-text": emoji.fallback || emoji.shortName,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "emoji",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            visibility: 'visible'
        },
        onError: onError,
        onLoad: onLoad,
        ...sizing,
        "data-vc": "emoji"
    }, src);
    // show a tooltip for deletable emoji only on focus
    if (showDelete) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9fYN9.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lu2ov.DeletableEmojiTooltipContent), {}),
        position: "right-start",
        tag: "span",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)($d76808996c28e793$export$ce5eef59d8e46687, {
            ...props,
            "aria-labelledby": `screenreader-emoji-${emoji.id}`,
            type: "image",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: classes,
            ref: ref,
            showTooltip: false,
            onMouseOver: onMouseOver,
            children: [
                emojiNode,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $POaM3.default), {
                    onClick: (event)=>$d76808996c28e793$var$handleDelete(props, event)
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lu2ov.DeletableEmojiTooltipContentForScreenReader), {
                    emoji: emoji
                })
            ]
        })
    });
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)($d76808996c28e793$export$ce5eef59d8e46687, {
        ...props,
        type: "image",
        className: classes,
        ref: ref,
        children: emojiNode
    }));
};
const $d76808996c28e793$export$ce5eef59d8e46687 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showTooltip: showTooltip, showDelete: showDelete, shouldBeInteractive: shouldBeInteractive = false, tabIndex: tabIndex, onSelected: onSelected, onMouseMove: onMouseMove, onFocus: onFocus, onDelete: onDelete, onLoadError: onLoadError, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth, children: children, type: type, editorEmoji: editorEmoji, ...other } = props;
    let accessibilityProps;
    if (editorEmoji) accessibilityProps = {
        role: undefined
    };
    else if (shouldBeInteractive) accessibilityProps = {
        role: 'button',
        'aria-label': emoji.shortName
    };
    else accessibilityProps = {
        role: 'img',
        'aria-label': emoji.shortName
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...accessibilityProps,
        ref: ref,
        "data-testid": `${type}-emoji-${emoji.shortName}`,
        "data-emoji-type": type,
        tabIndex: shouldBeInteractive ? tabIndex || 0 : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            type === 'sprite' ? "_19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _1e0c1o8l _jr50scvx _ylp71o8l _pkaxgktf _1hdcgktf _109tnkob _tn8j14ae _3naf14ae _nt751r31 _49pcglyw _1hvw1o36 _7ehi1n2i _491113zc" : "_2rkosqtm _19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _bfhk18uv _1e0c1o8l _s7n4nkob _v4pn1ule _tn8j14ae _3naf14ae _160jewfl _1theewfl _1kogh2mm _qyp0ewfl _nt751r31 _49pcglyw _1hvw1o36 _7ehi1n2i _491113zc",
            className
        ]),
        onKeyDown: (event)=>$d76808996c28e793$var$handleKeyDown(props, event),
        onMouseDown: (event)=>{
            $d76808996c28e793$var$handleMouseDown(props, event);
        },
        onMouseEnter: (event)=>{
            $d76808996c28e793$var$handleMouseMove(props, event);
        },
        onFocus: (event)=>{
            $d76808996c28e793$var$handleFocus(props, event);
        },
        title: showTooltip ? emoji.shortName : undefined,
        ...other,
        children: children
    });
});
const $d76808996c28e793$export$56cc48506ff790a = (props)=>{
    const { emoji: emoji } = props;
    // start emoji rendered experience, it may have already started earlier in ResourcedEmoji or CachingEmoji
    (0, $k4VWQ.useSampledUFOComponentExperience)((0, $4v9rR.ufoExperiences)['emoji-rendered'].getInstance(emoji.id || emoji.shortName), (0, $bwwQh.SAMPLING_RATE_EMOJI_RENDERED_EXP), {
        source: 'Emoji',
        emojiId: emoji.id
    });
    (0, $5uXOq.useEffect)(()=>{
        const ufoExp = (0, $4v9rR.sampledUfoRenderedEmoji)(emoji);
        if (!(0, $4v9rR.hasUfoMarked)(ufoExp, 'fmp')) ufoExp.markFMP();
        if (!(0, $4v9rR.hasUfoMarked)(ufoExp, (0, $9NDjD.UfoEmojiTimings).MOUNTED_END)) ufoExp.mark((0, $9NDjD.UfoEmojiTimings).MOUNTED_END);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // TODO: We always prefer render as image as having accessibility issues with sprite representation
    if ((0, $bwbaR.isSpriteRepresentation)(emoji.representation)) return /*#__PURE__*/ (0, $2OMIu.jsx)($d76808996c28e793$export$ef49ddbb198ce334, {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($d76808996c28e793$export$99dfeb9d71c11788, {
        ...props
    });
};
var $d76808996c28e793$export$2e2bcd8739ae039 = $d76808996c28e793$export$56cc48506ff790a;

});
parcelRegister("9w8A4", function(module, exports) {

$parcel$export(module.exports, "emojiRequest", () => $a3109e0c4c1cb942$export$ea1accde4cc117f4);
$parcel$export(module.exports, "getAltRepresentation", () => $a3109e0c4c1cb942$export$4a0301d636367e1d);
$parcel$export(module.exports, "denormaliseEmojiServiceResponse", () => $a3109e0c4c1cb942$export$afaea97e40b5ca70);
$parcel$export(module.exports, "shouldUseAltRepresentation", () => $a3109e0c4c1cb942$export$b7e9058f156d8d19);

var $92r21 = parcelRequire("92r21");

var $bwbaR = parcelRequire("bwbaR");

var $9ith6 = parcelRequire("9ith6");
const $a3109e0c4c1cb942$export$ea1accde4cc117f4 = (provider, options)=>{
    const { getRatio: getRatio = $a3109e0c4c1cb942$export$d39ce20a37bba061, ...serviceConfig } = provider;
    const scaleQueryParams = $a3109e0c4c1cb942$var$calculateScale(getRatio);
    const { queryParams: queryParams = {}, ...otherOptions } = options || {};
    const requestOptions = {
        ...otherOptions,
        queryParams: {
            ...scaleQueryParams,
            ...queryParams,
            preferredRepresentation: 'IMAGE'
        }
    };
    return (0, $92r21.utils).requestService(serviceConfig, requestOptions);
};
const $a3109e0c4c1cb942$var$calculateScale = (getRatio)=>{
    // Retina display
    if (getRatio() > 1) return {
        scale: 'XHDPI',
        altScale: 'XXXHDPI'
    };
    // Default set used for desktop
    return {
        altScale: 'XHDPI'
    };
};
const $a3109e0c4c1cb942$export$d39ce20a37bba061 = ()=>{
    if (typeof window === 'undefined') return 0;
    return window.devicePixelRatio;
};
const $a3109e0c4c1cb942$export$4a0301d636367e1d = (reps)=>{
    // Invalid reps handled outside function - logic may change depending what the service returns
    return reps[$a3109e0c4c1cb942$var$calculateScale($a3109e0c4c1cb942$export$d39ce20a37bba061).altScale];
};
const $a3109e0c4c1cb942$export$db05e6ae1fd416af = (url, meta)=>!!(meta && meta.mediaApiToken && url.indexOf(meta.mediaApiToken.url) === 0);
const $a3109e0c4c1cb942$export$55077db3efc820aa = (representation, meta)=>{
    if ((0, $bwbaR.isSpriteServiceRepresentation)(representation) && meta && meta.spriteSheets) {
        const { height: height, width: width, x: x, y: y, xIndex: xIndex, yIndex: yIndex, spriteRef: spriteRef } = representation;
        const spriteSheet = meta.spriteSheets[spriteRef];
        if (spriteSheet) return {
            sprite: spriteSheet,
            height: height,
            width: width,
            x: x,
            y: y,
            xIndex: xIndex,
            yIndex: yIndex
        };
    } else if ((0, $bwbaR.isImageRepresentation)(representation)) {
        const { height: height, width: width, imagePath: imagePath } = representation;
        if ($a3109e0c4c1cb942$export$db05e6ae1fd416af(imagePath, meta)) return (0, $bwbaR.convertImageToMediaRepresentation)(representation);
        return {
            height: height,
            width: width,
            imagePath: imagePath
        };
    }
    (0, $9ith6.default)('failed conversion for representation', representation, meta);
    return undefined;
};
const $a3109e0c4c1cb942$export$aa9faa01267cb2e7 = (altReps, meta)=>{
    return !altReps || Object.keys(altReps).length === 0 ? undefined : $a3109e0c4c1cb942$export$55077db3efc820aa($a3109e0c4c1cb942$export$4a0301d636367e1d(altReps), meta);
};
const $a3109e0c4c1cb942$export$e3da49c88c2e54d5 = (emoji, meta)=>{
    if (!emoji.skinVariations) return [];
    const skinEmoji = emoji.skinVariations;
    const baseId = emoji.id;
    return skinEmoji.map((skin)=>{
        const { representation: representation, altRepresentations: altRepresentations, ...other } = skin;
        return {
            baseId: baseId,
            representation: $a3109e0c4c1cb942$export$55077db3efc820aa(representation, meta),
            altRepresentation: $a3109e0c4c1cb942$export$aa9faa01267cb2e7(altRepresentations, meta),
            ...other
        };
    });
};
const $a3109e0c4c1cb942$export$afaea97e40b5ca70 = (emojiData)=>{
    const emojis = emojiData.emojis.map((emoji)=>{
        const newRepresentation = $a3109e0c4c1cb942$export$55077db3efc820aa(emoji.representation, emojiData.meta);
        const altRepresentation = $a3109e0c4c1cb942$export$aa9faa01267cb2e7(emoji.altRepresentations, emojiData.meta);
        const newSkinVariations = $a3109e0c4c1cb942$export$e3da49c88c2e54d5(emoji, emojiData.meta);
        // create trimmedServiceDesc which is emoji with no representations or skinVariations
        const { representation: representation, skinVariations: skinVariations, altRepresentations: altRepresentations, ...trimmedServiceDesc } = emoji;
        const response = {
            ...trimmedServiceDesc,
            representation: newRepresentation,
            skinVariations: newSkinVariations
        };
        return (0, $bwbaR.buildEmojiDescriptionWithAltRepresentation)(response, altRepresentation);
    });
    const mediaApiToken = emojiData.meta && emojiData.meta.mediaApiToken;
    return {
        emojis: emojis,
        mediaApiToken: mediaApiToken
    };
};
const $a3109e0c4c1cb942$var$getHeight = (fitToHeight)=>$a3109e0c4c1cb942$export$d39ce20a37bba061() > 1 ? fitToHeight * 2 : fitToHeight;
const $a3109e0c4c1cb942$export$b7e9058f156d8d19 = (emoji, fitToHeight)=>!!(fitToHeight && emoji.altRepresentation && $a3109e0c4c1cb942$var$getHeight(fitToHeight) > emoji.representation.height);

});
parcelRegister("9ith6", function(module, exports) {

$parcel$export(module.exports, "default", () => $f59357fd36664f50$export$2e2bcd8739ae039);
let $f59357fd36664f50$var$debugEnabled = false;
let $f59357fd36664f50$var$stacktracesEnabled = false;
function $f59357fd36664f50$export$748ada60eaf985cc(enable) {
    $f59357fd36664f50$var$debugEnabled = enable;
}
function $f59357fd36664f50$export$4f7017086af31c25(enable) {
    $f59357fd36664f50$var$stacktracesEnabled = enable;
}
function $f59357fd36664f50$export$2a858f450a2f66d() {
    if ($f59357fd36664f50$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $f59357fd36664f50$export$2e2bcd8739ae039(msg, ...args) {
    if ($f59357fd36664f50$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});


parcelRegister("cfDJ6", function(module, exports) {

$parcel$export(module.exports, "leftClick", () => $1ae9a6d368631fbc$export$34ebdaf2c517ae75);
function $1ae9a6d368631fbc$export$fd3cd03f8ac42187(event) {
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $1ae9a6d368631fbc$export$de744e30016241b0(oldPosition, newPosition) {
    if (!oldPosition || oldPosition.x !== newPosition.x || oldPosition.y !== newPosition.y) return true;
    return false;
}
function $1ae9a6d368631fbc$export$34ebdaf2c517ae75(reactEvent) {
    return reactEvent.button === 0 && !reactEvent.altKey && !reactEvent.ctrlKey && !reactEvent.metaKey && !reactEvent.shiftKey;
}

});

parcelRegister("POaM3", function(module, exports) {

$parcel$export(module.exports, "default", () => $81bf8c2f86b5c1f3$export$2e2bcd8739ae039);
/* DeleteButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $goLm2 = parcelRequire("goLm2");

var $kvxjE = parcelRequire("kvxjE");


var $bwwQh = parcelRequire("bwwQh");


var $5JBkS = parcelRequire("5JBkS");
const $81bf8c2f86b5c1f3$var$styles = {
    boxWrapperStyle: "_1bsbf6fq _4t3if6fq"
};
const $81bf8c2f86b5c1f3$var$deleteButton = null;
const $81bf8c2f86b5c1f3$export$28fc7374cf1206d4 = 'render-emoji-delete-button';
const $81bf8c2f86b5c1f3$var$DeleteButton = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_3um015vq _1e0c1txw _kqswstnw _154ix0bf _1xi2x0bf _1pbykb7n _13t3idpf",
            (0, $c7ea896bb618f785$export$b11fa39b56a371f6)
        ]),
        "data-testid": $81bf8c2f86b5c1f3$export$28fc7374cf1206d4,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $goLm2.default), {
            iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5JBkS.default), {
                xcss: $81bf8c2f86b5c1f3$var$styles.boxWrapperStyle,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kvxjE))), {
                    label: (0, $bwwQh.deleteEmojiLabel),
                    color: `var(--ds-text-subtle, ${(0, $dbda9f692ace54dd$export$c39c0fe0f26207ae)})`,
                    LEGACY_size: "small"
                })
            }),
            onClick: props.onClick,
            // TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
            appearance: "subtle-link",
            spacing: "none",
            testId: "emoji-delete-button",
            tabIndex: -1
        })
    });
var $81bf8c2f86b5c1f3$export$2e2bcd8739ae039 = $81bf8c2f86b5c1f3$var$DeleteButton;

});
parcelRegister("kvxjE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::23abdef56045225c72ffa19368031ad5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eee08bc6562259ed$var$_react = $eee08bc6562259ed$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eee08bc6562259ed$var$_crossCircle = $eee08bc6562259ed$var$_interopRequireDefault((parcelRequire("2bhht")));

var $eee08bc6562259ed$var$_crossCircle2 = $eee08bc6562259ed$var$_interopRequireDefault((parcelRequire("iK9zs")));
function $eee08bc6562259ed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "CrossCircleIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eee08bc6562259ed$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $eee08bc6562259ed$var$_react.default.createElement($eee08bc6562259ed$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $eee08bc6562259ed$var$_crossCircle2.default
    }, props));
$eee08bc6562259ed$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $eee08bc6562259ed$var$_default = module.exports.default = $eee08bc6562259ed$var$CrossCircleIcon;

});

const $c7ea896bb618f785$export$8633a0edef8e95dd = 'emoji-common-selected';
const $c7ea896bb618f785$export$860109dfd198259b = 'emoji-common-select-on-hover';
const $c7ea896bb618f785$export$1c10634420a08d8a = 'emoji-common-emoji-sprite';
const $c7ea896bb618f785$export$b06c4aab1d012063 = 'emoji-common-node';
const $c7ea896bb618f785$export$da61cef1c8919f7c = 'emoji-common-emoji-image';
const $c7ea896bb618f785$export$b11fa39b56a371f6 = 'emoji-common-deleteButton';
const $c7ea896bb618f785$export$11462c0756c24ab6 = 'emoji-common-main-styles';
const $c7ea896bb618f785$export$22b19c311e9caa4 = 'emoji-common-deletable';
const $c7ea896bb618f785$export$c7187bbd1a7a9244 = 'emoji-common-placeholder';
const $c7ea896bb618f785$export$b0fe756d87022806 = 'emoji-picker-add-emoji';


parcelRegister("4v9rR", function(module, exports) {

$parcel$export(module.exports, "ufoExperiences", () => $d716af77aaf9012f$export$615f888019c45765);
$parcel$export(module.exports, "sampledUfoRenderedEmoji", () => $d716af77aaf9012f$export$71c8cba6f1251ea9);
$parcel$export(module.exports, "hasUfoMarked", () => $d716af77aaf9012f$export$a9be054d2a5cedc0);
$parcel$export(module.exports, "sampledUfoEmojiResourceFetched", () => $d716af77aaf9012f$export$1466212a1606133);

var $9NDjD = parcelRequire("9NDjD");

var $iVQco = parcelRequire("iVQco");
var $l9Uwt = parcelRequire("l9Uwt");
var $3RlD1 = parcelRequire("3RlD1");

var $GOf9B = parcelRequire("GOf9B");
const $d716af77aaf9012f$var$createRenderExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $l9Uwt.ExperienceTypes).Load,
        performanceType: (0, $l9Uwt.ExperiencePerformanceTypes).PageSegmentLoad
    };
};
const $d716af77aaf9012f$var$createInlineExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $l9Uwt.ExperienceTypes).Experience,
        performanceType: (0, $l9Uwt.ExperiencePerformanceTypes).InlineResult
    };
};
const $d716af77aaf9012f$var$customEmojiTimings = [
    {
        key: (0, $9NDjD.UfoEmojiTimingsKeys).FMP,
        endMark: (0, $9NDjD.UfoEmojiTimings).FMP_END
    },
    {
        key: (0, $9NDjD.UfoEmojiTimingsKeys).METADATA,
        component: 'resourced-emoji',
        startMark: (0, $9NDjD.UfoEmojiTimings).METADATA_START,
        endMark: (0, $9NDjD.UfoEmojiTimings).METADATA_END
    },
    {
        key: (0, $9NDjD.UfoEmojiTimingsKeys).MEDIADATA,
        component: 'caching-emoji',
        startMark: (0, $9NDjD.UfoEmojiTimings).MEDIA_START,
        endMark: (0, $9NDjD.UfoEmojiTimings).MEDIA_END
    },
    {
        key: (0, $9NDjD.UfoEmojiTimingsKeys).MOUNTED,
        component: 'emoji',
        endMark: (0, $9NDjD.UfoEmojiTimings).MOUNTED_END
    },
    {
        key: (0, $9NDjD.UfoEmojiTimingsKeys).ONLOAD,
        startMark: (0, $9NDjD.UfoEmojiTimings).ONLOAD_START,
        endMark: (0, $9NDjD.UfoEmojiTimings).ONLOAD_END
    }
];
const $d716af77aaf9012f$export$615f888019c45765 = {
    'emoji-rendered': new (0, $iVQco.ConcurrentExperience)((0, $9NDjD.UfoExperienceName).EMOJI_RENDERED, {
        platform: {
            component: (0, $9NDjD.UfoComponentName).EMOJI
        },
        type: (0, $l9Uwt.ExperienceTypes).Operation,
        performanceType: (0, $l9Uwt.ExperiencePerformanceTypes).Custom,
        timings: $d716af77aaf9012f$var$customEmojiTimings
    }),
    'emoji-resource-fetched': new (0, $iVQco.ConcurrentExperience)((0, $9NDjD.UfoExperienceName).EMOJI_RESOURCE_FETCHED, $d716af77aaf9012f$var$createRenderExperience((0, $9NDjD.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-picker-opened': new (0, $3RlD1.UFOExperience)((0, $9NDjD.UfoExperienceName).EMOJI_PICKER_OPENED, $d716af77aaf9012f$var$createRenderExperience((0, $9NDjD.UfoComponentName).EMOJI_PICKER)),
    'emoji-selection-recorded': new (0, $3RlD1.UFOExperience)((0, $9NDjD.UfoExperienceName).EMOJI_SELECTION_RECORDED, $d716af77aaf9012f$var$createInlineExperience((0, $9NDjD.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-uploaded': new (0, $3RlD1.UFOExperience)((0, $9NDjD.UfoExperienceName).EMOJI_UPLOADED, $d716af77aaf9012f$var$createInlineExperience((0, $9NDjD.UfoComponentName).EMOJI_PICKER)),
    'emoji-searched': new (0, $3RlD1.UFOExperience)((0, $9NDjD.UfoExperienceName).EMOJI_SEARCHED, $d716af77aaf9012f$var$createInlineExperience((0, $9NDjD.UfoComponentName).EMOJI_PICKER))
};
const $d716af77aaf9012f$export$71c8cba6f1251ea9 = (emojiId)=>{
    return (0, $GOf9B.withSampling)($d716af77aaf9012f$export$615f888019c45765['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName));
};
const $d716af77aaf9012f$export$a9be054d2a5cedc0 = (ufoExperience, name)=>{
    return ufoExperience.metrics.marks.some((mask)=>mask.name === name);
};
const $d716af77aaf9012f$export$1466212a1606133 = (providerType)=>{
    return (0, $GOf9B.withSampling)($d716af77aaf9012f$export$615f888019c45765['emoji-resource-fetched'].getInstance(providerType));
};

});
parcelRegister("iVQco", function(module, exports) {

$parcel$export(module.exports, "ConcurrentExperience", () => $7dc3a7a7cdc91963$export$ac1cddfee07ba6ac);

var $kRl09 = parcelRequire("kRl09");

var $3RlD1 = parcelRequire("3RlD1");
class $7dc3a7a7cdc91963$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $3RlD1.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $kRl09.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});
parcelRegister("kRl09", function(module, exports) {

$parcel$export(module.exports, "ufolog", () => $66088c2c289e3a65$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $66088c2c289e3a65$export$d53d07b6034c4560);
class $66088c2c289e3a65$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($66088c2c289e3a65$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($66088c2c289e3a65$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $66088c2c289e3a65$export$4ab84f6f04f6566d = new $66088c2c289e3a65$var$UFOLogger();
const $66088c2c289e3a65$export$b4958caff08a0960 = (...args)=>{
    $66088c2c289e3a65$export$4ab84f6f04f6566d.log(...args);
};
const $66088c2c289e3a65$export$d53d07b6034c4560 = (...args)=>{
    $66088c2c289e3a65$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("3RlD1", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", () => $3a89eb8fd7f06745$export$c00d22927c60484a);

var $9kPpG = parcelRequire("9kPpG");
class $3a89eb8fd7f06745$export$c00d22927c60484a extends (0, $9kPpG.UFOAbstractExperience) {
}

});
parcelRegister("9kPpG", function(module, exports) {

$parcel$export(module.exports, "UFOAbstractExperience", () => $1b1f3ec6e2398ef6$export$d31c89db257648c);

var $7Jxgt = parcelRequire("7Jxgt");


var $3v0Qk = parcelRequire("3v0Qk");

var $kRl09 = parcelRequire("kRl09");

var $3TRO5 = parcelRequire("3TRO5");

var $45WtH = parcelRequire("45WtH");

var $gtZnv = parcelRequire("gtZnv");

var $3IYpH = parcelRequire("3IYpH");

var $2QVEp = parcelRequire("2QVEp");

var $eGU6s = parcelRequire("eGU6s");

var $l9Uwt = parcelRequire("l9Uwt");
const $1b1f3ec6e2398ef6$var$getPageVisibleState = ()=>{
    return !(0, $3IYpH.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $45WtH.PageVisibleState).VISIBLE : (0, $45WtH.PageVisibleState).HIDDEN;
};
const $1b1f3ec6e2398ef6$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $gtZnv.roundPerfNow)();
};
class $1b1f3ec6e2398ef6$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $2QVEp.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $45WtH.PageVisibleState).MIXED;
            (0, $3TRO5.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $1b1f3ec6e2398ef6$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $l9Uwt.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $l9Uwt.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $kRl09.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $eGU6s.canTransition)(this.state, newState)) {
            (0, $kRl09.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $2QVEp.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $1b1f3ec6e2398ef6$export$c753e8669d30c8ad(timestamp);
                this.uuid = (0, $7Jxgt.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $1b1f3ec6e2398ef6$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $3v0Qk.getGlobalEventStream)().push((0, $3v0Qk.unsubscribeEvent)((0, $45WtH.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $kRl09.ufolog)('this.parent', this.parent);
                (0, $3v0Qk.getGlobalEventStream)().push((0, $3v0Qk.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $kRl09.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $kRl09.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $2QVEp.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $1b1f3ec6e2398ef6$var$getPageVisibleState();
            (0, $3TRO5.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $kRl09.ufolog)('subscribed', this.id);
                (0, $3v0Qk.getGlobalEventStream)().push((0, $3v0Qk.subscribeEvent)((0, $45WtH.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $45WtH.FMP_MARK) && name !== (0, $45WtH.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $kRl09.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $1b1f3ec6e2398ef6$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $2QVEp.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $45WtH.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $45WtH.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $kRl09.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $3TRO5.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $2QVEp.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $2QVEp.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $2QVEp.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $kRl09.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $87a363f3fbcfb534$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $87a363f3fbcfb534$export$2295b861f318254a = '0.1.5';

parcelRegister("3v0Qk", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", () => $d0d1fdd9ac696ac0$export$6123a44dc2384540);
$parcel$export(module.exports, "subscribeEvent", () => $d0d1fdd9ac696ac0$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $d0d1fdd9ac696ac0$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $d0d1fdd9ac696ac0$export$7c957416596ca127);

var $kRl09 = parcelRequire("kRl09");

var $45WtH = parcelRequire("45WtH");
const $d0d1fdd9ac696ac0$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $d0d1fdd9ac696ac0$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $d0d1fdd9ac696ac0$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $d0d1fdd9ac696ac0$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $kRl09.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $d0d1fdd9ac696ac0$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $45WtH.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $d0d1fdd9ac696ac0$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $45WtH.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $d0d1fdd9ac696ac0$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $45WtH.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("45WtH", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $be9b91ce87ea36d6$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $be9b91ce87ea36d6$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $be9b91ce87ea36d6$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $be9b91ce87ea36d6$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $be9b91ce87ea36d6$export$837e0f79a8056912);
var $be9b91ce87ea36d6$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $be9b91ce87ea36d6$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $be9b91ce87ea36d6$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $be9b91ce87ea36d6$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $be9b91ce87ea36d6$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $be9b91ce87ea36d6$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $be9b91ce87ea36d6$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $be9b91ce87ea36d6$export$9f2bf58999404c75 = 'fmp';
const $be9b91ce87ea36d6$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("3TRO5", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $5dc3d3b236e6c34d$export$13e680397ec8f3eb);

var $3IYpH = parcelRequire("3IYpH");
class $5dc3d3b236e6c34d$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $3IYpH.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $5dc3d3b236e6c34d$export$13e680397ec8f3eb = new $5dc3d3b236e6c34d$var$VisibilityChangeObserver();

});
parcelRegister("3IYpH", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", () => $f77e4cfcdfb5e8b3$export$15e172712955e18f);
const $f77e4cfcdfb5e8b3$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("gtZnv", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", () => $a17d60c7847e308c$export$5f490af6b2b115cf);
const $a17d60c7847e308c$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("2QVEp", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", () => $e681e94d33bde1d7$export$81b70111112841a0);
const $e681e94d33bde1d7$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("eGU6s", function(module, exports) {

$parcel$export(module.exports, "canTransition", () => $90c4246d37e50b9a$export$178881f329fdb81f);

var $2QVEp = parcelRequire("2QVEp");
const $90c4246d37e50b9a$var$UFOStateAvailableTransitions = {
    [(0, $2QVEp.UFOExperienceState).NOT_STARTED.id]: [
        (0, $2QVEp.UFOExperienceState).STARTED.id
    ],
    [(0, $2QVEp.UFOExperienceState).STARTED.id]: [
        (0, $2QVEp.UFOExperienceState).IN_PROGRESS.id,
        (0, $2QVEp.UFOExperienceState).BLOCKED.id,
        (0, $2QVEp.UFOExperienceState).SUCCEEDED.id,
        (0, $2QVEp.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $2QVEp.UFOExperienceState).FAILED.id,
        (0, $2QVEp.UFOExperienceState).ABORTED.id
    ],
    [(0, $2QVEp.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $2QVEp.UFOExperienceState).BLOCKED.id,
        (0, $2QVEp.UFOExperienceState).SUCCEEDED.id,
        (0, $2QVEp.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $2QVEp.UFOExperienceState).FAILED.id,
        (0, $2QVEp.UFOExperienceState).ABORTED.id
    ],
    [(0, $2QVEp.UFOExperienceState).BLOCKED.id]: [
        (0, $2QVEp.UFOExperienceState).RECOVERED.id,
        (0, $2QVEp.UFOExperienceState).ABORTED.id
    ],
    [(0, $2QVEp.UFOExperienceState).RECOVERED.id]: [
        (0, $2QVEp.UFOExperienceState).STARTED.id,
        (0, $2QVEp.UFOExperienceState).SUCCEEDED.id,
        (0, $2QVEp.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $2QVEp.UFOExperienceState).FAILED.id,
        (0, $2QVEp.UFOExperienceState).ABORTED.id
    ],
    [(0, $2QVEp.UFOExperienceState).SUCCEEDED.id]: [
        (0, $2QVEp.UFOExperienceState).STARTED.id
    ],
    [(0, $2QVEp.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $2QVEp.UFOExperienceState).SUCCEEDED.id,
        (0, $2QVEp.UFOExperienceState).FAILED.id,
        (0, $2QVEp.UFOExperienceState).ABORTED.id
    ],
    [(0, $2QVEp.UFOExperienceState).FAILED.id]: [
        (0, $2QVEp.UFOExperienceState).STARTED.id
    ],
    [(0, $2QVEp.UFOExperienceState).ABORTED.id]: [
        (0, $2QVEp.UFOExperienceState).STARTED.id
    ]
};
const $90c4246d37e50b9a$export$178881f329fdb81f = (state1, state2)=>{
    return $90c4246d37e50b9a$var$UFOStateAvailableTransitions[state1.id] && $90c4246d37e50b9a$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});

parcelRegister("l9Uwt", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", () => $b4b381f65c55605d$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $b4b381f65c55605d$export$cc26007c03242fff);
var $b4b381f65c55605d$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $b4b381f65c55605d$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});




parcelRegister("GOf9B", function(module, exports) {

$parcel$export(module.exports, "withSampling", () => $5f13c867343793c6$export$dc2f0946255b3f89);
const $5f13c867343793c6$export$c7c4959fece2f3ec = {};
const $5f13c867343793c6$export$cdff9a865136ae27 = ()=>{
    for (const prop of Object.getOwnPropertyNames($5f13c867343793c6$export$c7c4959fece2f3ec))delete $5f13c867343793c6$export$c7c4959fece2f3ec[prop];
};
const $5f13c867343793c6$export$1c967630b3ea2d58 = (rate)=>{
    if (rate === 1) return true;
    if (rate === 0) return false;
    return Math.random() * rate <= 1;
};
const $5f13c867343793c6$var$hasSampledFromStart = (experience)=>{
    if (!$5f13c867343793c6$export$c7c4959fece2f3ec[experience.id]) return false;
    if (experience.instanceId) // if the instance of concurrent exp has been sampled from start, allow it.
    return $5f13c867343793c6$export$c7c4959fece2f3ec[experience.id].sampledInstance[experience.instanceId];
    return $5f13c867343793c6$export$c7c4959fece2f3ec[experience.id].sampled;
};
const $5f13c867343793c6$export$dc2f0946255b3f89 = (ufoExperience)=>{
    const init = ()=>{
        if (!$5f13c867343793c6$export$c7c4959fece2f3ec[ufoExperience.id]) $5f13c867343793c6$export$c7c4959fece2f3ec[ufoExperience.id] = {
            sampled: false,
            sampledInstance: {}
        };
    };
    const start = async (options)=>{
        // check if the experience has already sampled before
        if ($5f13c867343793c6$var$hasSampledFromStart(ufoExperience)) return;
        const isSampled = options.samplingFunc || $5f13c867343793c6$export$1c967630b3ea2d58;
        if (!isSampled(options.samplingRate)) {
            if (ufoExperience.instanceId) $5f13c867343793c6$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = false;
            $5f13c867343793c6$export$c7c4959fece2f3ec[ufoExperience.id].sampled = false;
            return;
        }
        // update sampled records
        if (ufoExperience.instanceId) {
            $5f13c867343793c6$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = true;
            $5f13c867343793c6$export$c7c4959fece2f3ec[ufoExperience.id].sampled = true;
        }
        return ufoExperience.start(options.startTime);
    };
    const success = async (config)=>{
        if (!$5f13c867343793c6$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.success(config);
    };
    const failure = async (config)=>{
        if (!$5f13c867343793c6$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.failure(config);
    };
    const abort = async (config)=>{
        if (!$5f13c867343793c6$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.abort(config);
    };
    const addMetadata = (data)=>{
        if (!$5f13c867343793c6$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.addMetadata(data);
    };
    const mark = (name, timestamp)=>{
        if (!$5f13c867343793c6$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.mark(name, timestamp);
    };
    const markFMP = (timestamp)=>{
        if (!$5f13c867343793c6$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markFMP(timestamp);
    };
    const markInlineResponse = (timestamp)=>{
        if (!$5f13c867343793c6$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markInlineResponse(timestamp);
    };
    init();
    return {
        ...ufoExperience,
        start: start,
        addMetadata: addMetadata,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};

});


parcelRegister("k4VWQ", function(module, exports) {

$parcel$export(module.exports, "useSampledUFOComponentExperience", () => $4caf7538162e4e0a$export$f959821a7419dee1);

var $5uXOq = parcelRequire("5uXOq");

var $GOf9B = parcelRequire("GOf9B");
const $4caf7538162e4e0a$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $5uXOq.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $4caf7538162e4e0a$export$f959821a7419dee1 = (experience, samplingRate, metadata)=>{
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            (0, $GOf9B.withSampling)(experience).abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $4caf7538162e4e0a$var$useConstructor(()=>{
        (0, $GOf9B.withSampling)(experience).start({
            samplingRate: samplingRate
        });
        const isMetadataEmpty = Object.keys(experience.metadata).length === 0;
        if (metadata && isMetadataEmpty) experience.addMetadata(metadata);
    });
    return null;
};

});

parcelRegister("4TD8f", function(module, exports) {

$parcel$export(module.exports, "default", () => $b81cf922dae81a2a$export$2e2bcd8739ae039);
const $b81cf922dae81a2a$var$result = {
    mac: false,
    supportsIntersectionObserver: false
};
if (typeof navigator !== 'undefined') {
    $b81cf922dae81a2a$var$result.mac = /Mac/.test(navigator.platform);
    $b81cf922dae81a2a$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
}
var $b81cf922dae81a2a$export$2e2bcd8739ae039 = $b81cf922dae81a2a$var$result;

});

parcelRegister("734pQ", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $01daff91eaa8b9d1$export$2f62ee6831462844);

var $6ggyj = parcelRequire("6ggyj");

var $4TD8f = parcelRequire("4TD8f");
const $01daff91eaa8b9d1$export$2f62ee6831462844 = (options)=>{
    const hookResult = (0, $6ggyj.useInView)(options);
    if (!(0, $4TD8f.default).supportsIntersectionObserver) // Unsupported, return no `ref` and default `inView` true value
    return [
        undefined,
        true
    ];
    return hookResult;
};

});
parcelRegister("6ggyj", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $48f113a7cf9419a6$export$2f62ee6831462844);

var $5uXOq = parcelRequire("5uXOq");
function $48f113a7cf9419a6$var$_extends() {
    $48f113a7cf9419a6$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $48f113a7cf9419a6$var$_extends.apply(this, arguments);
}
function $48f113a7cf9419a6$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $48f113a7cf9419a6$var$_setPrototypeOf(subClass, superClass);
}
function $48f113a7cf9419a6$var$_setPrototypeOf(o, p) {
    $48f113a7cf9419a6$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $48f113a7cf9419a6$var$_setPrototypeOf(o, p);
}
function $48f113a7cf9419a6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $48f113a7cf9419a6$var$observerMap = new Map();
var $48f113a7cf9419a6$var$RootIds = new WeakMap();
var $48f113a7cf9419a6$var$rootId = 0;
var $48f113a7cf9419a6$var$unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/ function $48f113a7cf9419a6$export$2ef3a60ee1f37bec(inView) {
    $48f113a7cf9419a6$var$unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */ function $48f113a7cf9419a6$var$getRootId(root) {
    if (!root) return '0';
    if ($48f113a7cf9419a6$var$RootIds.has(root)) return $48f113a7cf9419a6$var$RootIds.get(root);
    $48f113a7cf9419a6$var$rootId += 1;
    $48f113a7cf9419a6$var$RootIds.set(root, $48f113a7cf9419a6$var$rootId.toString());
    return $48f113a7cf9419a6$var$RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */ function $48f113a7cf9419a6$var$optionsToId(options) {
    return Object.keys(options).sort().filter(function(key) {
        return options[key] !== undefined;
    }).map(function(key) {
        return key + "_" + (key === 'root' ? $48f113a7cf9419a6$var$getRootId(options.root) : options[key]);
    }).toString();
}
function $48f113a7cf9419a6$var$createObserver(options) {
    // Create a unique ID for this observer instance, based on the root, root margin and threshold.
    var id = $48f113a7cf9419a6$var$optionsToId(options);
    var instance = $48f113a7cf9419a6$var$observerMap.get(id);
    if (!instance) {
        // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
        var elements = new Map();
        var thresholds;
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                var _elements$get;
                // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
                // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
                var inView = entry.isIntersecting && thresholds.some(function(threshold) {
                    return entry.intersectionRatio >= threshold;
                }); // @ts-ignore support IntersectionObserver v2
                if (options.trackVisibility && typeof entry.isVisible === 'undefined') // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
                // @ts-ignore
                entry.isVisible = inView;
                (_elements$get = elements.get(entry.target)) == null || _elements$get.forEach(function(callback) {
                    callback(inView, entry);
                });
            });
        }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $48f113a7cf9419a6$var$observerMap.set(id, instance);
    }
    return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */ function $48f113a7cf9419a6$export$d1203567a167490e(element, callback, options, fallbackInView) {
    if (options === void 0) options = {};
    if (fallbackInView === void 0) fallbackInView = $48f113a7cf9419a6$var$unsupportedValue;
    if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
        var bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return function() {};
    } // An observer with the same options can be reused, so lets use this fact
    var _createObserver = $48f113a7cf9419a6$var$createObserver(options), id = _createObserver.id, observer = _createObserver.observer, elements = _createObserver.elements; // Register the callback listener for this element
    var callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        // Remove the callback from the callback list
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            // No more callback exists for element, so destroy it
            elements["delete"](element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            // No more elements are being observer by this instance, so destroy it
            observer.disconnect();
            $48f113a7cf9419a6$var$observerMap["delete"](id);
        }
    };
}
var $48f113a7cf9419a6$var$_excluded = [
    "children",
    "as",
    "triggerOnce",
    "threshold",
    "root",
    "rootMargin",
    "onChange",
    "skip",
    "trackVisibility",
    "delay",
    "initialInView",
    "fallbackInView"
];
function $48f113a7cf9419a6$var$isPlainChildren(props) {
    return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */ var $48f113a7cf9419a6$export$a62107ca74432f44 = /*#__PURE__*/ function(_React$Component) {
    $48f113a7cf9419a6$var$_inheritsLoose(InView, _React$Component);
    function InView(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.node = null;
        _this._unobserveCb = null;
        _this.handleNode = function(node) {
            if (_this.node) {
                // Clear the old observer, before we start observing a new element
                _this.unobserve();
                if (!node && !_this.props.triggerOnce && !_this.props.skip) // Reset the state if we get a new node, and we aren't ignoring updates
                _this.setState({
                    inView: !!_this.props.initialInView,
                    entry: undefined
                });
            }
            _this.node = node ? node : null;
            _this.observeNode();
        };
        _this.handleChange = function(inView, entry) {
            if (inView && _this.props.triggerOnce) // If `triggerOnce` is true, we should stop observing the element.
            _this.unobserve();
            if (!$48f113a7cf9419a6$var$isPlainChildren(_this.props)) // Store the current State, so we can pass it to the children in the next render update
            // There's no reason to update the state for plain children, since it's not used in the rendering.
            _this.setState({
                inView: inView,
                entry: entry
            });
            if (_this.props.onChange) // If the user is actively listening for onChange, always trigger it
            _this.props.onChange(inView, entry);
        };
        _this.state = {
            inView: !!props.initialInView,
            entry: undefined
        };
        return _this;
    }
    var _proto = InView.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        // If a IntersectionObserver option changed, reinit the observer
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unobserve();
        this.node = null;
    };
    _proto.observeNode = function observeNode() {
        if (!this.node || this.props.skip) return;
        var _this$props = this.props, threshold = _this$props.threshold, root = _this$props.root, rootMargin = _this$props.rootMargin, trackVisibility = _this$props.trackVisibility, delay = _this$props.delay, fallbackInView = _this$props.fallbackInView;
        this._unobserveCb = $48f113a7cf9419a6$export$d1203567a167490e(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            // @ts-ignore
            trackVisibility: trackVisibility,
            // @ts-ignore
            delay: delay
        }, fallbackInView);
    };
    _proto.unobserve = function unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    };
    _proto.render = function render() {
        if (!$48f113a7cf9419a6$var$isPlainChildren(this.props)) {
            var _this$state = this.state, inView = _this$state.inView, entry = _this$state.entry;
            return this.props.children({
                inView: inView,
                entry: entry,
                ref: this.handleNode
            });
        }
        var _this$props2 = this.props, children = _this$props2.children, as = _this$props2.as, props = $48f113a7cf9419a6$var$_objectWithoutPropertiesLoose(_this$props2, $48f113a7cf9419a6$var$_excluded);
        return /*#__PURE__*/ $5uXOq.createElement(as || 'div', $48f113a7cf9419a6$var$_extends({
            ref: this.handleNode
        }, props), children);
    };
    return InView;
}($5uXOq.Component);
$48f113a7cf9419a6$export$a62107ca74432f44.displayName = 'InView';
$48f113a7cf9419a6$export$a62107ca74432f44.defaultProps = {
    threshold: 0,
    triggerOnce: false,
    initialInView: false
};
/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */ function $48f113a7cf9419a6$export$2f62ee6831462844(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, threshold = _ref.threshold, delay = _ref.delay, trackVisibility = _ref.trackVisibility, rootMargin = _ref.rootMargin, root = _ref.root, triggerOnce = _ref.triggerOnce, skip = _ref.skip, initialInView = _ref.initialInView, fallbackInView = _ref.fallbackInView;
    var unobserve = $5uXOq.useRef();
    var _React$useState = $5uXOq.useState({
        inView: !!initialInView
    }), state = _React$useState[0], setState = _React$useState[1];
    var setRef = $5uXOq.useCallback(function(node) {
        if (unobserve.current !== undefined) {
            unobserve.current();
            unobserve.current = undefined;
        } // Skip creating the observer
        if (skip) return;
        if (node) unobserve.current = $48f113a7cf9419a6$export$d1203567a167490e(node, function(inView, entry) {
            setState({
                inView: inView,
                entry: entry
            });
            if (entry.isIntersecting && triggerOnce && unobserve.current) {
                // If it should only trigger once, unobserve the element after it's inView
                unobserve.current();
                unobserve.current = undefined;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            // @ts-ignore
            trackVisibility: trackVisibility,
            // @ts-ignore
            delay: delay
        }, fallbackInView);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // eslint-disable-next-line react-hooks/exhaustive-deps
        Array.isArray(threshold) ? threshold.toString() : threshold,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    /* eslint-disable-next-line */ (0, $5uXOq.useEffect)(function() {
        if (!unobserve.current && state.entry && !triggerOnce && !skip) // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
        // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
        setState({
            inView: !!initialInView
        });
    });
    var result = [
        setRef,
        state.inView,
        state.entry
    ]; // Support object destructuring, by adding the specific values.
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}

});


parcelRegister("lu2ov", function(module, exports) {

$parcel$export(module.exports, "DeletableEmojiTooltipContent", () => $52c5dd7ea9e13dd1$export$4727956877b6f612);
$parcel$export(module.exports, "DeletableEmojiTooltipContentForScreenReader", () => $52c5dd7ea9e13dd1$export$d151e4941072147c);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $bjC98 = parcelRequire("bjC98");

var $440tx = parcelRequire("440tx");

var $hZvqn = parcelRequire("hZvqn");

var $8iEvh = parcelRequire("8iEvh");
const $52c5dd7ea9e13dd1$export$4727956877b6f612 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $440tx.ToolTipContentWithKeymap), {
        description: formatMessage((0, $bjC98.messages).deleteEmojiTooltip),
        keymap: (0, $hZvqn.backspace)
    });
};
const $52c5dd7ea9e13dd1$export$d151e4941072147c = ({ emoji: emoji })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8iEvh.default), {
        id: `screenreader-emoji-${emoji.id}`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $bjC98.messages).deleteEmojiTooltipForScreenreader,
            values: {
                shortName: emoji.shortName
            }
        })
    });
};

});
parcelRegister("440tx", function(module, exports) {

$parcel$export(module.exports, "ToolTipContentWithKeymap", () => $2f2bef88e0cb8295$export$c7308f5f9ed494ac);
/* ToolTipContentWithKeymap.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hZvqn = parcelRequire("hZvqn");
const $2f2bef88e0cb8295$var$tooltipShortcutStyle = null;
const $2f2bef88e0cb8295$export$c7308f5f9ed494ac = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ description: description, shortcutOverride: shortcutOverride, keymap: keymap })=>{
    const shortcut = shortcutOverride || keymap && (0, $hZvqn.formatShortcut)(keymap);
    return shortcut || description ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            description,
            shortcut && description && '\u00A0',
            shortcut && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    "_2rko1l7b _bfhk17rn _ca0qidpf _n3tdidpf _19bvv77o _u5f3v77o _jqf61teg"
                ]),
                children: shortcut
            })
        ]
    }) : null;
});

});
parcelRegister("hZvqn", function(module, exports) {

$parcel$export(module.exports, "backspace", () => $48dec913f729965e$export$1ea584ca7009bcc1);
$parcel$export(module.exports, "formatShortcut", () => $48dec913f729965e$export$384a290f8c265cc5);
/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ 
var $4TD8f = parcelRequire("4TD8f");
const $48dec913f729965e$export$1ea584ca7009bcc1 = $48dec913f729965e$export$7e6b588cc98b34f1('Backspace', 'Backspace');
function $48dec913f729965e$export$d8a7f422d8d42038(description, windows, mac, common) {
    return {
        description: description,
        windows: windows.replace(/Mod/i, 'Ctrl'),
        mac: mac.replace(/Mod/i, 'Cmd'),
        common: common
    };
}
function $48dec913f729965e$export$7e6b588cc98b34f1(description, common) {
    const windows = common.replace(/Mod/i, 'Ctrl');
    const mac = common.replace(/Mod/i, 'Cmd');
    return $48dec913f729965e$export$d8a7f422d8d42038(description, windows, mac, common);
}
const $48dec913f729965e$export$8d734690d3a46118 = {
    // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    ARROWLEFT: '\u2190',
    ARROWRIGHT: '\u2192',
    ARROWUP: '\u2191',
    ARROWDOWN: '\u2193'
};
function $48dec913f729965e$export$384a290f8c265cc5(keymap) {
    let shortcut;
    if ((0, $4TD8f.default).mac) // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    shortcut = keymap.mac.replace(/Cmd/i, '\u2318').replace(/Shift/i, '\u21E7').replace(/Ctrl/i, '\u2303').replace(/Alt/i, '\u2325').replace(/Backspace/i, '\u232B').replace(/Enter/i, '\u23CE');
    else shortcut = keymap.windows.replace(/Backspace/i, '\u232B');
    const keys = shortcut.split('-');
    let lastKey = keys[keys.length - 1];
    if (lastKey.length === 1) // capitalise single letters
    lastKey = lastKey.toUpperCase();
    keys[keys.length - 1] = $48dec913f729965e$export$8d734690d3a46118[lastKey.toUpperCase()] || lastKey;
    return keys.join((0, $4TD8f.default).mac ? '' : '+');
}

});



parcelRegister("by6z1", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $22d86ec9025e7690$export$48d7c418edadb60c);

var $6cAn5 = parcelRequire("6cAn5");
function $22d86ec9025e7690$export$48d7c418edadb60c() {
    try {
        return Boolean(// In most places there is no document when running on server-side
        typeof document === 'undefined' || // When SSRing editor with full cycle mode we define the document
        // Check Confluence specific environment variable
        typeof $6cAn5 !== 'undefined' && $6cAn5?.env?.REACT_SSR);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}

});


parcelRegister("lEPER", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f61fc63044a3a39$export$2e2bcd8739ae039);
/* EmojiPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hFKXd = parcelRequire("hFKXd");

var $bwwQh = parcelRequire("bwwQh");

const $3f61fc63044a3a39$var$placeholderContainer = null;
const $3f61fc63044a3a39$var$easeSweep = null;
const $3f61fc63044a3a39$var$placeholderContainerAnimated = null;
const $3f61fc63044a3a39$export$73987987fac5266b = (shortName)=>`emoji-placeholder-${shortName}`;
const $3f61fc63044a3a39$var$EmojiPlaceholder = (props)=>{
    const { shortName: shortName, size: size = (0, $bwwQh.defaultEmojiHeight), showTooltip: showTooltip, representation: representation, loading: loading = false } = props;
    let scaledWidth;
    let scaledHeight;
    if (representation && size) {
        const width = representation.width;
        const height = representation.height;
        if (width && height) {
            scaledWidth = size / height * width;
            scaledHeight = size;
        }
    }
    const width = scaledWidth || size;
    const height = scaledHeight || size;
    const style = {
        fill: 'f7f7f7',
        minWidth: `${width}px`,
        width: `${width}px`,
        height: `${height}px`
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": $3f61fc63044a3a39$export$73987987fac5266b(shortName),
        "aria-busy": loading,
        role: "status",
        "aria-label": shortName,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _2rkosqtm _1reo15vq _18m915vq _kqswh2mm _1e0c1o8l _bfhkttw1 _s7n4nkob _o5721q9c _y3gn1h6o",
            loading && !(0, $hFKXd.fg)('cc_complexit_fe_remove_emoji_animation') && "",
            loading && !(0, $hFKXd.fg)('cc_complexit_fe_remove_emoji_animation') && "_1kt9b3bt _cfu11ule _1cs8stnw _1rusiw92 _kfgt1osq _1mp41osq _1088zfu5 _joxl9cwz _zo24167c _evp612c5",
            (0, $c7ea896bb618f785$export$c7187bbd1a7a9244)
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        title: showTooltip ? shortName : ''
    });
};
var $3f61fc63044a3a39$export$2e2bcd8739ae039 = $3f61fc63044a3a39$var$EmojiPlaceholder;

});

parcelRegister("9VLPC", function(module, exports) {

$parcel$export(module.exports, "EmojiCommonProvider", () => $167dc9bae7f52302$export$1120e666998e21b5);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8mHKh = parcelRequire("8mHKh");
const $167dc9bae7f52302$export$1120e666998e21b5 = (props)=>{
    if (props.emojiProvider) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8mHKh.EmojiContextProvider), {
        emojiContextValue: {
            emoji: {
                emojiProvider: props.emojiProvider
            }
        },
        children: props.children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: props.children
    });
};

});
parcelRegister("8mHKh", function(module, exports) {

$parcel$export(module.exports, "EmojiContextProvider", () => $e31a6d5da5f0d61f$export$f4a09143833145ed);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dKJyh = parcelRequire("dKJyh");

var $9ith6 = parcelRequire("9ith6");
const $e31a6d5da5f0d61f$export$f4a09143833145ed = ({ children: children, emojiContextValue: emojiContextValue })=>{
    const memoizedEmojiContextValue = (0, $5uXOq.useMemo)(()=>emojiContextValue, [
        emojiContextValue
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // trigger emoji fetching
        async function fetchEmojiProvider() {
            try {
                await memoizedEmojiContextValue?.emoji.emojiProvider.fetchEmojiProvider();
            } catch (error) {
                (0, $9ith6.default)('fetchEmojiProvider error catched from outside', error);
            }
        }
        if (memoizedEmojiContextValue?.emoji.emojiProvider.onlyFetchOnDemand) {
            const isFetchingOnDemand = memoizedEmojiContextValue?.emoji.emojiProvider.onlyFetchOnDemand();
            if (!isFetchingOnDemand) fetchEmojiProvider();
        } else fetchEmojiProvider();
    }, [
        memoizedEmojiContextValue
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dKJyh.EmojiContext).Provider, {
        value: memoizedEmojiContextValue,
        children: children
    });
};

});
parcelRegister("dKJyh", function(module, exports) {

$parcel$export(module.exports, "EmojiContext", () => $3ffeeeed2d5f20d7$export$9fab6c37a453c65e);

var $5uXOq = parcelRequire("5uXOq");
const $3ffeeeed2d5f20d7$export$9fab6c37a453c65e = (0, $5uXOq.createContext)(null);

});




parcelRegister("3UZxO", function(module, exports) {

$parcel$export(module.exports, "UfoErrorBoundary", () => $e45c8d7af8de4e5e$export$5ef1c2550074a375);

var $5uXOq = parcelRequire("5uXOq");
class $e45c8d7af8de4e5e$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch(error, errorInfo) {
        for (const exp of this.props.experiences){
            const { name: name, message: message } = error;
            const infoStack = errorInfo.componentStack && typeof errorInfo.componentStack !== 'undefined' ? errorInfo.componentStack : undefined;
            exp.failure({
                metadata: {
                    source: 'UfoErrorBoundary',
                    reason: 'error',
                    error: {
                        name: name,
                        message: message,
                        infoStack: infoStack
                    }
                }
            });
        }
    }
    render() {
        return this.props.children;
    }
}

});



parcelRegister("4pRS2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ade77193038d3511$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ioLBV = parcelRequire("ioLBV");

var $hFKXd = parcelRequire("hFKXd");

var $gJUKS = parcelRequire("gJUKS");
var $ade77193038d3511$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)(function MentionItem(props) {
    const { eventHandlers: eventHandlers, id: id, providers: providers, text: text, accessLevel: accessLevel, localId: localId } = props;
    const inlineAnnotationProps = (0, $gJUKS.useInlineAnnotationProps)(props);
    if ((0, $hFKXd.fg)('editor_inline_comments_on_inline_nodes')) return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...inlineAnnotationProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ioLBV.default), {
            id: id,
            text: text,
            accessLevel: accessLevel,
            providers: providers,
            localId: localId,
            eventHandlers: eventHandlers && eventHandlers.mention
        })
    }));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ioLBV.default), {
        id: id,
        text: text,
        accessLevel: accessLevel,
        providers: providers,
        localId: localId,
        eventHandlers: eventHandlers && eventHandlers.mention
    });
});

});
parcelRegister("ioLBV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5597c2979c2b5a15$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-class-components */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $hFKXd = parcelRequire("hFKXd");

var $4b4i9 = parcelRequire("4b4i9");
var $hiA9t = parcelRequire("hiA9t");

var $ddGVF = parcelRequire("ddGVF");
class $5597c2979c2b5a15$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    constructor(props){
        super(props), this.renderWithProvider = (providers)=>{
            const { accessLevel: accessLevel, eventHandlers: eventHandlers, id: id, text: text, localId: localId } = this.props;
            const { mentionProvider: mentionProvider, profilecardProvider: profilecardProvider } = providers;
            if ((0, $hFKXd.fg)('platform_editor_react18_mention_with_provider_fix') || (0, $hFKXd.fg)('platform_editor_react18_mention_with_provider_jira')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ddGVF.MentionWithProviders), {
                id: id,
                text: text,
                accessLevel: accessLevel,
                localId: localId,
                eventHandlers: eventHandlers,
                mentionProvider: mentionProvider,
                profilecardProvider: profilecardProvider
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ddGVF.MentionWithProvidersOld), {
                id: id,
                text: text,
                accessLevel: accessLevel,
                localId: localId,
                eventHandlers: eventHandlers,
                mentionProvider: mentionProvider,
                profilecardProvider: profilecardProvider
            });
        };
        this.providerFactory = props.providers || new (0, $4b4i9.default)();
    }
    componentWillUnmount() {
        if (!this.props.providers) // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
    }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hiA9t.WithProviders), {
            providers: [
                'mentionProvider',
                'profilecardProvider'
            ],
            providerFactory: this.providerFactory,
            renderNode: this.renderWithProvider
        });
    }
}

});
parcelRegister("ddGVF", function(module, exports) {

$parcel$export(module.exports, "MentionWithProviders", () => $a7685c9ca4d4c44d$export$cd21803c89efe790);
$parcel$export(module.exports, "MentionWithProvidersOld", () => $a7685c9ca4d4c44d$export$7279f5a9685c37e0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $b7bHf = parcelRequire("b7bHf");

var $1L4Cd = parcelRequire("1L4Cd");
const $a7685c9ca4d4c44d$var$GENERIC_USER_IDS = [
    'HipChat',
    'all',
    'here'
];
const $a7685c9ca4d4c44d$var$noop = ()=>{};
const $a7685c9ca4d4c44d$export$cd21803c89efe790 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ accessLevel: accessLevel, eventHandlers: eventHandlers, id: id, mentionProvider: mentionProvider, profilecardProvider: profilecardProviderResolver, text: text, localId: localId })=>{
    const [profilecardProvider, setProfilecardProvider] = (0, $5uXOq.useState)(null);
    const mountedRef = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    (0, $5uXOq.useLayoutEffect)(()=>{
        // We are not using async/await here to avoid having an intermediate Promise
        // introduced by the transpiler.
        // This will allow consumer to use a SynchronousPromise.resolve and avoid useless
        // rerendering
        profilecardProviderResolver?.then((result)=>{
            if (mountedRef.current) setProfilecardProvider(result);
        }).catch(()=>{
            if (mountedRef.current) setProfilecardProvider(null);
        });
    }, [
        profilecardProviderResolver
    ]);
    const MentionComponent = profilecardProvider && profilecardProviderResolver && $a7685c9ca4d4c44d$var$GENERIC_USER_IDS.indexOf(id) === -1 ? (0, $1L4Cd.default) : (0, $b7bHf.default);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(MentionComponent, {
        id: id,
        text: text,
        accessLevel: accessLevel,
        localId: localId,
        mentionProvider: mentionProvider,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        profilecardProvider: profilecardProvider,
        onClick: eventHandlers?.onClick,
        onMouseEnter: eventHandlers?.onMouseEnter,
        onMouseLeave: eventHandlers?.onMouseLeave
    });
});
class $a7685c9ca4d4c44d$export$7279f5a9685c37e0 extends (0, $5uXOq.PureComponent) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/no-unsafe
    UNSAFE_componentWillMount() {
        this.updateProfilecardProvider(this.props);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line react/no-unsafe
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.profilecardProvider !== this.props.profilecardProvider) this.updateProfilecardProvider(nextProps);
    }
    updateProfilecardProvider(props) {
        // We are not using async/await here to avoid having an intermediate Promise
        // introduced by the transpiler.
        // This will allow consumer to use a SynchronousPromise.resolve and avoid useless
        // rerendering
        if (props.profilecardProvider) props.profilecardProvider.then((profilecardProvider)=>{
            this.setState({
                profilecardProvider: profilecardProvider
            });
        }).catch(()=>{
            this.setState({
                profilecardProvider: null
            });
        });
        else this.setState({
            profilecardProvider: null
        });
    }
    render() {
        const { accessLevel: accessLevel, eventHandlers: eventHandlers, id: id, mentionProvider: mentionProvider, text: text, localId: localId } = this.props;
        const { profilecardProvider: profilecardProvider } = this.state;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const actionHandlers = {};
        [
            'onClick',
            'onMouseEnter',
            'onMouseLeave'
        ].forEach((handler)=>{
            actionHandlers[handler] = eventHandlers && eventHandlers[handler] || $a7685c9ca4d4c44d$var$noop;
        });
        const MentionComponent = profilecardProvider && $a7685c9ca4d4c44d$var$GENERIC_USER_IDS.indexOf(id) === -1 ? (0, $1L4Cd.default) : (0, $b7bHf.default);
        return /*#__PURE__*/ (0, $2OMIu.jsx)(MentionComponent, {
            id: id,
            text: text,
            accessLevel: accessLevel,
            localId: localId,
            mentionProvider: mentionProvider,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            profilecardProvider: profilecardProvider,
            ...actionHandlers
        });
    }
    constructor(...args){
        super(...args), this.state = {
            profilecardProvider: null
        };
    }
}

});
parcelRegister("b7bHf", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d017eafb85c10fe$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jyjg6 = parcelRequire("jyjg6");

var $3S16W = parcelRequire("3S16W");

var $iYy1U = parcelRequire("iYy1U");

var $kU7Ls = parcelRequire("kU7Ls");
class $1d017eafb85c10fe$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    constructor(props){
        super(props), this.handleMentionProvider = (props)=>{
            const { id: id, mentionProvider: mentionProvider, text: text } = props;
            if (mentionProvider) mentionProvider.then((provider)=>{
                const newState = {
                    isHighlighted: provider.shouldHighlightMention({
                        id: id
                    })
                };
                if (!text && (0, $jyjg6.isResolvingMentionProvider)(provider)) {
                    const nameDetail = provider.resolveMentionName(id);
                    if ((0, $3S16W.isPromise)(nameDetail)) nameDetail.then((nameDetailResult)=>{
                        this.setStateSafely({
                            resolvedMentionName: this.processName(nameDetailResult)
                        });
                    });
                    else newState.resolvedMentionName = this.processName(nameDetail);
                }
                this.setStateSafely(newState);
            }).catch(()=>{
                this.setStateSafely({
                    isHighlighted: false
                });
            });
            else this.setStateSafely({
                isHighlighted: false
            });
        };
        this._isMounted = false;
        this.state = {
            isHighlighted: false
        };
    }
    componentDidMount() {
        this.handleMentionProvider(this.props);
        this._isMounted = true;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { props: props } = this;
        if (props.id !== nextProps.id || props.mentionProvider !== nextProps.mentionProvider) this.handleMentionProvider(nextProps);
    }
    setStateSafely(newState) {
        if (!this._isMounted) {
            (0, $kU7Ls.default)('[ResourcedMention]: cannot setState when component is unmounted.');
            return;
        }
        this.setState(newState);
    }
    processName(name) {
        let mentionName;
        switch(name.status){
            case (0, $3S16W.MentionNameStatus).OK:
                mentionName = name.name || '';
                break;
            case (0, $3S16W.MentionNameStatus).SERVICE_ERROR:
            case (0, $3S16W.MentionNameStatus).UNKNOWN:
            default:
                mentionName = (0, $iYy1U.UNKNOWN_USER_ID);
                break;
        }
        return `@${mentionName}`;
    }
    render() {
        const { props: props, state: state } = this;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iYy1U.default), {
            id: props.id,
            text: props.text || state.resolvedMentionName || '',
            isHighlighted: state.isHighlighted,
            accessLevel: props.accessLevel,
            localId: props.localId,
            onClick: props.onClick,
            onMouseEnter: props.onMouseEnter,
            onMouseLeave: props.onMouseLeave
        });
    }
}

});
parcelRegister("jyjg6", function(module, exports) {

$parcel$export(module.exports, "AbstractMentionResource", () => $e1deba116d5f2924$export$8576ba1ed2760927);
$parcel$export(module.exports, "isResolvingMentionProvider", () => $e1deba116d5f2924$export$ae1fce5f69858ef3);

var $92r21 = parcelRequire("92r21");

var $3S16W = parcelRequire("3S16W");

var $kU7Ls = parcelRequire("kU7Ls");

var $8t1vy = parcelRequire("8t1vy");

var $lFKmC = parcelRequire("lFKmC");
const $e1deba116d5f2924$var$MAX_QUERY_ITEMS = 100;
const $e1deba116d5f2924$var$MAX_NOTIFIED_ITEMS = 20;
const $e1deba116d5f2924$var$emptySecurityProvider = ()=>{
    return {
        params: {},
        headers: {}
    };
};
class $e1deba116d5f2924$export$4529f10aed0950d4 {
    constructor(){
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
        this.analyticsListeners = new Map();
    }
    subscribe(key, callback, errCallback, infoCallback, allResultsCallback, analyticsListeners) {
        if (callback) this.changeListeners.set(key, callback);
        if (errCallback) this.errListeners.set(key, errCallback);
        if (infoCallback) this.infoListeners.set(key, infoCallback);
        if (allResultsCallback) this.allResultsListeners.set(key, allResultsCallback);
        if (analyticsListeners) this.analyticsListeners.set(key, analyticsListeners);
    }
    unsubscribe(key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
        this.analyticsListeners.delete(key);
    }
}
class $e1deba116d5f2924$export$8576ba1ed2760927 extends $e1deba116d5f2924$export$4529f10aed0950d4 {
    shouldHighlightMention(_mention) {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    filter(query) {
        throw new Error(`not yet implemented.\nParams: query=${query}`);
    }
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    recordMentionSelection(_mention) {
    // Do nothing
    }
    isFiltering(_query) {
        return false;
    }
    _notifyListeners(mentionsResult, stats) {
        (0, $kU7Ls.default)('ak-mention-resource._notifyListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $e1deba116d5f2924$var$MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            } catch (e) {
                // ignore error from listener
                (0, $kU7Ls.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAllResultsListeners(mentionsResult) {
        (0, $kU7Ls.default)('ak-mention-resource._notifyAllResultsListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $e1deba116d5f2924$var$MAX_NOTIFIED_ITEMS), mentionsResult.query);
            } catch (e) {
                // ignore error from listener
                (0, $kU7Ls.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyErrorListeners(error, query) {
        this.errListeners.forEach((listener, key)=>{
            try {
                listener(error, query);
            } catch (e) {
                // ignore error from listener
                (0, $kU7Ls.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyInfoListeners(info) {
        this.infoListeners.forEach((listener, key)=>{
            try {
                listener(info);
            } catch (e) {
                // ignore error fromr listener
                (0, $kU7Ls.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAnalyticsListeners(event, actionSubject, action, attributes) {
        this.analyticsListeners.forEach((listener, key)=>{
            try {
                listener(event, actionSubject, action, attributes);
            } catch (e) {
                // ignore error from listener
                (0, $kU7Ls.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $e1deba116d5f2924$export$5a4331e3e1c43553 extends $e1deba116d5f2924$export$8576ba1ed2760927 {
    constructor(config){
        super();
        this.verifyMentionConfig(config);
        this.config = config;
        this.lastReturnedSearch = 0;
        this.activeSearches = new Set();
        this.productName = config.productName;
        this.shouldEnableInvite = !!config.shouldEnableInvite;
        this.onInviteItemClick = config.onInviteItemClick;
        this.inviteXProductUser = config.inviteXProductUser;
        this.userRole = config.userRole || 'basic';
        if (this.config.debounceTime) this.filter = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(this.filter, this.config.debounceTime);
    }
    shouldHighlightMention(mention) {
        if (this.config.shouldHighlightMention) return this.config.shouldHighlightMention(mention);
        return false;
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        } else {
            const date = new Date(searchTime).toISOString().substr(17, 6);
            (0, $kU7Ls.default)('Stale search result, skipping', date, query); // eslint-disable-line no-console, max-len
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
        if (query) this.activeSearches.delete(query);
    }
    async filter(query, contextIdentifier) {
        try {
            const searchTime = Date.now();
            let results;
            if (!query) results = await this.initialState(contextIdentifier);
            else {
                this.activeSearches.add(query);
                const searchResponse = this.search(query, contextIdentifier);
                results = await searchResponse.mentions;
            }
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    resolveMentionName(id) {
        if (!this.config.mentionNameResolver) return {
            id: id,
            name: '',
            status: (0, $3S16W.MentionNameStatus).UNKNOWN
        };
        return this.config.mentionNameResolver.lookupName(id);
    }
    cacheMentionName(id, mentionName) {
        if (!this.config.mentionNameResolver) return;
        this.config.mentionNameResolver.cacheName(id, mentionName);
    }
    supportsMentionNameResolving() {
        return !!this.config.mentionNameResolver;
    }
    updateActiveSearches(query) {
        this.activeSearches.add(query);
    }
    verifyMentionConfig(config) {
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.securityProvider) config.securityProvider = $e1deba116d5f2924$var$emptySecurityProvider;
    }
    initialState(contextIdentifier) {
        return this.remoteInitialState(contextIdentifier);
    }
    /**
	 * Clear a context object to generate query params by removing empty
	 * strings, `undefined` and empty values.
	 *
	 * @param contextIdentifier the current context identifier
	 * @returns a safe context for query encoding
	 */ clearContext(contextIdentifier = {}) {
        return Object.keys(contextIdentifier).filter((key)=>contextIdentifier[key]).reduce((context, key)=>({
                [key]: contextIdentifier[key],
                ...context
            }), {});
    }
    getQueryParams(contextIdentifier) {
        const configParams = {};
        if (this.config.containerId) configParams['containerId'] = this.config.containerId;
        if (this.config.productId) configParams['productIdentifier'] = this.config.productId;
        // if contextParams exist then it will override configParams for containerId
        return {
            ...configParams,
            ...this.clearContext(contextIdentifier)
        };
    }
    /**
	 * Returns the initial mention display list before a search is performed for the specified
	 * container.
	 *
	 * @param contextIdentifier
	 * @returns Promise
	 */ async remoteInitialState(contextIdentifier) {
        const queryParams = this.getQueryParams(contextIdentifier);
        const options = {
            path: 'bootstrap',
            queryParams: queryParams
        };
        try {
            const result = await (0, $92r21.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $8t1vy.SLI_EVENT_TYPE), (0, $3S16W.SliNames).INITIAL_STATE, (0, $3S16W.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, '');
        } catch (error) {
            this._notifyAnalyticsListeners((0, $8t1vy.SLI_EVENT_TYPE), (0, $3S16W.SliNames).INITIAL_STATE, (0, $3S16W.Actions).FAILED);
            throw error;
        }
    }
    search(query, contextIdentifier) {
        return {
            mentions: this.remoteSearch(query, contextIdentifier)
        };
    }
    async remoteSearch(query, contextIdentifier) {
        const options = {
            path: 'search',
            queryParams: {
                query: query,
                limit: $e1deba116d5f2924$var$MAX_QUERY_ITEMS,
                ...this.getQueryParams(contextIdentifier)
            }
        };
        try {
            const result = await (0, $92r21.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $8t1vy.SLI_EVENT_TYPE), (0, $3S16W.SliNames).SEARCH, (0, $3S16W.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, query);
        } catch (error) {
            this._notifyAnalyticsListeners((0, $8t1vy.SLI_EVENT_TYPE), (0, $3S16W.SliNames).SEARCH, (0, $3S16W.Actions).FAILED);
            throw error;
        }
    }
    transformServiceResponse(result, query) {
        const mentions = result.mentions.map((mention)=>{
            let lozenge;
            if ((0, $3S16W.isAppMention)(mention)) lozenge = mention.userType;
            else if ((0, $3S16W.isTeamMention)(mention)) lozenge = mention.userType;
            return {
                ...mention,
                lozenge: lozenge,
                query: query
            };
        });
        return {
            ...result,
            mentions: mentions,
            query: result.query || query
        };
    }
}
class $e1deba116d5f2924$export$65bd6083489bd8bb {
    constructor(statusCode, statusMessage){
        this.statusCode = statusCode;
        this.message = statusMessage;
        this.name = 'HttpError';
        this.stack = new Error().stack;
    }
}
const $e1deba116d5f2924$export$ae1fce5f69858ef3 = (p)=>!!(p && p.supportsMentionNameResolving && p.supportsMentionNameResolving());
var $e1deba116d5f2924$export$2e2bcd8739ae039 = $e1deba116d5f2924$export$5a4331e3e1c43553;

});
parcelRegister("3S16W", function(module, exports) {

$parcel$export(module.exports, "MentionType", () => $854a6741a63621b5$export$2102863a3c660c6b);
$parcel$export(module.exports, "UserAccessLevel", () => $854a6741a63621b5$export$81124e6148ca5db0);
$parcel$export(module.exports, "UserType", () => $854a6741a63621b5$export$8436e53e45ffe15b);
$parcel$export(module.exports, "SliNames", () => $854a6741a63621b5$export$7afb0727c7d7e8af);
$parcel$export(module.exports, "ComponentNames", () => $854a6741a63621b5$export$5c42d9dea6d035c1);
$parcel$export(module.exports, "Actions", () => $854a6741a63621b5$export$b52183d5cfb26dc9);
$parcel$export(module.exports, "MentionNameStatus", () => $854a6741a63621b5$export$b8fa67dc54502853);
$parcel$export(module.exports, "isRestricted", () => $854a6741a63621b5$export$dbaa15dc1820b89a);
$parcel$export(module.exports, "isSpecialMention", () => $854a6741a63621b5$export$37b8dcac6198c514);
$parcel$export(module.exports, "isAppMention", () => $854a6741a63621b5$export$eb590c844d13454c);
$parcel$export(module.exports, "isTeamMention", () => $854a6741a63621b5$export$803b1379348dbfd5);
$parcel$export(module.exports, "isSpecialMentionText", () => $854a6741a63621b5$export$d13d4f976b36a397);
$parcel$export(module.exports, "isPromise", () => $854a6741a63621b5$export$4369c812aac99591);
var $854a6741a63621b5$export$2102863a3c660c6b = /*#__PURE__*/ function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    return MentionType;
}({});
var $854a6741a63621b5$export$81124e6148ca5db0 = /*#__PURE__*/ function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    return UserAccessLevel;
}({});
var $854a6741a63621b5$export$8436e53e45ffe15b = /*#__PURE__*/ function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    return UserType;
}({});
var $854a6741a63621b5$export$7afb0727c7d7e8af = /*#__PURE__*/ function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
    return SliNames;
}({});
var $854a6741a63621b5$export$5c42d9dea6d035c1 = /*#__PURE__*/ function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
    return ComponentNames;
}({});
var $854a6741a63621b5$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
    return Actions;
}({});
var $854a6741a63621b5$export$b8fa67dc54502853 = /*#__PURE__*/ function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    return MentionNameStatus;
}({});
function $854a6741a63621b5$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === $854a6741a63621b5$export$81124e6148ca5db0[0];
}
function $854a6741a63621b5$export$37b8dcac6198c514(mention) {
    return !!mention.userType && mention.userType === $854a6741a63621b5$export$8436e53e45ffe15b[1];
}
function $854a6741a63621b5$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === $854a6741a63621b5$export$8436e53e45ffe15b[2];
}
function $854a6741a63621b5$export$803b1379348dbfd5(mention) {
    return mention.userType && mention.userType === $854a6741a63621b5$export$8436e53e45ffe15b[3];
}
function $854a6741a63621b5$export$d13d4f976b36a397(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
const $854a6741a63621b5$export$4369c812aac99591 = (p)=>!!(p && p.then);

});

parcelRegister("kU7Ls", function(module, exports) {

$parcel$export(module.exports, "default", () => $a414115eb0824f74$export$2e2bcd8739ae039);
let $a414115eb0824f74$var$debugEnabled = false;
let $a414115eb0824f74$var$stacktracesEnabled = false;
function $a414115eb0824f74$export$748ada60eaf985cc(enable) {
    $a414115eb0824f74$var$debugEnabled = enable;
}
function $a414115eb0824f74$export$4f7017086af31c25(enable) {
    $a414115eb0824f74$var$stacktracesEnabled = enable;
}
function $a414115eb0824f74$export$2a858f450a2f66d() {
    if ($a414115eb0824f74$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $a414115eb0824f74$export$2e2bcd8739ae039(msg, ...args) {
    if ($a414115eb0824f74$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("8t1vy", function(module, exports) {

$parcel$export(module.exports, "SLI_EVENT_TYPE", () => $75717af50e0a4782$export$245097525aef1262);
$parcel$export(module.exports, "SMART_EVENT_TYPE", () => $75717af50e0a4782$export$c724588856bbfbcf);
$parcel$export(module.exports, "fireAnalyticsMentionEvent", () => $75717af50e0a4782$export$44902bc7b3f0b09f);
$parcel$export(module.exports, "fireAnalyticsMentionHydrationEvent", () => $75717af50e0a4782$export$91b2fa6a0fe06408);



var $3S16W = parcelRequire("3S16W");
const $75717af50e0a4782$var$packageName = "platform-pkg";
const $75717af50e0a4782$var$packageVersion = "0.0.0-use.local";
const $75717af50e0a4782$export$245097525aef1262 = 'sli';
const $75717af50e0a4782$export$c724588856bbfbcf = 'smart';
const $75717af50e0a4782$export$a823474ae5cb9e9c = (props)=>(action, duration, userIds = [], query)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $3S16W.ComponentNames).TYPEAHEAD,
                attributes: {
                    packageName: $75717af50e0a4782$var$packageName,
                    packageVersion: $75717af50e0a4782$var$packageVersion,
                    componentName: (0, $3S16W.ComponentNames).MENTION,
                    duration: Math.round(duration),
                    userIds: userIds,
                    queryLength: query ? query.length : 0
                },
                eventType: (0, $6252f4c5224b497a$export$12346a674644c156)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $0420448f44d4b822$export$d821aa4c8afb384e));
        }
    };
const $75717af50e0a4782$export$44902bc7b3f0b09f = (createEvent)=>(actionSubject, action, text, id, accessLevel)=>{
        const payload = {
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $6252f4c5224b497a$export$a1562d08625f5d7e),
            attributes: {
                packageName: $75717af50e0a4782$var$packageName,
                packageVersion: $75717af50e0a4782$var$packageVersion,
                componentName: (0, $3S16W.ComponentNames).MENTION,
                accessLevel: accessLevel,
                isSpecial: (0, $3S16W.isSpecialMentionText)(text),
                userId: id
            }
        };
        const event = createEvent(payload);
        event.fire((0, $0420448f44d4b822$export$d821aa4c8afb384e));
        return event;
    };
const $75717af50e0a4782$export$c8b245b690e10169 = (props)=>(actionSubject, action)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = $75717af50e0a4782$export$c357a2872628de7c(actionSubject, action);
            props.createAnalyticsEvent(eventPayload).fire((0, $0420448f44d4b822$export$d821aa4c8afb384e));
        }
    };
const $75717af50e0a4782$export$c357a2872628de7c = (actionSubject, action, attributes)=>{
    const eventPayload = {
        action: action,
        actionSubject: actionSubject,
        eventType: (0, $6252f4c5224b497a$export$12346a674644c156),
        attributes: {
            packageName: $75717af50e0a4782$var$packageName,
            packageVersion: $75717af50e0a4782$var$packageVersion,
            componentName: (0, $3S16W.ComponentNames).MENTION,
            ...attributes
        }
    };
    return eventPayload;
};
const $75717af50e0a4782$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $3S16W.ComponentNames).MENTION,
                actionSubjectId: 'hydration',
                attributes: {
                    packageName: $75717af50e0a4782$var$packageName,
                    packageVersion: $75717af50e0a4782$var$packageVersion,
                    componentName: (0, $3S16W.ComponentNames).MENTION,
                    userId: userId,
                    fromCache: fromCache,
                    duration: Math.round(duration)
                },
                eventType: (0, $6252f4c5224b497a$export$12346a674644c156)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $0420448f44d4b822$export$d821aa4c8afb384e));
        }
    };
// OLD Analytics
const $75717af50e0a4782$var$MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
const $75717af50e0a4782$export$34ac71ce24cddec2 = (firePrivateAnalyticsEvent)=>(eventName, text, accessLevel)=>{
        if (firePrivateAnalyticsEvent) firePrivateAnalyticsEvent(`${$75717af50e0a4782$var$MENTION_ANALYTICS_PREFIX}.${eventName}`, {
            accessLevel: accessLevel,
            isSpecial: (0, $3S16W.isSpecialMentionText)(text)
        });
    };

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $6252f4c5224b497a$export$a1562d08625f5d7e = 'ui';
const $6252f4c5224b497a$export$947dac6c72b26f81 = 'track';
const $6252f4c5224b497a$export$f1d537d508d2945a = 'screen';
const $6252f4c5224b497a$export$12346a674644c156 = 'operational';
const $6252f4c5224b497a$export$b055de0e665cb20c = 'unknown';

const $0420448f44d4b822$export$d821aa4c8afb384e = 'fabric-elements';



parcelRegister("iYy1U", function(module, exports) {

$parcel$export(module.exports, "UNKNOWN_USER_ID", () => $06d7db58e811d2e1$export$af8124aa496797f2);
$parcel$export(module.exports, "default", () => $06d7db58e811d2e1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $RD3UT = parcelRequire("RD3UT");

var $fBlLf = parcelRequire("fBlLf");

var $boR01 = parcelRequire("boR01");

var $g2vFv = parcelRequire("g2vFv");

var $3S16W = parcelRequire("3S16W");

var $8t1vy = parcelRequire("8t1vy");

var $2keUK = parcelRequire("2keUK");

var $2QVEp = parcelRequire("2QVEp");

var $5MeFJ = parcelRequire("5MeFJ");

var $hCedp = parcelRequire("hCedp");
const $06d7db58e811d2e1$export$7452d7062a4d0634 = 1000;
const $06d7db58e811d2e1$export$af8124aa496797f2 = '_|unknown|_';
class $06d7db58e811d2e1$export$92ab8442e7a15cef extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    constructor(props){
        super(props), this.handleOnClick = (e)=>{
            const { id: id, text: text, onClick: onClick } = this.props;
            if (onClick) onClick(id, text, e);
        }, this.handleOnMouseEnter = (e)=>{
            const { id: id, text: text, onMouseEnter: onMouseEnter, onHover: onHover } = this.props;
            if (onMouseEnter) onMouseEnter(id, text, e);
            this.hoverTimeout = window.setTimeout(()=>{
                if (onHover) onHover();
                this.hoverTimeout = undefined;
            }, $06d7db58e811d2e1$export$7452d7062a4d0634);
        }, this.handleOnMouseLeave = (e)=>{
            const { id: id, text: text, onMouseLeave: onMouseLeave } = this.props;
            if (onMouseLeave) onMouseLeave(id, text, e);
            if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        }, this.getMentionType = ()=>{
            const { accessLevel: accessLevel, isHighlighted: isHighlighted } = this.props;
            if (isHighlighted) return (0, $3S16W.MentionType).SELF;
            if ((0, $3S16W.isRestricted)(accessLevel)) return (0, $3S16W.MentionType).RESTRICTED;
            return (0, $3S16W.MentionType).DEFAULT;
        };
        (0, $hCedp.mentionRenderedUfoExperience).getInstance(props.id).start();
    }
    componentDidMount() {
        (0, $hCedp.mentionRenderedUfoExperience).getInstance(this.props.id).success();
    }
    componentWillUnmount() {
        if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        const ufoInstance = (0, $hCedp.mentionRenderedUfoExperience).getInstance(this.props.id);
        if ([
            (0, $2QVEp.UFOExperienceState)['STARTED'],
            (0, $2QVEp.UFOExperienceState)['IN_PROGRESS']
        ].includes(ufoInstance.state)) ufoInstance.abort();
    }
    renderUnknownUserError(id) {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5MeFJ.UnknownUserError), {
            values: {
                userId: id.slice(-5)
            },
            children: (message)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: `@${message}`
                })
        });
    }
    render() {
        const { handleOnClick: handleOnClick, handleOnMouseEnter: handleOnMouseEnter, handleOnMouseLeave: handleOnMouseLeave, props: props } = this;
        const { text: text, id: id, accessLevel: accessLevel, localId: localId } = props;
        const mentionType = this.getMentionType();
        const failedMention = text === `@${$06d7db58e811d2e1$export$af8124aa496797f2}`;
        const showTooltip = mentionType === (0, $3S16W.MentionType).RESTRICTED;
        const mentionComponent = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $RD3UT.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $boR01.default), {
                mentionType: mentionType,
                onClick: handleOnClick,
                onMouseEnter: handleOnMouseEnter,
                onMouseLeave: handleOnMouseLeave,
                spellCheck: false,
                "data-testid": `mention-${id}`,
                "data-mention-type": mentionType,
                "data-mention-tooltip": showTooltip,
                children: failedMention ? this.renderUnknownUserError(id) : text || '@...'
            })
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hCedp.UfoErrorBoundary), {
            id: id,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: localId,
                "data-mention-id": id,
                "data-local-id": localId,
                "data-access-level": accessLevel,
                spellCheck: false,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fBlLf.default), {
                    children: showTooltip ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Suspense, {
                        fallback: mentionComponent,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g2vFv.default), {
                            name: text,
                            children: mentionComponent
                        })
                    }) : mentionComponent
                })
            })
        });
    }
}
const $06d7db58e811d2e1$var$MentionWithAnalytics = (0, $2keUK.default)({
    onClick: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $8t1vy.fireAnalyticsMentionEvent)(createEvent)('mention', 'selected', text, id, accessLevel);
        return event;
    },
    onHover: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $8t1vy.fireAnalyticsMentionEvent)(createEvent)('mention', 'hovered', text, id, accessLevel);
        return event;
    }
})($06d7db58e811d2e1$export$92ab8442e7a15cef);
const $06d7db58e811d2e1$var$Mention = $06d7db58e811d2e1$var$MentionWithAnalytics;
var $06d7db58e811d2e1$export$2e2bcd8739ae039 = $06d7db58e811d2e1$var$Mention;

});
parcelRegister("fBlLf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e248eb55dca1790$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");

var $5MeFJ = parcelRequire("5MeFJ");
const $3e248eb55dca1790$var$EMPTY = {};
const $3e248eb55dca1790$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState($3e248eb55dca1790$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        let aborted = false;
        setMessages($3e248eb55dca1790$var$EMPTY);
        (0, $5MeFJ.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $3e248eb55dca1790$var$MessagesIntlProvider = (props)=>{
    const { children: children } = props;
    const intl = (0, $koVbs.default)();
    const messages = $3e248eb55dca1790$var$useI18n(intl.locale);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        ...intl,
        messages: messages,
        children: children
    });
};
var $3e248eb55dca1790$export$2e2bcd8739ae039 = $3e248eb55dca1790$var$MessagesIntlProvider;

});
parcelRegister("5MeFJ", function(module, exports) {

$parcel$export(module.exports, "UnknownUserError", () => $77c8eb7b5ba38487$export$98e06fe7a6174253);
$parcel$export(module.exports, "NoAccessWarning", () => $77c8eb7b5ba38487$export$58bd5a2057b6b855);
$parcel$export(module.exports, "NoAccessLabel", () => $77c8eb7b5ba38487$export$da9f8ce14593162f);
$parcel$export(module.exports, "getMessagesForLocale", () => $77c8eb7b5ba38487$export$d0a3169680473b6c);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $hLIsO = parcelRequire("hLIsO");
const $77c8eb7b5ba38487$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
        const { formatMessage: formatMessage } = (0, $koVbs.default)();
        const message = formatMessage(messageDescriptor, values);
        if (typeof children === 'function') return children(message);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            values: values,
            ...messageDescriptor
        });
    };
const $77c8eb7b5ba38487$export$98e06fe7a6174253 = $77c8eb7b5ba38487$export$392a0c6a82ab0e50((0, $hLIsO.messages).unknownUserError);
const $77c8eb7b5ba38487$export$58bd5a2057b6b855 = $77c8eb7b5ba38487$export$392a0c6a82ab0e50((0, $hLIsO.messages).noAccessWarning);
const $77c8eb7b5ba38487$export$da9f8ce14593162f = $77c8eb7b5ba38487$export$392a0c6a82ab0e50((0, $hLIsO.messages).noAccessLabel);
const $77c8eb7b5ba38487$export$4a258ffee7316766 = $77c8eb7b5ba38487$export$392a0c6a82ab0e50((0, $hLIsO.messages).defaultHeadline);
const $77c8eb7b5ba38487$export$702321a50d74536e = $77c8eb7b5ba38487$export$392a0c6a82ab0e50((0, $hLIsO.messages).defaultAdvisedAction);
const $77c8eb7b5ba38487$export$ed7f16088a93ae9d = $77c8eb7b5ba38487$export$392a0c6a82ab0e50((0, $hLIsO.messages).loginAgain);
const $77c8eb7b5ba38487$export$3ab158df56460d1c = $77c8eb7b5ba38487$export$392a0c6a82ab0e50((0, $hLIsO.messages).differentText);































const $77c8eb7b5ba38487$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("422HQ")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("bZKQY")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("geQFX")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("6HcEP")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("2ZHbI")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("c352U")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("aczhc")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("7ZEkz")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("c9KhF")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("6tyrt")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("97RdE")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("eG3dM")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("5sFLY")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("dSjIl")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("6JcqN")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("LctzK")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("6e6BK")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("9d95G")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("bYjhl")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("cxRtd")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("kC8LM")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("dkQki")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("8R4NO")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("deb13")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("loCXA")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("cEgGs")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("h2cXz")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("01dXj")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("cBfgZ")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("lzvZE")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $77c8eb7b5ba38487$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("6HcEP")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("hLIsO", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e154cb8ef6f5eeec$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $e154cb8ef6f5eeec$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    unknownUserError: {
        id: 'fabric.mention.unknow.user.error',
        defaultMessage: 'Unknown user {userId}',
        description: 'Mention user name could not be found or look up failed'
    },
    noAccessWarning: {
        id: 'fabric.mention.noAccess.warning',
        defaultMessage: "{name} won't be notified as they have no access",
        description: "Warning message to show that the mentioned user won't be notified"
    },
    noAccessLabel: {
        id: 'fabric.mention.noAccess.label',
        defaultMessage: 'No access',
        description: 'Label for no access icon'
    },
    defaultHeadline: {
        id: 'fabric.mention.error.defaultHeadline',
        defaultMessage: 'Something went wrong',
        description: 'Error message shown when there is an error communicating with backend'
    },
    defaultAdvisedAction: {
        id: 'fabric.mention.error.defaultAction',
        defaultMessage: 'Try again in a few seconds',
        description: 'Default advised action when an error occurs'
    },
    loginAgain: {
        id: 'fabric.mention.error.loginAgain',
        defaultMessage: 'Try logging out then in again',
        description: 'Login again message when there is an authentication error occurs'
    },
    differentText: {
        id: 'fabric.mention.error.differentText',
        defaultMessage: 'Try entering different text',
        description: 'Enter different text message when a forbidden error occurs'
    },
    memberCountWithoutYou: {
        id: 'fabric.elements.mentions.team.member.count',
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}",
        description: 'Byline to show the number of members in the team when the current user is not a member of the team'
    },
    memberCountWithYou: {
        id: 'fabric.elements.mentions.team.member.count.including.you',
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you",
        description: 'Byline to show the number of members in the team when the current user is also a member of the team'
    },
    plus50MembersWithoutYou: {
        id: 'fabric.elements.mentions.team.member.50plus',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the number of members in the team when the number exceeds 50'
    },
    plus50MembersWithYou: {
        id: 'fabric.elements.mentions.team.member.50plus.including.you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
    },
    xProductMentionDescription: {
        id: 'fabric.elements.mentions.xproduct.mention.description',
        defaultMessage: 'Needs access to Confluence',
        description: 'Description for a x-product mention item in the mention list in Confluence'
    }
});

});

parcelRegister("422HQ", function(module, exports) {

let $2ef972b4a6b327b1$var$load = (parcelRequire("loK1v"))(4);
module.exports = $2ef972b4a6b327b1$var$load("o3ypa").then(()=>parcelRequire('hmt2h'));

});

parcelRegister("bZKQY", function(module, exports) {

let $8bb9bc4f23fc4f16$var$load = (parcelRequire("loK1v"))(4);
module.exports = $8bb9bc4f23fc4f16$var$load("cgwHQ").then(()=>parcelRequire('9oY8Y'));

});

parcelRegister("geQFX", function(module, exports) {

let $bd26d06fc1e05fdb$var$load = (parcelRequire("loK1v"))(4);
module.exports = $bd26d06fc1e05fdb$var$load("Ez77u").then(()=>parcelRequire('KWDla'));

});

parcelRegister("6HcEP", function(module, exports) {

let $4e0093c43810775b$var$load = (parcelRequire("loK1v"))(4);
module.exports = $4e0093c43810775b$var$load("bIKs4").then(()=>parcelRequire('8VRRX'));

});

parcelRegister("2ZHbI", function(module, exports) {

let $22e2c784f567c9e0$var$load = (parcelRequire("loK1v"))(4);
module.exports = $22e2c784f567c9e0$var$load("7wO9J").then(()=>parcelRequire('ei3NP'));

});

parcelRegister("c352U", function(module, exports) {

let $8c59adddfd44f304$var$load = (parcelRequire("loK1v"))(4);
module.exports = $8c59adddfd44f304$var$load("efXo8").then(()=>parcelRequire('f7BWA'));

});

parcelRegister("aczhc", function(module, exports) {

let $76d6638b5c1b9594$var$load = (parcelRequire("loK1v"))(4);
module.exports = $76d6638b5c1b9594$var$load("aqIoH").then(()=>parcelRequire('dlSv8'));

});

parcelRegister("7ZEkz", function(module, exports) {

let $5d1d83c17903fa43$var$load = (parcelRequire("loK1v"))(4);
module.exports = $5d1d83c17903fa43$var$load("4wa7C").then(()=>parcelRequire('7OI81'));

});

parcelRegister("c9KhF", function(module, exports) {

let $8d9a3a50673fe9d4$var$load = (parcelRequire("loK1v"))(4);
module.exports = $8d9a3a50673fe9d4$var$load("eHzZ7").then(()=>parcelRequire('3qsva'));

});

parcelRegister("6tyrt", function(module, exports) {

let $4b702b026e7c030a$var$load = (parcelRequire("loK1v"))(4);
module.exports = $4b702b026e7c030a$var$load("edvli").then(()=>parcelRequire('h6779'));

});

parcelRegister("97RdE", function(module, exports) {

let $6a4e0cb2a73fc1dc$var$load = (parcelRequire("loK1v"))(4);
module.exports = $6a4e0cb2a73fc1dc$var$load("5gD5s").then(()=>parcelRequire('6dwdy'));

});

parcelRegister("eG3dM", function(module, exports) {

let $aaf77c9e5ffd46e9$var$load = (parcelRequire("loK1v"))(4);
module.exports = $aaf77c9e5ffd46e9$var$load("7LUjf").then(()=>parcelRequire('5k5Kt'));

});

parcelRegister("5sFLY", function(module, exports) {

let $3f9ff8809f323335$var$load = (parcelRequire("loK1v"))(4);
module.exports = $3f9ff8809f323335$var$load("e3W7Y").then(()=>parcelRequire('72lMw'));

});

parcelRegister("dSjIl", function(module, exports) {

let $a19f9c5c928662f7$var$load = (parcelRequire("loK1v"))(4);
module.exports = $a19f9c5c928662f7$var$load("gdKJU").then(()=>parcelRequire('kZBSv'));

});

parcelRegister("6JcqN", function(module, exports) {

let $4e60969c75ac3e83$var$load = (parcelRequire("loK1v"))(4);
module.exports = $4e60969c75ac3e83$var$load("7MWts").then(()=>parcelRequire('bMmTH'));

});

parcelRegister("LctzK", function(module, exports) {

let $08de116128330e3d$var$load = (parcelRequire("loK1v"))(4);
module.exports = $08de116128330e3d$var$load("8EU5M").then(()=>parcelRequire('dMtOB'));

});

parcelRegister("6e6BK", function(module, exports) {

let $48892d0fb6b15934$var$load = (parcelRequire("loK1v"))(4);
module.exports = $48892d0fb6b15934$var$load("jiN1F").then(()=>parcelRequire('jFIpk'));

});

parcelRegister("9d95G", function(module, exports) {

let $6b4c612a23cbc012$var$load = (parcelRequire("loK1v"))(4);
module.exports = $6b4c612a23cbc012$var$load("h3oYl").then(()=>parcelRequire('e4emr'));

});

parcelRegister("bYjhl", function(module, exports) {

let $8b7440b0aecfe4e3$var$load = (parcelRequire("loK1v"))(4);
module.exports = $8b7440b0aecfe4e3$var$load("6SbfQ").then(()=>parcelRequire('i9Vza'));

});

parcelRegister("cxRtd", function(module, exports) {

let $92220b292e2b95a0$var$load = (parcelRequire("loK1v"))(4);
module.exports = $92220b292e2b95a0$var$load("d5VI3").then(()=>parcelRequire('aQeCP'));

});

parcelRegister("kC8LM", function(module, exports) {

let $f01e28b620c32746$var$load = (parcelRequire("loK1v"))(4);
module.exports = $f01e28b620c32746$var$load("2jw7H").then(()=>parcelRequire('6w5hJ'));

});

parcelRegister("dkQki", function(module, exports) {

let $9b55bb8a2baae846$var$load = (parcelRequire("loK1v"))(4);
module.exports = $9b55bb8a2baae846$var$load("92d4O").then(()=>parcelRequire('gQFyB'));

});

parcelRegister("8R4NO", function(module, exports) {

let $6726ff9db7dae6c7$var$load = (parcelRequire("loK1v"))(4);
module.exports = $6726ff9db7dae6c7$var$load("aMUlt").then(()=>parcelRequire('iDmcl'));

});

parcelRegister("deb13", function(module, exports) {

let $9a1520b95768fa3a$var$load = (parcelRequire("loK1v"))(4);
module.exports = $9a1520b95768fa3a$var$load("7IjH0").then(()=>parcelRequire('cBfrL'));

});

parcelRegister("loCXA", function(module, exports) {

let $f93a0f8caa150cb6$var$load = (parcelRequire("loK1v"))(4);
module.exports = $f93a0f8caa150cb6$var$load("fDbSI").then(()=>parcelRequire('kRAGE'));

});

parcelRegister("cEgGs", function(module, exports) {

let $9356298ae1989613$var$load = (parcelRequire("loK1v"))(4);
module.exports = $9356298ae1989613$var$load("bSV25").then(()=>parcelRequire('gFt5b'));

});

parcelRegister("h2cXz", function(module, exports) {

let $c66cad1b763944a2$var$load = (parcelRequire("loK1v"))(4);
module.exports = $c66cad1b763944a2$var$load("8ukEq").then(()=>parcelRequire('kSseF'));

});

parcelRegister("01dXj", function(module, exports) {

let $003aeb6b1ee41b55$var$load = (parcelRequire("loK1v"))(4);
module.exports = $003aeb6b1ee41b55$var$load("f0x4d").then(()=>parcelRequire('fyPr9'));

});

parcelRegister("cBfgZ", function(module, exports) {

let $92c4c9a93eb89bfc$var$load = (parcelRequire("loK1v"))(4);
module.exports = $92c4c9a93eb89bfc$var$load("6kdMv").then(()=>parcelRequire('kNwDR'));

});

parcelRegister("lzvZE", function(module, exports) {

let $fb45af0e61330fac$var$load = (parcelRequire("loK1v"))(4);
module.exports = $fb45af0e61330fac$var$load("fiXBz").then(()=>parcelRequire('6RnhC'));

});



parcelRegister("boR01", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae22b3777879f93c$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/no-html-button */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");


var $3S16W = parcelRequire("3S16W");

var $5uXOq = parcelRequire("5uXOq");
const $ae22b3777879f93c$var$mentionStyle = {
    [(0, $3S16W.MentionType).SELF]: {
        background: `var(--ds-background-brand-bold, ${(0, $dbda9f692ace54dd$export$b3de0ae08da2ce64)})`,
        borderColor: 'transparent',
        text: `var(--ds-text-inverse, ${(0, $dbda9f692ace54dd$export$9fdfb749e33cdf97)})`,
        hoveredBackground: `var(--ds-background-brand-bold-hovered, ${(0, $dbda9f692ace54dd$export$b3de0ae08da2ce64)})`,
        pressedBackground: `var(--ds-background-brand-bold-pressed, ${(0, $dbda9f692ace54dd$export$b3de0ae08da2ce64)})`
    },
    [(0, $3S16W.MentionType).RESTRICTED]: {
        background: 'transparent',
        borderColor: `var(--ds-border-bold, ${(0, $dbda9f692ace54dd$export$c39c0fe0f26207ae)})`,
        text: `var(--ds-text, ${(0, $dbda9f692ace54dd$export$c39c0fe0f26207ae)})`,
        hoveredBackground: 'transparent',
        pressedBackground: 'transparent'
    },
    [(0, $3S16W.MentionType).DEFAULT]: {
        background: `var(--ds-background-neutral, ${(0, $dbda9f692ace54dd$export$920c0d5c49070351)})`,
        borderColor: 'transparent',
        text: `var(--ds-text-subtle, ${(0, $dbda9f692ace54dd$export$c39c0fe0f26207ae)})`,
        hoveredBackground: `var(--ds-background-neutral-hovered, ${(0, $dbda9f692ace54dd$export$920c0d5c49070351)})`,
        pressedBackground: `var(--ds-background-neutral-pressed, ${(0, $dbda9f692ace54dd$export$920c0d5c49070351)})`
    }
};
const $ae22b3777879f93c$var$getStyle = ({ mentionType: mentionType }, property)=>{
    const obj = $ae22b3777879f93c$var$mentionStyle[mentionType][property];
    return typeof obj === 'string' ? obj : obj;
};
const $ae22b3777879f93c$var$PrimitiveMention = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ mentionType: mentionType, ...other }, ref)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $f8Sb3.css)("display:inline;border:1px solid ", $ae22b3777879f93c$var$getStyle({
            mentionType: mentionType
        }, 'borderColor'), ";background:", $ae22b3777879f93c$var$getStyle({
            mentionType: mentionType
        }, 'background'), ";color:", $ae22b3777879f93c$var$getStyle({
            mentionType: mentionType
        }, 'text'), ";border-radius:20px;cursor:pointer;padding:0 0.3em 2px 0.23em;line-height:1.714;font-size:1em;font-weight:var(--ds-font-weight-regular, 400);word-break:break-word;&:hover{background:", $ae22b3777879f93c$var$getStyle({
            mentionType: mentionType
        }, 'hoveredBackground'), ";}&:active{background:", $ae22b3777879f93c$var$getStyle({
            mentionType: mentionType
        }, 'pressedBackground'), ";}"),
        ...other
    });
});
var $ae22b3777879f93c$export$2e2bcd8739ae039 = $ae22b3777879f93c$var$PrimitiveMention;

});

parcelRegister("g2vFv", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f2fc8c280c9252c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $1f2fc8c280c9252c$var$AsyncNoAccessTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("gzeHe")).then((module)=>{
        return {
            default: module.NoAccessTooltip
        };
    }));
var $1f2fc8c280c9252c$export$2e2bcd8739ae039 = $1f2fc8c280c9252c$var$AsyncNoAccessTooltip;

});
parcelRegister("gzeHe", function(module, exports) {

let $c0fb50a0c0faad2d$var$load = (parcelRequire("loK1v"))(4);
module.exports = $c0fb50a0c0faad2d$var$load("1FBc6").then(()=>parcelRequire('4EBSv'));

});


parcelRegister("hCedp", function(module, exports) {

$parcel$export(module.exports, "mentionRenderedUfoExperience", () => $7b05a4b43ad6b3dc$export$1d011e4240507c78);
$parcel$export(module.exports, "UfoErrorBoundary", () => $7b05a4b43ad6b3dc$export$5ef1c2550074a375);

var $5uXOq = parcelRequire("5uXOq");

var $iVQco = parcelRequire("iVQco");
var $l9Uwt = parcelRequire("l9Uwt");
const $7b05a4b43ad6b3dc$export$1d011e4240507c78 = new (0, $iVQco.ConcurrentExperience)('mention-rendered', {
    platform: {
        component: 'mention'
    },
    type: (0, $l9Uwt.ExperienceTypes).Load,
    performanceType: (0, $l9Uwt.ExperiencePerformanceTypes).PageSegmentLoad
});
class $7b05a4b43ad6b3dc$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch() {
        $7b05a4b43ad6b3dc$export$1d011e4240507c78.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}

});



parcelRegister("1L4Cd", function(module, exports) {

$parcel$export(module.exports, "default", () => $04ba8655f72c56b1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $b7bHf = parcelRequire("b7bHf");

var $ko6rZ = parcelRequire("ko6rZ");
function $04ba8655f72c56b1$export$2e2bcd8739ae039({ autoFocus: autoFocus, id: id, text: text, accessLevel: accessLevel, mentionProvider: mentionProvider, profilecardProvider: profilecardProvider, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, localId: localId }) {
    const { cloudId: cloudId, resourceClient: resourceClient } = profilecardProvider;
    const actions = (0, $5uXOq.useMemo)(()=>profilecardProvider.getActions(id, text, accessLevel), [
        accessLevel,
        id,
        profilecardProvider,
        text
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ko6rZ.default), {
        autoFocus: autoFocus,
        cloudId: cloudId,
        userId: id,
        resourceClient: resourceClient,
        actions: actions,
        trigger: "click",
        position: "bottom-end",
        testId: "mention-with-profilecard-trigger",
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        ariaLabel: text.replace(/^@/, ''),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b7bHf.default), {
            id: id,
            text: text,
            accessLevel: accessLevel,
            localId: localId,
            mentionProvider: mentionProvider,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave
        })
    });
}

});
parcelRegister("ko6rZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a2abae304e3fe14$export$2e2bcd8739ae039);


var $4JvFX = parcelRequire("4JvFX");

var $kx2PY = parcelRequire("kx2PY");
var $3a2abae304e3fe14$export$2e2bcd8739ae039 = (0, $kx2PY.default);

});
parcelRegister("4JvFX", function(module, exports) {

$parcel$export(module.exports, "ProfileCardLazy", () => $ad4a96f7fc200f87$export$403d297463f226af);

var $5uXOq = parcelRequire("5uXOq");

const $ad4a96f7fc200f87$export$403d297463f226af = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("knRDd")));

});
parcelRegister("knRDd", function(module, exports) {

let $ed6f8ebf21007e6c$var$load = (parcelRequire("loK1v"))(4);
module.exports = Promise.all([
    $ed6f8ebf21007e6c$var$load("aCh9P"),
    $ed6f8ebf21007e6c$var$load("bxxT5"),
    $ed6f8ebf21007e6c$var$load("jpUMx")
]).then(()=>parcelRequire('gFTVm'));

});


parcelRegister("kx2PY", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bc1a11c544611fd$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2Dcc2 = parcelRequire("2Dcc2");

var $kmSlU = parcelRequire("kmSlU");
var $k4NZN = parcelRequire("k4NZN");

var $hFKXd = parcelRequire("hFKXd");

var $bRHJ4 = parcelRequire("bRHJ4");

var $1wToE = parcelRequire("1wToE");

var $7nT3L = parcelRequire("7nT3L");

var $7NgkP = parcelRequire("7NgkP");

var $drWLA = parcelRequire("drWLA");

var $lL6Xv = parcelRequire("lL6Xv");


var $ejj2T = parcelRequire("ejj2T");

var $4JvFX = parcelRequire("4JvFX");

var $knYHp = parcelRequire("knYHp");
function $9bc1a11c544611fd$var$ProfileCardContent({ profilecardProps: profilecardProps, userId: userId, cloudId: cloudId, resourceClient: resourceClient, viewingUserId: viewingUserId, trigger: trigger, product: product, isAgent: isAgent, profileCardAction: profileCardAction, hasError: hasError, errorType: errorType, agentActions: agentActions, addFlag: addFlag }) {
    if (isAgent) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ejj2T.AgentProfileCardResourced), {
        accountId: userId,
        cloudId: cloudId,
        resourceClient: resourceClient,
        viewingUserId: viewingUserId,
        trigger: trigger,
        product: product,
        onChatClick: agentActions?.onChatClick,
        onConversationStartersClick: agentActions?.onConversationStartersClick,
        addFlag: addFlag
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4JvFX.ProfileCardLazy), {
            ...profilecardProps,
            actions: profileCardAction,
            hasError: hasError,
            errorType: errorType,
            withoutElevation: true
        })
    });
}
function $9bc1a11c544611fd$export$2e2bcd8739ae039({ autoFocus: autoFocus, trigger: trigger = 'hover', userId: userId, cloudId: cloudId, resourceClient: resourceClient, actions: actions = [], position: position = 'bottom-start', children: children, testId: testId, addFlag: addFlag, onReportingLinesClick: onReportingLinesClick, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, prepopulatedData: prepopulatedData, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, viewingUserId: viewingUserId, product: product, agentActions: agentActions, ariaHideProfileTrigger: ariaHideProfileTrigger = false, isVisible: propsIsVisible }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2Dcc2.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isMounted = (0, $5uXOq.useRef)(false);
    const showDelay = trigger === 'click' || propsIsVisible && (0, $hFKXd.fg)('fix_profilecard_trigger_isvisible') ? 0 : (0, $ebb4ffc4551ca474$export$5b956b542f1bc1b3);
    const hideDelay = trigger === 'click' || propsIsVisible && (0, $hFKXd.fg)('fix_profilecard_trigger_isvisible') ? 0 : (0, $ebb4ffc4551ca474$export$89a9f35a94d7f196);
    const showTimer = (0, $5uXOq.useRef)(0);
    const hideTimer = (0, $5uXOq.useRef)(0);
    const [visible, setVisible] = (0, $5uXOq.useState)(false);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(undefined);
    const [hasError, setHasError] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [data, setData] = (0, $5uXOq.useState)(null);
    const [reportingLinesData, setReportingLinesData] = (0, $5uXOq.useState)(undefined);
    const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $5uXOq.useState)(false);
    const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $5uXOq.useState)(undefined);
    const [kudosDrawerOpen, setKudosDrawerOpen] = (0, $5uXOq.useState)(false);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $5uXOq.useState)(false);
    const triggerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        // Reset state when the userId changes
        setIsLoading(undefined);
        setHasError(false);
        setError(null);
        setData(null);
        setReportingLinesData(undefined);
        setShouldShowGiveKudos(false);
        setTeamCentralBaseUrl(undefined);
    }, [
        userId
    ]);
    const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
        // Don't fire any analytics if the component is unmounted
        if (!isMounted.current) return;
        (0, $lL6Xv.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const hideProfilecard = (0, $5uXOq.useCallback)(()=>{
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        if (!isTriggeredUsingKeyboard) hideTimer.current = window.setTimeout(()=>{
            setVisible(false);
            onVisibilityChange && onVisibilityChange(false);
        }, hideDelay);
    }, [
        hideDelay,
        isTriggeredUsingKeyboard,
        onVisibilityChange
    ]);
    const handleKeyboardClose = (0, $5uXOq.useCallback)((event)=>{
        if (event.key && event.key !== 'Escape') return;
        if (triggerRef.current) triggerRef.current.focus();
        setTriggeredUsingKeyboard(false);
        setVisible(false);
        onVisibilityChange && onVisibilityChange(false);
    }, [
        setTriggeredUsingKeyboard,
        setVisible,
        onVisibilityChange
    ]);
    const handleClientSuccess = (0, $5uXOq.useCallback)((profileData, reportingLinesData, shouldShowGiveKudos, teamCentralBaseUrl)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(false);
        setData(profileData);
        setReportingLinesData(reportingLinesData);
        setTeamCentralBaseUrl(teamCentralBaseUrl);
        setShouldShowGiveKudos(shouldShowGiveKudos);
    }, [
        setHasError,
        setIsLoading,
        setData,
        setReportingLinesData,
        setShouldShowGiveKudos
    ]);
    const handleClientError = (0, $5uXOq.useCallback)((err)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(true);
        setError(err);
    }, [
        setHasError,
        setIsLoading,
        setError
    ]);
    const clientFetchProfile = (0, $5uXOq.useCallback)(async ()=>{
        if (isLoading === true) // don't fetch data when fetching is in process
        return;
        setIsLoading(true);
        setHasError(false);
        setError(null);
        setData(null);
        try {
            const requests = Promise.all([
                resourceClient.getProfile(cloudId || '', userId, fireAnalytics),
                resourceClient.getReportingLines(userId),
                resourceClient.shouldShowGiveKudos(),
                resourceClient.getTeamCentralBaseUrl({
                    withOrgContext: true,
                    withSiteContext: true
                })
            ]);
            const responses = await requests;
            handleClientSuccess(...responses);
        } catch (err) {
            handleClientError(err);
        }
    }, [
        cloudId,
        fireAnalytics,
        isLoading,
        resourceClient,
        userId,
        handleClientSuccess,
        handleClientError
    ]);
    const showProfilecard = (0, $5uXOq.useCallback)(()=>{
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(()=>{
            if (!visible) {
                clientFetchProfile();
                setVisible(true);
                onVisibilityChange && onVisibilityChange(true);
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        clientFetchProfile,
        onVisibilityChange
    ]);
    const onClick = (0, $5uXOq.useCallback)((event)=>{
        // If the user clicks on the trigger then we don't want that click event to
        // propagate out to parent containers. For example when clicking a mention
        // lozenge in an inline-edit.
        event.stopPropagation();
        showProfilecard();
        if (!visible) fireAnalytics((0, $lL6Xv.cardTriggered)('user', 'click'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onMouseEnter = (0, $5uXOq.useCallback)(()=>{
        showProfilecard();
        if (!visible) fireAnalytics((0, $lL6Xv.cardTriggered)('user', 'hover'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onKeyPress = (0, $5uXOq.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setTriggeredUsingKeyboard(true);
            showProfilecard();
            if (!visible) fireAnalytics((0, $lL6Xv.cardTriggered)('user', 'click'));
        }
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onFocus = (0, $5uXOq.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $hFKXd.fg)('fix_profilecard_trigger_isvisible')) return;
        // If the prop isVisible is not defined, we don't want to do anything
        if (propsIsVisible === undefined) return;
        // If the prop isVisible is defined, we want to show or hide the profile card based on the value
        if (propsIsVisible) showProfilecard();
        else hideProfilecard();
    }, [
        hideProfilecard,
        propsIsVisible,
        showProfilecard
    ]);
    const containerListeners = (0, $5uXOq.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    const filterActions = (0, $5uXOq.useCallback)(()=>{
        return (0, $7nT3L.default)(actions, data);
    }, [
        actions,
        data
    ]);
    const openKudosDrawer = ()=>{
        hideProfilecard();
        setKudosDrawerOpen(true);
    };
    const closeKudosDrawer = ()=>{
        setKudosDrawerOpen(false);
    };
    const showLoading = isLoading === true || isLoading === undefined;
    const wrapperProps = (0, $5uXOq.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onFocus: onFocus
        } : {}, [
        hideProfilecard,
        onFocus,
        onMouseEnter,
        trigger
    ]);
    const profilecardProps = {
        userId: userId,
        fullName: prepopulatedData?.fullName,
        isCurrentUser: userId === viewingUserId,
        clientFetchProfile: clientFetchProfile,
        ...data,
        reportingLines: reportingLinesData,
        onReportingLinesClick: onReportingLinesClick,
        isKudosEnabled: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId,
        openKudosDrawer: openKudosDrawer,
        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
        disabledAriaAttributes: disabledAriaAttributes
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bRHJ4.default), {
                isOpen: !!visible,
                onClose: (event)=>{
                    hideProfilecard();
                    handleKeyboardClose(event);
                },
                placement: position,
                offset: offset ?? [
                    0,
                    8
                ],
                content: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        ...wrapperProps,
                        children: showLoading ? /*#__PURE__*/ (0, $2OMIu.jsx)($9bc1a11c544611fd$var$LoadingView, {
                            fireAnalytics: fireAnalytics
                        }) : visible && /*#__PURE__*/ (0, $2OMIu.jsx)($9bc1a11c544611fd$var$ProfileCardContent, {
                            profilecardProps: profilecardProps,
                            isAgent: !!data?.isAgent,
                            userId: userId,
                            cloudId: cloudId,
                            resourceClient: resourceClient,
                            viewingUserId: viewingUserId,
                            trigger: trigger,
                            product: product,
                            profileCardAction: filterActions(),
                            errorType: error,
                            hasError: hasError,
                            agentActions: agentActions,
                            addFlag: addFlag
                        })
                    }),
                trigger: (triggerProps)=>{
                    const { ref: callbackRef, ...innerProps } = triggerProps;
                    const ref = (element)=>{
                        triggerRef.current = element;
                        if (typeof callbackRef === 'function') callbackRef(element);
                    };
                    const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = innerProps;
                    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        ...disabledAriaAttributes ? restInnerProps : triggerProps,
                        ...containerListeners,
                        ref: ref,
                        "data-testid": testId,
                        ...!ariaHideProfileTrigger && {
                            'aria-labelledby': ariaLabelledBy
                        },
                        ...disabledAriaAttributes ? {} : {
                            role: 'button',
                            //  aria-hidden cannot contain focusable elements: https://dequeuniversity.com/rules/axe/3.5/aria-hidden-focus
                            tabIndex: ariaHideProfileTrigger ? -1 : 0,
                            'aria-label': ariaHideProfileTrigger ? undefined : (0, $7NgkP.default)(ariaLabel, profilecardProps.fullName, formatMessage)
                        },
                        ...ariaHideProfileTrigger && {
                            'aria-hidden': 'true'
                        },
                        children: children
                    });
                },
                zIndex: (0, $1wToE.layers).modal(),
                shouldUseCaptureOnOutsideClick: true,
                autoFocus: autoFocus ?? trigger === 'click',
                // This feature gate is currently enabled only for Jira_Web to avoid UI issues in Confluence_Web.
                shouldRenderToParent: (0, $hFKXd.fg)('enable_appropriate_reading_order_in_profile_card')
            }),
            shouldShowGiveKudos && teamCentralBaseUrl && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kmSlU.GiveKudosLauncherLazy), {
                    isOpen: kudosDrawerOpen,
                    recipient: {
                        type: (0, $k4NZN.KudosType).INDIVIDUAL,
                        recipientId: userId
                    },
                    analyticsSource: "profile-card",
                    teamCentralBaseUrl: teamCentralBaseUrl,
                    cloudId: cloudId,
                    addFlag: addFlag,
                    onClose: closeKudosDrawer
                })
            })
        ]
    });
}
const $9bc1a11c544611fd$var$LoadingView = ({ fireAnalytics: fireAnalytics })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $drWLA.CardWrapper), {
        testId: "profilecard.profilecardtrigger.loading",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $knYHp.default), {
            fireAnalytics: fireAnalytics
        })
    });

});
parcelRegister("kmSlU", function(module, exports) {

$parcel$export(module.exports, "GiveKudosLauncherLazy", () => $6fa95ca76ce14127$export$93fe397a02fe8b76);

var $5uXOq = parcelRequire("5uXOq");

const $6fa95ca76ce14127$export$93fe397a02fe8b76 = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("lEQjS")));

});
parcelRegister("lEQjS", function(module, exports) {

let $fc45eafba38514f0$var$load = (parcelRequire("loK1v"))(4);
module.exports = Promise.all([
    $fc45eafba38514f0$var$load("4X3wS"),
    $fc45eafba38514f0$var$load("hSQJ5"),
    $fc45eafba38514f0$var$load("aCh9P"),
    $fc45eafba38514f0$var$load("bxxT5"),
    $fc45eafba38514f0$var$load("7C9cO")
]).then(()=>parcelRequire('5pCAN'));

});


parcelRegister("k4NZN", function(module, exports) {

$parcel$export(module.exports, "KudosType", () => $17b7f09b38b36008$export$4fa2020056771264);
$parcel$export(module.exports, "FlagEventType", () => $17b7f09b38b36008$export$d21f9befaa2961a);
$parcel$export(module.exports, "isFlagEventTypeValue", () => $17b7f09b38b36008$export$7a1fc1a1b0477464);
var $17b7f09b38b36008$export$4fa2020056771264 = /*#__PURE__*/ function(KudosType) {
    KudosType["INDIVIDUAL"] = "individual";
    KudosType["TEAM"] = "team";
    KudosType["MIXED"] = "mixed";
    return KudosType;
}({});
var $17b7f09b38b36008$export$d21f9befaa2961a = /*#__PURE__*/ function(FlagEventType) {
    FlagEventType["KUDOS_CREATED"] = "kudos-created";
    FlagEventType["KUDOS_FAILED"] = "kudos-failed";
    FlagEventType["JIRA_KUDOS_CREATED"] = "jira-kudos-created";
    FlagEventType["JIRA_KUDOS_FAILED"] = "jira-kudos-failed";
    FlagEventType["DIRTY"] = "dirty";
    FlagEventType["CLOSE"] = "close";
    return FlagEventType;
}({});
const $17b7f09b38b36008$export$7a1fc1a1b0477464 = (value)=>{
    return Object.values($17b7f09b38b36008$export$d21f9befaa2961a).includes(value);
};

});

parcelRegister("7nT3L", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3ca68a0fed5f06b$export$2e2bcd8739ae039);
const $a3ca68a0fed5f06b$var$filterActions = (actions = [], data)=>{
    return actions.filter((action)=>{
        if (!action.shouldRender) return true;
        else if (typeof action.shouldRender !== 'function') return Boolean(action.shouldRender);
        return action.shouldRender(data);
    });
};
var $a3ca68a0fed5f06b$export$2e2bcd8739ae039 = $a3ca68a0fed5f06b$var$filterActions;

});

parcelRegister("7NgkP", function(module, exports) {

$parcel$export(module.exports, "default", () => $487d510670ebdfb7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $487d510670ebdfb7$var$getLabelMessage = (ariaLabelProp, fullName, formatMessage)=>{
    if (ariaLabelProp) return ariaLabelProp;
    return fullName ? formatMessage($487d510670ebdfb7$var$messages.label, {
        fullName: fullName
    }) : formatMessage($487d510670ebdfb7$var$messages.fallbackLabel);
};
const $487d510670ebdfb7$var$messages = (0, $7VHMR.defineMessages)({
    fallbackLabel: {
        id: 'profilecard.user.trigger.fallback-aria-label',
        defaultMessage: 'More information about this user',
        description: 'Label for profile card trigger when we do not have user name'
    },
    label: {
        id: 'profilecard.user.trigger.aria-label',
        defaultMessage: 'More information about {fullName}',
        description: 'Label for profile card trigger'
    }
});
var $487d510670ebdfb7$export$2e2bcd8739ae039 = $487d510670ebdfb7$var$getLabelMessage;

});

parcelRegister("drWLA", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", () => $197fe2e714b3722b$export$6aa22a823032b784);
$parcel$export(module.exports, "SpinnerContainer", () => $197fe2e714b3722b$export$a5e06607a5ac6158);
/* UserTrigger.tsx generated by @compiled/babel-plugin v0.36.1 */ // PLEASE NOTE: This file is sync-loaded with the trigger components. Only add components here that
// are necessary for the main render of the trigger component to help maintain bundle size.
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bGNZj = parcelRequire("bGNZj");

var $hFKXd = parcelRequire("hFKXd");

var $5JBkS = parcelRequire("5JBkS");

var $42CYN = parcelRequire("42CYN");

var $bWGt6 = parcelRequire("bWGt6");
function $197fe2e714b3722b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $197fe2e714b3722b$var$styles = {
    cardWrapper: "_2rkoglpi _1bsb1gwv",
    spinnerContainer: "_4cvr1h6o _1e0c1txw _4t3i16xz _1bah1h6o _kqswh2mm"
};
const $197fe2e714b3722b$export$6aa22a823032b784 = ({ children: children, role: role, testId: testId, labelledBy: labelledBy })=>(0, $hFKXd.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5JBkS.default), {
        xcss: (0, $bGNZj.cx)($197fe2e714b3722b$var$styles.cardWrapper),
        backgroundColor: 'elevation.surface.overlay',
        role: role,
        testId: testId,
        "aria-labelledby": labelledBy,
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($197fe2e714b3722b$var$CardWrapperLegacy, {
        "data-testid": testId,
        role: role,
        "aria-labelledby": labelledBy,
        children: children
    });
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $197fe2e714b3722b$var$CardWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1fdk60v1"
})("background-color:", (0, $42CYN.bgColor), ";border-radius:var(--ds-border-radius, 3px);width:360px;");
const $197fe2e714b3722b$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>(0, $hFKXd.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5JBkS.default), {
        testId: testId,
        xcss: (0, $bGNZj.cx)($197fe2e714b3722b$var$styles.spinnerContainer),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($197fe2e714b3722b$var$SpinnerContainerLegacy, {
        "data-testid": testId,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $197fe2e714b3722b$var$SpinnerContainerLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1fdk60v0"
})({
    name: "1e8m6rx",
    styles: "align-items:center;display:flex;height:96px;justify-content:center;position:relative"
});

});
parcelRegister("42CYN", function(module, exports) {

$parcel$export(module.exports, "bgColor", () => $b40792da90aac98f$export$7dcbec377a25efc6);
$parcel$export(module.exports, "headerBgColor", () => $b40792da90aac98f$export$d3ec0459d8f4bbed);
$parcel$export(module.exports, "teamHeaderBgColor", () => $b40792da90aac98f$export$afc7ad7e78cf1c79);
$parcel$export(module.exports, "headerBgColorDisabledUser", () => $b40792da90aac98f$export$ef73fded6fab455c);
$parcel$export(module.exports, "headerTextColor", () => $b40792da90aac98f$export$5c2df128da90e8de);
$parcel$export(module.exports, "appLabelBgColor", () => $b40792da90aac98f$export$6f79b778f6280d31);
$parcel$export(module.exports, "appLabelTextColor", () => $b40792da90aac98f$export$3db47a978b9599f9);
$parcel$export(module.exports, "labelTextColor", () => $b40792da90aac98f$export$dd73341f2a5541fa);
$parcel$export(module.exports, "labelIconColor", () => $b40792da90aac98f$export$5a20f73e634c37e3);
$parcel$export(module.exports, "errorIconColor", () => $b40792da90aac98f$export$85e73a744c5d1042);
$parcel$export(module.exports, "errorTitleColor", () => $b40792da90aac98f$export$be3c814f7ed506ed);

const $b40792da90aac98f$export$7dcbec377a25efc6 = `var(--ds-surface-overlay, ${(0, $dbda9f692ace54dd$export$29a4f05edc054374)})`;
const $b40792da90aac98f$export$d3ec0459d8f4bbed = `var(--ds-background-brand-bold, ${(0, $dbda9f692ace54dd$export$a6ee3d71bc067634)})`;
const $b40792da90aac98f$export$afc7ad7e78cf1c79 = `var(--ds-background-neutral, ${(0, $dbda9f692ace54dd$export$8754fc7e6d8b3000)})`;
const $b40792da90aac98f$export$ef73fded6fab455c = `var(--ds-background-disabled, ${(0, $dbda9f692ace54dd$export$3e51e8f1440314ba)})`;
const $b40792da90aac98f$export$5c2df128da90e8de = `var(--ds-text-inverse, ${(0, $dbda9f692ace54dd$export$29a4f05edc054374)})`;
const $b40792da90aac98f$export$a882617dcf7f98a6 = `var(--ds-text, ${(0, $dbda9f692ace54dd$export$7d61b15e0da132af)})`;
const $b40792da90aac98f$export$6f79b778f6280d31 = `var(--ds-background-neutral, ${(0, $dbda9f692ace54dd$export$9fdfb749e33cdf97)})`;
const $b40792da90aac98f$export$3db47a978b9599f9 = `var(--ds-text, ${(0, $dbda9f692ace54dd$export$c39c0fe0f26207ae)})`;
const $b40792da90aac98f$export$dd73341f2a5541fa = `var(--ds-text, ${(0, $dbda9f692ace54dd$export$7d61b15e0da132af)})`;
const $b40792da90aac98f$export$5a20f73e634c37e3 = `var(--ds-text-subtlest, ${(0, $dbda9f692ace54dd$export$c2e91cbeada39b8b)})`;
const $b40792da90aac98f$export$85e73a744c5d1042 = `var(--ds-text-disabled, ${(0, $dbda9f692ace54dd$export$7c87d337fb91a97d)})`;
const $b40792da90aac98f$export$be3c814f7ed506ed = `var(--ds-text, ${(0, $dbda9f692ace54dd$export$7d61b15e0da132af)})`;
const $b40792da90aac98f$export$ddf766d3bfcf965c = `var(--ds-text-subtlest, ${(0, $dbda9f692ace54dd$export$7c87d337fb91a97d)})`;

});


parcelRegister("lL6Xv", function(module, exports) {

$parcel$export(module.exports, "fireEvent", () => $3674b041c85fc0cd$export$43835e9acf248a15);
$parcel$export(module.exports, "cardTriggered", () => $3674b041c85fc0cd$export$d50ab8a3b6975c);
$parcel$export(module.exports, "teamRequestAnalytics", () => $3674b041c85fc0cd$export$c9b0e37b229a297b);
$parcel$export(module.exports, "userRequestAnalytics", () => $3674b041c85fc0cd$export$12dae48763368ac9);
$parcel$export(module.exports, "profileCardRendered", () => $3674b041c85fc0cd$export$41816a317479160b);
$parcel$export(module.exports, "actionClicked", () => $3674b041c85fc0cd$export$fdcd134fbeb1f921);
$parcel$export(module.exports, "reportingLinesClicked", () => $3674b041c85fc0cd$export$93260987012593be);
$parcel$export(module.exports, "moreActionsClicked", () => $3674b041c85fc0cd$export$79befd155063a6a7);
$parcel$export(module.exports, "teamAvatarClicked", () => $3674b041c85fc0cd$export$2703289b35687fde);
$parcel$export(module.exports, "moreMembersClicked", () => $3674b041c85fc0cd$export$b4411a7661cf2d3f);
$parcel$export(module.exports, "errorRetryClicked", () => $3674b041c85fc0cd$export$c86679da702d560e);
$parcel$export(module.exports, "agentRequestAnalytics", () => $3674b041c85fc0cd$export$a9f8c9f412cf5664);

var $f0Crb = parcelRequire("f0Crb");
/** Below lines are copied from teams common analytics */ const $3674b041c85fc0cd$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $3674b041c85fc0cd$var$runItLater = (cb)=>{
    const requestIdleCallback = window.requestIdleCallback;
    if (typeof requestIdleCallback === 'function') return requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $3674b041c85fc0cd$export$43835e9acf248a15 = (createAnalyticsEvent, body)=>{
    if (!createAnalyticsEvent) return;
    $3674b041c85fc0cd$var$runItLater(()=>{
        createAnalyticsEvent(body).fire($3674b041c85fc0cd$var$ANALYTICS_CHANNEL);
    });
};
/** Above lines are copied from teams common analytics */ const $3674b041c85fc0cd$var$TEAM_SUBJECT = 'teamProfileCard';
const $3674b041c85fc0cd$var$USER_SUBJECT = 'profilecard';
const $3674b041c85fc0cd$var$AGENT_SUBJECT = 'rovoAgentProfilecard';
const $3674b041c85fc0cd$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes,
            firedAt: Math.round((0, $f0Crb.getPageTime)())
        }
    });
const $3674b041c85fc0cd$var$getActionSubject = (type)=>{
    switch(type){
        case 'user':
            return $3674b041c85fc0cd$var$USER_SUBJECT;
        case 'team':
            return $3674b041c85fc0cd$var$TEAM_SUBJECT;
        case 'agent':
            return $3674b041c85fc0cd$var$AGENT_SUBJECT;
        default:
            return 'user';
    }
};
const $3674b041c85fc0cd$export$d50ab8a3b6975c = (type, method, teamId)=>{
    return $3674b041c85fc0cd$var$createEvent('ui', 'triggered', $3674b041c85fc0cd$var$getActionSubject(type), undefined, {
        method: method,
        ...type === 'team' && teamId ? {
            teamId: teamId
        } : {}
    });
};
const $3674b041c85fc0cd$export$c9b0e37b229a297b = (action, attributes)=>$3674b041c85fc0cd$var$createEvent('operational', action, $3674b041c85fc0cd$var$TEAM_SUBJECT, 'request', attributes);
const $3674b041c85fc0cd$export$12dae48763368ac9 = (action, attributes)=>$3674b041c85fc0cd$var$createEvent('operational', action, $3674b041c85fc0cd$var$USER_SUBJECT, 'request', attributes);
const $3674b041c85fc0cd$export$41816a317479160b = (type, actionSubjectId, attributes)=>$3674b041c85fc0cd$var$createEvent('ui', 'rendered', $3674b041c85fc0cd$var$getActionSubject(type), actionSubjectId, attributes);
const $3674b041c85fc0cd$export$fdcd134fbeb1f921 = (type, attributes)=>$3674b041c85fc0cd$var$createEvent('ui', 'clicked', $3674b041c85fc0cd$var$getActionSubject(type), 'action', attributes);
const $3674b041c85fc0cd$export$93260987012593be = (attributes)=>$3674b041c85fc0cd$var$createEvent('ui', 'clicked', $3674b041c85fc0cd$var$USER_SUBJECT, 'reportingLines', attributes);
const $3674b041c85fc0cd$export$79befd155063a6a7 = (type, attributes)=>$3674b041c85fc0cd$var$createEvent('ui', 'clicked', $3674b041c85fc0cd$var$getActionSubject(type), 'moreActions', attributes);
const $3674b041c85fc0cd$export$2703289b35687fde = (attributes)=>$3674b041c85fc0cd$var$createEvent('ui', 'clicked', $3674b041c85fc0cd$var$TEAM_SUBJECT, 'avatar', attributes);
const $3674b041c85fc0cd$export$b4411a7661cf2d3f = (attributes)=>$3674b041c85fc0cd$var$createEvent('ui', 'clicked', $3674b041c85fc0cd$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $3674b041c85fc0cd$export$c86679da702d560e = (attributes)=>$3674b041c85fc0cd$var$createEvent('ui', 'clicked', $3674b041c85fc0cd$var$TEAM_SUBJECT, 'errorRetry', attributes);
const $3674b041c85fc0cd$export$a9f8c9f412cf5664 = (action, actionSubjectId, attributes)=>$3674b041c85fc0cd$var$createEvent('operational', action, $3674b041c85fc0cd$var$AGENT_SUBJECT, actionSubjectId || 'request', attributes);

});
parcelRegister("f0Crb", function(module, exports) {

$parcel$export(module.exports, "getPageTime", () => $3054df903dd8b007$export$e9faea7c41053334);
const $3054df903dd8b007$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $3054df903dd8b007$var$performanceAvailable = $3054df903dd8b007$var$isPerformanceAvailable();
const $3054df903dd8b007$var$initialPageTime = Date.now();
const $3054df903dd8b007$export$e9faea7c41053334 = ()=>{
    if ($3054df903dd8b007$var$performanceAvailable) return performance.now();
    return Date.now() - $3054df903dd8b007$var$initialPageTime;
};

});


const $ebb4ffc4551ca474$export$5b956b542f1bc1b3 = 800;
const $ebb4ffc4551ca474$export$89a9f35a94d7f196 = 200;

parcelRegister("ejj2T", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardResourced", () => $43f4b5bfa58f8f08$export$4b013ffffcb40af8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2Dcc2 = parcelRequire("2Dcc2");

var $lL6Xv = parcelRequire("lL6Xv");

var $7nTes = parcelRequire("7nTes");

var $lS8D6 = parcelRequire("lS8D6");

var $YwwdH = parcelRequire("YwwdH");

var $lqrar = parcelRequire("lqrar");
const $43f4b5bfa58f8f08$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $5uXOq.useState)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2Dcc2.useAnalyticsEvents)();
    const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $lL6Xv.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const creatorUserId = (0, $5uXOq.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $7nTes.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const getCreator = (0, $5uXOq.useCallback)(async (creator_type, creator)=>{
        if (!creator) return undefined;
        switch(creator_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                try {
                    if (!creatorUserId || !props.cloudId) return undefined;
                    const creatorInfo = await props.resourceClient.getProfile(creatorUserId, props.cloudId, fireAnalytics);
                    return {
                        type: 'CUSTOMER',
                        name: creatorInfo.fullName,
                        profileLink: `/people/${creatorUserId}`,
                        id: creatorUserId
                    };
                } catch (error) {
                    return undefined;
                }
            default:
                return undefined;
        }
    }, [
        creatorUserId,
        fireAnalytics,
        props.cloudId,
        props.resourceClient
    ]);
    const fetchData = (0, $5uXOq.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const profileData = await props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireAnalytics);
            const agentCreatorInfo = await getCreator(profileData?.creator_type, profileData?.creator || undefined);
            setAgentData({
                ...profileData,
                creatorInfo: agentCreatorInfo
            });
        } catch (err) {
            setError(err);
        } finally{
            setIsLoading(false);
        }
    }, [
        fireAnalytics,
        getCreator,
        props.accountId,
        props.resourceClient
    ]);
    (0, $5uXOq.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $YwwdH.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lS8D6.default), {
            reload: ()=>{
                fetchData();
            },
            errorType: error || null,
            fireAnalytics: ()=>{}
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lqrar.AgentProfileCardLazy), {
            agent: agentData,
            isLoading: isLoading,
            hasError: !!error,
            isCreatedByViewingUser: creatorUserId === props.viewingUserId,
            product: props.product,
            onConversationStartersClick: props.onConversationStartersClick,
            onChatClick: props.onChatClick,
            addFlag: props.addFlag,
            resourceClient: props.resourceClient,
            cloudId: props.cloudId
        })
    });
};

});
parcelRegister("7nTes", function(module, exports) {

$parcel$export(module.exports, "getAAIDFromARI", () => $eac88961c0a9316f$export$3761e66a04602cbd);
const $eac88961c0a9316f$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $eac88961c0a9316f$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($eac88961c0a9316f$export$470b0d72e4fdc43a, '');
};

});

parcelRegister("lS8D6", function(module, exports) {

$parcel$export(module.exports, "default", () => $784bb34e1d1b3caa$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $goLm2 = parcelRequire("goLm2");

var $YIdgD = parcelRequire("YIdgD");

var $7BLQd = parcelRequire("7BLQd");

var $iK9zs = parcelRequire("iK9zs");

var $hFKXd = parcelRequire("hFKXd");

var $2zROn = parcelRequire("2zROn");

var $6Py1c = parcelRequire("6Py1c");

var $lL6Xv = parcelRequire("lL6Xv");
const $784bb34e1d1b3caa$var$ErrorMessage = (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $5uXOq.useEffect)(()=>{
        fireAnalytics((0, $lL6Xv.profileCardRendered)('user', 'error', {
            hasRetry: hasRetry,
            errorType: errorReason
        }));
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6Py1c.ErrorTitle), {
            children: "The user is no longer available for the site"
        });
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $6Py1c.ErrorTitle), {
            children: [
                "Oops, looks like we\u2019re having issues",
                /*#__PURE__*/ (0, $2OMIu.jsx)("br", {}),
                reload && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2zROn.default), {
                    color: "color.text.subtlest",
                    children: "Try again and we\u2019ll give it another shot"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $6Py1c.ErrorWrapper), {
        testId: "profilecard-error",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7BLQd))), {
                label: "icon error",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($iK9zs))),
                LEGACY_size: "xlarge"
            }),
            errorContent(),
            reload && ((0, $hFKXd.fg)('ptc_migrate_buttons') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $YIdgD.default), {
                onClick: reload,
                children: "Try again"
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $goLm2.default), {
                appearance: "link",
                onClick: reload,
                children: "Try again"
            }))
        ]
    });
};
var $784bb34e1d1b3caa$export$2e2bcd8739ae039 = $784bb34e1d1b3caa$var$ErrorMessage;

});
parcelRegister("6Py1c", function(module, exports) {

$parcel$export(module.exports, "ErrorWrapper", () => $39e365385b4b6ce7$export$bb27b7e39840238f);
$parcel$export(module.exports, "ErrorTitle", () => $39e365385b4b6ce7$export$b065fd053267ec81);
$parcel$export(module.exports, "TeamErrorText", () => $39e365385b4b6ce7$export$90d92ccfb27352c6);
/* Error.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bGNZj = parcelRequire("bGNZj");

var $hFKXd = parcelRequire("hFKXd");

var $5JBkS = parcelRequire("5JBkS");


var $42CYN = parcelRequire("42CYN");

var $bWGt6 = parcelRequire("bWGt6");
const $39e365385b4b6ce7$var$styles = {
    errorWrapper: "_y3gn1h6o _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    errorTitle: "_11c82smr _syaz1fxt _19pku2gc",
    teamErrorText: "_syaz1wmz _19pku2gc"
};
const $39e365385b4b6ce7$export$bb27b7e39840238f = (props)=>(0, $hFKXd.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5JBkS.default), {
        xcss: (0, $bGNZj.cx)($39e365385b4b6ce7$var$styles.errorWrapper),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($39e365385b4b6ce7$var$ErrorWrapperLegacy, {
        "data-testId": props.testId,
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $39e365385b4b6ce7$var$ErrorWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1gaqn292"
})({
    textAlign: 'center',
    padding: "var(--ds-space-300, 24px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $42CYN.errorIconColor)
});
const $39e365385b4b6ce7$export$b065fd053267ec81 = (props)=>(0, $hFKXd.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5JBkS.default), {
        xcss: (0, $bGNZj.cx)($39e365385b4b6ce7$var$styles.errorTitle),
        children: props.children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($39e365385b4b6ce7$var$ErrorTitleLegacy, {
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $39e365385b4b6ce7$var$ErrorTitleLegacy = /*#__PURE__*/ (0, $bWGt6.default)("p", {
    target: "e1gaqn291"
})({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $42CYN.errorTitleColor),
    margin: `${"var(--ds-space-100, 8px)"} 0`
});
const $39e365385b4b6ce7$export$90d92ccfb27352c6 = (props)=>(0, $hFKXd.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5JBkS.default), {
        xcss: (0, $bGNZj.cx)($39e365385b4b6ce7$var$styles.teamErrorText),
        children: props.children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($39e365385b4b6ce7$var$TeamErrorTextLegacy, {
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $39e365385b4b6ce7$var$TeamErrorTextLegacy = /*#__PURE__*/ (0, $bWGt6.default)("p", {
    target: "e1gaqn290"
})({
    color: `var(--ds-text-subtlest, ${(0, $dbda9f692ace54dd$export$f563ee71e9ee74cd)})`,
    marginTop: "var(--ds-space-100, 8px)"
});

});


parcelRegister("YwwdH", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardWrapper", () => $9f3d516ccee231c0$export$2c6604b50c274e6f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $e65Lk = parcelRequire("e65Lk");
var $ii5wQ = parcelRequire("ii5wQ");
const $9f3d516ccee231c0$var$styles = (0, $ii5wQ.xcss)({
    width: '360px'
});
const $9f3d516ccee231c0$export$2c6604b50c274e6f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e65Lk.default), {
        xcss: $9f3d516ccee231c0$var$styles,
        children: children
    });
};

});

parcelRegister("lqrar", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardLazy", () => $9ec6253f7a77843a$export$ed0ca9c1d49ea0bf);

var $5uXOq = parcelRequire("5uXOq");

const $9ec6253f7a77843a$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("1LIYx")));

});
parcelRegister("1LIYx", function(module, exports) {

let $149d116f60adbeac$var$load = (parcelRequire("loK1v"))(4);
module.exports = Promise.all([
    $149d116f60adbeac$var$load("4X3wS"),
    $149d116f60adbeac$var$load("hSQJ5"),
    $149d116f60adbeac$var$load("aCh9P"),
    $149d116f60adbeac$var$load("bxxT5"),
    $149d116f60adbeac$var$load("dcxHC")
]).then(()=>parcelRequire('ajdIT'));

});



parcelRegister("knYHp", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d9dd754b138ddda$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dyckQ = parcelRequire("dyckQ");

var $drWLA = parcelRequire("drWLA");

var $lL6Xv = parcelRequire("lL6Xv");
const $8d9dd754b138ddda$var$UserLoadingState = ({ fireAnalytics: fireAnalytics })=>{
    (0, $5uXOq.useEffect)(()=>{
        fireAnalytics((0, $lL6Xv.profileCardRendered)('user', 'spinner'));
    }, [
        fireAnalytics
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $drWLA.SpinnerContainer), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dyckQ.default), {})
    });
};
var $8d9dd754b138ddda$export$2e2bcd8739ae039 = $8d9dd754b138ddda$var$UserLoadingState;

});







parcelRegister("jiOMJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $81684c8957674a18$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $4UaOO = parcelRequire("4UaOO");

var $bFtEE = parcelRequire("bFtEE");

var $Ff3Gv = parcelRequire("Ff3Gv");

var $jCur3 = parcelRequire("jCur3");

var $5Mo7g = parcelRequire("5Mo7g");

var $aq1l9 = parcelRequire("aq1l9");

var $jZJzT = parcelRequire("jZJzT");
var $7tojC = parcelRequire("7tojC");
var $d8LJZ = parcelRequire("d8LJZ");
var $l3Hnh = parcelRequire("l3Hnh");
var $3SfMu = parcelRequire("3SfMu");

var $9KcbK = parcelRequire("9KcbK");

var $hFKXd = parcelRequire("hFKXd");
function $81684c8957674a18$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// New custom icons are a little smaller than predefined icons.
// To fix alignment issues with custom icons, vertical alignment is updated.
const $81684c8957674a18$var$panelEmojiSpriteVerticalAlignment = -(24 - (0, $9KcbK.akEditorCustomIconSize)) / 2;
const $81684c8957674a18$var$panelEmojiImageVerticalAlignment = $81684c8957674a18$var$panelEmojiSpriteVerticalAlignment - 1;
const $81684c8957674a18$var$blockNodesVerticalMargin = '0.75rem';
const $81684c8957674a18$var$akEditorTableCellMinWidth = 48;
const $81684c8957674a18$var$panelBaseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&.ak-editor-panel': {
        borderRadius: "var(--ds-border-radius, 3px)",
        margin: `${$81684c8957674a18$var$blockNodesVerticalMargin} 0 0`,
        paddingTop: "var(--ds-space-100, 8px)",
        paddingRight: "var(--ds-space-200, 16px)",
        paddingBottom: "var(--ds-space-100, 8px)",
        paddingLeft: "var(--ds-space-100, 8px)",
        minWidth: `${$81684c8957674a18$var$akEditorTableCellMinWidth}px`,
        display: 'flex',
        position: 'relative',
        alignItems: 'normal',
        wordBreak: 'break-word',
        backgroundColor: "var(--ds-background-accent-blue-subtlest, #DEEBFF)",
        color: 'inherit',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-panel__icon': {
            flexShrink: 0,
            height: "var(--ds-space-300, 24px)",
            width: "var(--ds-space-300, 24px)",
            boxSizing: 'content-box',
            paddingRight: "var(--ds-space-100, 8px)",
            textAlign: 'center',
            userSelect: 'none',
            MozUserSelect: 'none',
            WebkitUserSelect: 'none',
            MsUserSelect: 'none',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '0.1em',
            color: "var(--ds-icon-information, #1D7AFC)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> span': {
                verticalAlign: 'middle',
                display: 'inline-flex'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.emoji-common-emoji-sprite': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                verticalAlign: `${$81684c8957674a18$var$panelEmojiSpriteVerticalAlignment}px`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.emoji-common-emoji-image': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                verticalAlign: `${$81684c8957674a18$var$panelEmojiImageVerticalAlignment}px`,
                // Vertical align only works for inline-block elements in Firefox
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                '@-moz-document url-prefix()': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    img: {
                        display: 'inline-block'
                    }
                }
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-panel__content': {
            margin: `${"var(--ds-space-025, 2px)"} 0 ${"var(--ds-space-025, 2px)"}`,
            flex: '1 0 0',
            /*
      https://ishadeed.com/article/min-max-css/#setting-min-width-to-zero-with-flexbox
      The default value for min-width is auto, which is computed to zero. When an element is a flex item, the value of min-width doesn’t compute to zero. The minimum size of a flex item is equal to the size of its contents.
      */ minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-panel-type="note"]': {
            backgroundColor: "var(--ds-background-accent-purple-subtlest, #EAE6FF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                color: "var(--ds-icon-discovery, #8270DB)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        '&[data-panel-type="tip"]': {
            backgroundColor: "var(--ds-background-accent-green-subtlest, #E3FCEF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                color: "var(--ds-icon-success, #22A06B)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        '&[data-panel-type="warning"]': {
            backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FFFAE6)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                color: "var(--ds-icon-warning, #E56910)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        '&[data-panel-type="error"]': {
            backgroundColor: "var(--ds-background-accent-red-subtlest, #FFEBE6)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                color: "var(--ds-icon-danger, #C9372C)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        '&[data-panel-type="success"]': {
            backgroundColor: "var(--ds-background-accent-green-subtlest, #E3FCEF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                color: "var(--ds-icon-success, #22A06B)"
            }
        }
    }
});
const $81684c8957674a18$var$panelHasNoIconStyles = {
    name: "vaqcwq",
    styles: "&.ak-editor-panel{&[data-panel-type=\"custom\"]{padding-left:var(--ds-space-150, 12px);padding-right:var(--ds-space-150, 12px);}}"
};
const $81684c8957674a18$var$panelNestedIconStyles = {
    name: "dsr7j7",
    styles: "&.ak-editor-panel__no-icon{padding-left:var(--ds-space-150, 12px);padding-right:var(--ds-space-150, 12px);}"
};
const $81684c8957674a18$var$nestedPanelStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-panel__content .ak-editor-panel': {
        border: `1px solid ${"var(--ds-border, #091E42)"}`
    }
});
const $81684c8957674a18$var$panelCustomBackground = {
    name: "bjtns3",
    styles: "&.ak-editor-panel{&[data-panel-type=\"custom\"]{background-color:var(--ak-renderer-panel-custom-bg-color);}}"
};
const $81684c8957674a18$var$PanelStyled = ({ backgroundColor: backgroundColor, hasIcon: hasIcon, ...props })=>{
    const customBackgroundColor = backgroundColor ? (0, $jCur3.hexToEditorBackgroundPaletteColor)(backgroundColor) || backgroundColor : undefined;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        {
            '--ak-renderer-panel-custom-bg-color': customBackgroundColor
        },
        css: [
            $81684c8957674a18$var$panelBaseStyles,
            !hasIcon && $81684c8957674a18$var$panelHasNoIconStyles,
            props['data-panel-type'] === (0, $bFtEE.PanelType).CUSTOM && backgroundColor && $81684c8957674a18$var$panelCustomBackground,
            (0, $hFKXd.fg)('platform_editor_nested_dnd_styles_changes') && $81684c8957674a18$var$panelNestedIconStyles,
            (0, $hFKXd.fg)('platform_editor_add_border_for_nested_panel') && $81684c8957674a18$var$nestedPanelStyles
        ],
        ...props
    }, props.children);
};
$81684c8957674a18$var$PanelStyled.displayName = 'PanelStyled';
const $81684c8957674a18$var$panelIcons = {
    info: (0, $7tojC.PanelInfoIcon),
    success: (0, $l3Hnh.PanelSuccessIcon),
    note: (0, $d8LJZ.PanelNoteIcon),
    tip: (0, (/*@__PURE__*/$parcel$interopDefault($4UaOO))),
    warning: (0, $3SfMu.PanelWarningIcon),
    error: (0, $jZJzT.PanelErrorIcon),
    custom: (0, (/*@__PURE__*/$parcel$interopDefault($5Mo7g)))
};
const $81684c8957674a18$var$Panel = (props)=>{
    const { allowCustomPanels: allowCustomPanels, panelType: type, panelColor: panelColor, panelIcon: panelIcon, panelIconId: panelIconId, panelIconText: panelIconText, providers: providers, children: children } = props;
    // only allow custom panel type if flag is set
    // otherwise fall back to info if custom panel is given
    const panelType = allowCustomPanels ? type : type === (0, $bFtEE.PanelType).CUSTOM ? (0, $bFtEE.PanelType).INFO : type;
    const getIcon = ()=>{
        if (panelType === (0, $bFtEE.PanelType).CUSTOM) {
            if (panelIcon && providers) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aq1l9.default), {
                id: panelIconId,
                text: panelIconText,
                shortName: panelIcon,
                providers: providers
            });
            return null;
        }
        const Icon = $81684c8957674a18$var$panelIcons[panelType];
        return /*#__PURE__*/ (0, $f8Sb3.jsx)(Icon, {
            label: `${panelType} panel`
        });
    };
    const icon = getIcon();
    const renderIcon = ()=>{
        if (icon) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            className: (0, $Ff3Gv.PanelSharedCssClassName).icon
        }, icon);
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($81684c8957674a18$var$PanelStyled, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $Ff3Gv.PanelSharedCssClassName).prefix,
        "data-panel-type": panelType,
        "data-panel-color": panelColor,
        "data-panel-icon": panelIcon,
        "data-panel-icon-id": panelIconId,
        "data-panel-icon-text": panelIconText,
        backgroundColor: panelColor,
        hasIcon: Boolean(icon)
    }, renderIcon(), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        className: (0, $Ff3Gv.PanelSharedCssClassName).content
    }, children));
};
var $81684c8957674a18$export$2e2bcd8739ae039 = $81684c8957674a18$var$Panel;

});
parcelRegister("4UaOO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2b2d7d7d35471a6e12918268c6980291>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3924c8ba162d6084$var$_react = $3924c8ba162d6084$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3924c8ba162d6084$var$_lightbulb = $3924c8ba162d6084$var$_interopRequireDefault((parcelRequire("1P2Ep")));

var $3924c8ba162d6084$var$_hint = $3924c8ba162d6084$var$_interopRequireDefault((parcelRequire("gelMA")));
function $3924c8ba162d6084$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LightbulbIcon.
 * This component is LightbulbIcon, with `UNSAFE_fallbackIcon` set to "EditorHintIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3924c8ba162d6084$var$LightbulbIcon = (props)=>/*#__PURE__*/ $3924c8ba162d6084$var$_react.default.createElement($3924c8ba162d6084$var$_lightbulb.default, Object.assign({
        LEGACY_fallbackIcon: $3924c8ba162d6084$var$_hint.default
    }, props));
$3924c8ba162d6084$var$LightbulbIcon.Name = 'LightbulbIconMigration';
var $3924c8ba162d6084$var$_default = module.exports.default = $3924c8ba162d6084$var$LightbulbIcon;

});
parcelRegister("gelMA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bd0ed9bbe08bc274$var$_react = $bd0ed9bbe08bc274$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $hD6Dj = parcelRequire("hD6Dj");

var $bd0ed9bbe08bc274$var$_lightbulb = $bd0ed9bbe08bc274$var$_interopRequireDefault((parcelRequire("1P2Ep")));
function $bd0ed9bbe08bc274$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bd0ed9bbe08bc274$var$EditorHintIcon = (props)=>/*#__PURE__*/ $bd0ed9bbe08bc274$var$_react.default.createElement($hD6Dj.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14 16h-4s0-.5-1-2-2.5-3-2.5-5S7 4 12 4s5.5 3 5.5 5-1.5 3.5-2.5 5-1 2-1 2m-4 1h4v1l-1.5 2h-1L10 18z"/></svg>`
    }, props, {
        newIcon: $bd0ed9bbe08bc274$var$_lightbulb.default
    }));
$bd0ed9bbe08bc274$var$EditorHintIcon.displayName = 'EditorHintIcon';
var $bd0ed9bbe08bc274$var$_default = module.exports.default = $bd0ed9bbe08bc274$var$EditorHintIcon;

});


parcelRegister("Ff3Gv", function(module, exports) {

$parcel$export(module.exports, "darkPanelColors", () => $2c561a52b6e10b78$export$804476272fbaff5e);
$parcel$export(module.exports, "PanelSharedCssClassName", () => $2c561a52b6e10b78$export$6dd740b6c888e050);
$parcel$export(module.exports, "getPanelTypeBackgroundNoTokens", () => $2c561a52b6e10b78$export$8099afddf1b1be78);
$parcel$export(module.exports, "panelSharedStyles", () => $2c561a52b6e10b78$export$fc98407afe711ba8);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $bFtEE = parcelRequire("bFtEE");

var $jCur3 = parcelRequire("jCur3");

var $9KcbK = parcelRequire("9KcbK");

var $9KcbK = parcelRequire("9KcbK");


var $hFKXd = parcelRequire("hFKXd");
const $2c561a52b6e10b78$var$lightPanelColors = {
    info: '#DEEBFF',
    note: '#EAE6FF',
    tip: '#E3FCEF',
    success: '#E3FCEF',
    warning: '#FFFAE6',
    error: '#FFEBE6'
};
const $2c561a52b6e10b78$export$804476272fbaff5e = {
    // standard panels
    info: `#0C294F`,
    error: `#441C13`,
    warning: `#413001`,
    tip: `#052E21`,
    success: `#052E21`,
    note: `#282249`,
    // Reds
    R900: '#601D16',
    // Red Saturated
    R100S: `#FFEFEB`,
    R300S: `#FFB5A3`,
    R500S: `#FF6B47`,
    R800S: `#C4320E`,
    R1200S: `#441C13`,
    // Yellows
    Y900: '#533F04',
    // Yellow Saturated
    Y100S: `#FFF3D1`,
    Y300S: `#FFDC7A`,
    Y500S: `#FFC933`,
    Y800S: `#D8A003`,
    Y1200S: `#413001`,
    // Greens
    G900: '#164B35',
    // Green Saturated
    G100S: `#E3FCF0`,
    G300S: `#95EEC5`,
    G400S: `#60DCA8`,
    G900S: `#086848`,
    G1200S: `#052E21`,
    // Blues
    B900: '#09326C',
    // Saturated Blues
    B100S: '#E5F0FF',
    B300S: '#A3C9FF',
    B500S: '#4794FF',
    B800S: '#0055CC',
    B1200S: '#0C294F',
    // Purples
    P900: `#352C63`,
    // Purple Saturated
    P100S: `#EEEBFF`,
    P300S: `#CCC3FE`,
    P500S: `#A292F7`,
    P800S: `#5E49CA`,
    P1200S: `#282249`,
    // Teals
    T900: '#1D474C',
    // Teal Saturated
    T100S: `#DBFAFF`,
    T300S: `#78EBFC`,
    T400S: `#3AD6EE`,
    T900S: `#056270`,
    T1200S: `#0B3037`,
    // Dark Mode Alpha
    DarkGray: '#161A1D',
    Gray: '#2C333A',
    LightGray: '#5A6977',
    TextColor: '#D9DDE3'
};
const $2c561a52b6e10b78$var$lightIconColor = {
    info: "var(--ds-icon-information, #1D7AFC)",
    note: "var(--ds-icon-discovery, #8270DB)",
    tip: "var(--ds-icon-success, #22A06B)",
    success: "var(--ds-icon-success, #22A06B)",
    warning: "var(--ds-icon-warning, #E56910)",
    error: "var(--ds-icon-danger, #C9372C)"
};
// New custom icons are a little smaller than predefined icons.
// To fix alignment issues with custom icons, vertical alignment is updated.
const $2c561a52b6e10b78$var$panelEmojiSpriteVerticalAlignment = -(24 - (0, $9KcbK.akEditorCustomIconSize)) / 2;
const $2c561a52b6e10b78$var$panelEmojiImageVerticalAlignment = $2c561a52b6e10b78$var$panelEmojiSpriteVerticalAlignment - 1;
function $2c561a52b6e10b78$export$9490e629452e7f9e(colorName, colorValue) {
    return `
  &[data-panel-color="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
    color: ${$2c561a52b6e10b78$export$804476272fbaff5e.TextColor};
  }
  `;
}
const $2c561a52b6e10b78$var$prefix = 'ak-editor-panel';
const $2c561a52b6e10b78$export$6dd740b6c888e050 = {
    prefix: $2c561a52b6e10b78$var$prefix,
    content: `${$2c561a52b6e10b78$var$prefix}__content`,
    icon: `${$2c561a52b6e10b78$var$prefix}__icon`,
    noIcon: `${$2c561a52b6e10b78$var$prefix}__no-icon`
};
const $2c561a52b6e10b78$export$b0ee08fae091706a = {
    infoPanel: `.${$2c561a52b6e10b78$var$prefix}[data-panel-type=${(0, $bFtEE.PanelType).INFO}]`,
    notePanel: `.${$2c561a52b6e10b78$var$prefix}[data-panel-type=${(0, $bFtEE.PanelType).NOTE}]`,
    warningPanel: `.${$2c561a52b6e10b78$var$prefix}[data-panel-type=${(0, $bFtEE.PanelType).WARNING}]`,
    errorPanel: `.${$2c561a52b6e10b78$var$prefix}[data-panel-type=${(0, $bFtEE.PanelType).ERROR}]`,
    successPanel: `.${$2c561a52b6e10b78$var$prefix}[data-panel-type=${(0, $bFtEE.PanelType).SUCCESS}]`,
    noteButton: `button[aria-label="Note"]`,
    warningButton: `button[aria-label="Warning"]`,
    removeButton: `button[aria-label="Remove"]`,
    colorPalette: `[aria-label="Background color"]`,
    selectedColor: `[aria-label="Light green"]`,
    removeEmojiIcon: `[aria-label="Remove emoji"]`,
    emojiIcon: `[aria-label="editor-add-emoji"]`,
    selectedEmoji: `[aria-label=":grinning:"]`,
    addYourOwnEmoji: `#add-custom-emoji`,
    emojiNameInCustomEmoji: `[aria-label="Enter a name for the new emoji"]`,
    title: `#editor-title`,
    emojiPopup: `[aria-label="Popup"]`,
    searchEmoji: `[aria-label="Emoji name"]`,
    orangeWarningIcon: `[aria-label=":warning:"]`,
    yellowWarningIcon: `[aria-label=":warning:"]  span:nth-child(1)`,
    copyButton: `button[aria-label="Copy"]`
};
const $2c561a52b6e10b78$var$getIconStyles = (panelType)=>{
    if ((0, $hFKXd.fg)('platform_editor_lcm_nested_panel_icon_fix')) return `
			.${$2c561a52b6e10b78$export$6dd740b6c888e050.icon}[data-panel-type='${panelType}'] {
				color: ${$2c561a52b6e10b78$var$lightIconColor[panelType]};
			}
		`;
    else return `
			.${$2c561a52b6e10b78$export$6dd740b6c888e050.icon} {
				color: ${$2c561a52b6e10b78$var$lightIconColor[panelType]};
			}
		`;
};
const $2c561a52b6e10b78$export$8099afddf1b1be78 = (panelType)=>$2c561a52b6e10b78$var$lightPanelColors[panelType] || 'none';
const $2c561a52b6e10b78$export$dd3f0fd482ae7ccc = (panelType)=>(0, $jCur3.hexToEditorBackgroundPaletteColor)($2c561a52b6e10b78$var$lightPanelColors[panelType]) || 'none';
const $2c561a52b6e10b78$var$mainDynamicStyles = (panelType)=>{
    return `
    background-color: ${$2c561a52b6e10b78$export$dd3f0fd482ae7ccc(panelType)};
    color: inherit;
  `;
};
const $2c561a52b6e10b78$export$d707b378cb63679a = ()=>/*#__PURE__*/ (0, $f8Sb3.css)("border-radius:var(--ds-border-radius, 3px);margin:", (0, $9KcbK.blockNodesVerticalMargin), " 0 0;padding-top:var(--ds-space-100, 8px);padding-right:var(--ds-space-200, 16px);padding-bottom:var(--ds-space-100, 8px);padding-left:var(--ds-space-100, 8px);min-width:", (0, $9KcbK.akEditorTableCellMinWidth), "px;display:flex;position:relative;align-items:normal;word-break:break-word;", $2c561a52b6e10b78$var$mainDynamicStyles((0, $bFtEE.PanelType).INFO), " .", $2c561a52b6e10b78$export$6dd740b6c888e050.icon, "{flex-shrink:0;height:var(--ds-space-300, 24px);width:var(--ds-space-300, 24px);box-sizing:content-box;padding-right:var(--ds-space-100, 8px);text-align:center;user-select:none;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;margin-top:0.1em;>span{vertical-align:middle;display:inline-flex;}.", (0, $c7ea896bb618f785$export$1c10634420a08d8a), "{vertical-align:", $2c561a52b6e10b78$var$panelEmojiSpriteVerticalAlignment, "px;}.", (0, $c7ea896bb618f785$export$da61cef1c8919f7c), "{vertical-align:", $2c561a52b6e10b78$var$panelEmojiImageVerticalAlignment, "px;@-moz-document url-prefix(){img{display:inline-block;}}}}.ak-editor-panel__content{margin:var(--ds-space-025, 2px) 0 var(--ds-space-025, 2px);flex:1 0 0;min-width:0;}", (0, $hFKXd.fg)('platform_editor_add_border_for_nested_panel') ? `.${$2c561a52b6e10b78$export$6dd740b6c888e050.content} .${$2c561a52b6e10b78$var$prefix} {
			border: 1px solid ${"var(--ds-border, #091E42)"};
		}` : '', " &[data-panel-type='", (0, $bFtEE.PanelType).INFO, "']{", $2c561a52b6e10b78$var$getIconStyles((0, $bFtEE.PanelType).INFO), ";}&[data-panel-type='", (0, $bFtEE.PanelType).NOTE, "']{", $2c561a52b6e10b78$var$mainDynamicStyles((0, $bFtEE.PanelType).NOTE), " ", $2c561a52b6e10b78$var$getIconStyles((0, $bFtEE.PanelType).NOTE), ";}&[data-panel-type='", (0, $bFtEE.PanelType).TIP, "']{", $2c561a52b6e10b78$var$mainDynamicStyles((0, $bFtEE.PanelType).TIP), " ", $2c561a52b6e10b78$var$getIconStyles((0, $bFtEE.PanelType).TIP), ";}&[data-panel-type='", (0, $bFtEE.PanelType).WARNING, "']{", $2c561a52b6e10b78$var$mainDynamicStyles((0, $bFtEE.PanelType).WARNING), " ", $2c561a52b6e10b78$var$getIconStyles((0, $bFtEE.PanelType).WARNING), ";}&[data-panel-type='", (0, $bFtEE.PanelType).ERROR, "']{", $2c561a52b6e10b78$var$mainDynamicStyles((0, $bFtEE.PanelType).ERROR), " ", $2c561a52b6e10b78$var$getIconStyles((0, $bFtEE.PanelType).ERROR), ";}&[data-panel-type='", (0, $bFtEE.PanelType).SUCCESS, "']{", $2c561a52b6e10b78$var$mainDynamicStyles((0, $bFtEE.PanelType).SUCCESS), " ", $2c561a52b6e10b78$var$getIconStyles((0, $bFtEE.PanelType).SUCCESS), ";}", (0, $hFKXd.fg)('platform_editor_nested_dnd_styles_changes') ? `&.${$2c561a52b6e10b78$export$6dd740b6c888e050.noIcon} {
			padding-right: ${"var(--ds-space-150, 12px)"};
			padding-left: ${"var(--ds-space-150, 12px)"};
		}` : '', ";");
const $2c561a52b6e10b78$export$fc98407afe711ba8 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`.${$2c561a52b6e10b78$export$6dd740b6c888e050.prefix}`]: $2c561a52b6e10b78$export$d707b378cb63679a()
    });

});

parcelRegister("5Mo7g", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be2db0d473b67ee2b7dfc80ce4f694c2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4354246b7bad05fa$var$_react = $4354246b7bad05fa$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4354246b7bad05fa$var$_emoji = $4354246b7bad05fa$var$_interopRequireDefault((parcelRequire("hh6IP")));

var $4354246b7bad05fa$var$_emoji2 = $4354246b7bad05fa$var$_interopRequireDefault((parcelRequire("aKqIL")));
function $4354246b7bad05fa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EmojiIcon.
 * This component is EmojiIcon, with `UNSAFE_fallbackIcon` set to "EditorEmojiIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4354246b7bad05fa$var$EmojiIcon = (props)=>/*#__PURE__*/ $4354246b7bad05fa$var$_react.default.createElement($4354246b7bad05fa$var$_emoji.default, Object.assign({
        LEGACY_fallbackIcon: $4354246b7bad05fa$var$_emoji2.default
    }, props));
$4354246b7bad05fa$var$EmojiIcon.Name = 'EmojiIconMigration';
var $4354246b7bad05fa$var$_default = module.exports.default = $4354246b7bad05fa$var$EmojiIcon;

});
parcelRegister("hh6IP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed0744cae5af6a1635a1b9234b867386>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c9393d09cdbb19ce$var$_react = $c9393d09cdbb19ce$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c9393d09cdbb19ce$var$_baseNew = $c9393d09cdbb19ce$var$_interopRequireDefault((parcelRequire("9ogAd")));
function $c9393d09cdbb19ce$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Emoji".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c9393d09cdbb19ce$var$EmojiIcon = (props)=>/*#__PURE__*/ $c9393d09cdbb19ce$var$_react.default.createElement($c9393d09cdbb19ce$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m4.5-1.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m4.5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m-2.915 3.783c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513" clip-rule="evenodd"/>`
    }, props));
$c9393d09cdbb19ce$var$EmojiIcon.displayName = 'EmojiIcon';
var $c9393d09cdbb19ce$var$_default = module.exports.default = $c9393d09cdbb19ce$var$EmojiIcon;

});

parcelRegister("aKqIL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d32ed7cf278c611$var$_react = $7d32ed7cf278c611$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $hD6Dj = parcelRequire("hD6Dj");

var $7d32ed7cf278c611$var$_emoji = $7d32ed7cf278c611$var$_interopRequireDefault((parcelRequire("hh6IP")));
function $7d32ed7cf278c611$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7d32ed7cf278c611$var$EditorEmojiIcon = (props)=>/*#__PURE__*/ $7d32ed7cf278c611$var$_react.default.createElement($hD6Dj.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 5a7 7 0 1 1 0 14 7 7 0 0 1 0-14m0 12.5c3.033 0 5.5-2.467 5.5-5.5S15.033 6.5 12 6.5A5.506 5.506 0 0 0 6.5 12c0 3.033 2.467 5.5 5.5 5.5m-1.5-6a1 1 0 1 1 0-2 1 1 0 0 1 0 2m3 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2m.27 1.583a.626.626 0 0 1 .932.834A3.63 3.63 0 0 1 12 15.125a3.63 3.63 0 0 1-2.698-1.204.625.625 0 0 1 .93-.835c.901 1.003 2.639 1.003 3.538-.003"/></svg>`
    }, props, {
        newIcon: $7d32ed7cf278c611$var$_emoji.default
    }));
$7d32ed7cf278c611$var$EditorEmojiIcon.displayName = 'EditorEmojiIcon';
var $7d32ed7cf278c611$var$_default = module.exports.default = $7d32ed7cf278c611$var$EditorEmojiIcon;

});


parcelRegister("jZJzT", function(module, exports) {

$parcel$export(module.exports, "PanelErrorIcon", () => $3195e49b039b6226$export$76fa6c311f4e2871);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $NpTs5 = parcelRequire("NpTs5");
const $3195e49b039b6226$var$PanelErrorGlyph = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.8562 11.9112L16.5088 9.26C16.7433 9.02545 16.8751 8.70733 16.8751 8.37563C16.8751 8.04392 16.7433 7.7258 16.5088 7.49125C16.2742 7.2567 15.9561 7.12493 15.6244 7.12493C15.2927 7.12493 14.9746 7.2567 14.74 7.49125L12.09 10.1438L9.4375 7.49125C9.20295 7.25686 8.8849 7.12526 8.55331 7.12537C8.22172 7.12549 7.90376 7.25732 7.66937 7.49188C7.43499 7.72643 7.30338 8.04448 7.3035 8.37607C7.30361 8.70766 7.43545 9.02561 7.67 9.26L10.32 11.91L7.67 14.5625C7.4423 14.7983 7.31631 15.114 7.31916 15.4418C7.32201 15.7695 7.45347 16.083 7.68523 16.3148C7.91699 16.5465 8.2305 16.678 8.55825 16.6808C8.88599 16.6837 9.20175 16.5577 9.4375 16.33L12.0888 13.68L14.74 16.33C14.8561 16.4461 14.9939 16.5383 15.1455 16.6012C15.2972 16.664 15.4597 16.6964 15.6239 16.6965C15.7881 16.6966 15.9507 16.6643 16.1024 16.6015C16.2541 16.5387 16.392 16.4467 16.5081 16.3306C16.6243 16.2146 16.7164 16.0768 16.7793 15.9251C16.8422 15.7734 16.8746 15.6109 16.8746 15.4467C16.8747 15.2825 16.8424 15.1199 16.7796 14.9682C16.7168 14.8165 16.6248 14.6786 16.5088 14.5625L13.8562 11.9112V11.9112ZM12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22Z",
            fill: "currentColor"
        })
    });
};
const $3195e49b039b6226$export$76fa6c311f4e2871 = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $NpTs5.default), {
        glyph: $3195e49b039b6226$var$PanelErrorGlyph,
        ...props
    });
};

});

parcelRegister("7tojC", function(module, exports) {

$parcel$export(module.exports, "PanelInfoIcon", () => $e4fcb6cd4f39597d$export$2187dc2d495c3efc);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $NpTs5 = parcelRequire("NpTs5");
const $e4fcb6cd4f39597d$var$PanelInfoGlyph = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM12 11.375C11.6685 11.375 11.3505 11.5067 11.1161 11.7411C10.8817 11.9755 10.75 12.2935 10.75 12.625V15.75C10.75 16.0815 10.8817 16.3995 11.1161 16.6339C11.3505 16.8683 11.6685 17 12 17C12.3315 17 12.6495 16.8683 12.8839 16.6339C13.1183 16.3995 13.25 16.0815 13.25 15.75V12.625C13.25 12.2935 13.1183 11.9755 12.8839 11.7411C12.6495 11.5067 12.3315 11.375 12 11.375ZM12 9.96875C12.4558 9.96875 12.893 9.78767 13.2153 9.46534C13.5377 9.14301 13.7188 8.70584 13.7188 8.25C13.7188 7.79416 13.5377 7.35699 13.2153 7.03466C12.893 6.71233 12.4558 6.53125 12 6.53125C11.5442 6.53125 11.107 6.71233 10.7847 7.03466C10.4623 7.35699 10.2812 7.79416 10.2812 8.25C10.2812 8.70584 10.4623 9.14301 10.7847 9.46534C11.107 9.78767 11.5442 9.96875 12 9.96875Z",
            fill: "currentColor"
        })
    });
};
const $e4fcb6cd4f39597d$export$2187dc2d495c3efc = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $NpTs5.default), {
        glyph: $e4fcb6cd4f39597d$var$PanelInfoGlyph,
        ...props
    });
};

});

parcelRegister("d8LJZ", function(module, exports) {

$parcel$export(module.exports, "PanelNoteIcon", () => $95a1549d7870ab2d$export$d4f894f0c3f0db6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $NpTs5 = parcelRequire("NpTs5");
const $95a1549d7870ab2d$var$PanelNoteGlyph = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7 2H17C17.663 2 18.2989 2.26339 18.7678 2.73223C19.2366 3.20107 19.5 3.83696 19.5 4.5V19.5C19.5 20.163 19.2366 20.7989 18.7678 21.2678C18.2989 21.7366 17.663 22 17 22H7C6.33696 22 5.70107 21.7366 5.23223 21.2678C4.76339 20.7989 4.5 20.163 4.5 19.5V4.5C4.5 3.83696 4.76339 3.20107 5.23223 2.73223C5.70107 2.26339 6.33696 2 7 2ZM8.875 7C8.70924 7 8.55027 7.06585 8.43306 7.18306C8.31585 7.30027 8.25 7.45924 8.25 7.625V8.875C8.25 9.04076 8.31585 9.19973 8.43306 9.31694C8.55027 9.43415 8.70924 9.5 8.875 9.5H15.125C15.2908 9.5 15.4497 9.43415 15.5669 9.31694C15.6842 9.19973 15.75 9.04076 15.75 8.875V7.625C15.75 7.45924 15.6842 7.30027 15.5669 7.18306C15.4497 7.06585 15.2908 7 15.125 7H8.875ZM8.875 12C8.70924 12 8.55027 12.0658 8.43306 12.1831C8.31585 12.3003 8.25 12.4592 8.25 12.625V13.875C8.25 14.0408 8.31585 14.1997 8.43306 14.3169C8.55027 14.4342 8.70924 14.5 8.875 14.5H12.625C12.7908 14.5 12.9497 14.4342 13.0669 14.3169C13.1842 14.1997 13.25 14.0408 13.25 13.875V12.625C13.25 12.4592 13.1842 12.3003 13.0669 12.1831C12.9497 12.0658 12.7908 12 12.625 12H8.875Z",
            fill: "currentColor"
        })
    });
};
const $95a1549d7870ab2d$export$d4f894f0c3f0db6 = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $NpTs5.default), {
        glyph: $95a1549d7870ab2d$var$PanelNoteGlyph,
        ...props
    });
};

});

parcelRegister("l3Hnh", function(module, exports) {

$parcel$export(module.exports, "PanelSuccessIcon", () => $aebc79ff17e3599c$export$a5a5162e21242c3c);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $NpTs5 = parcelRequire("NpTs5");
const $aebc79ff17e3599c$var$PanelSuccessGlyph = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM13.705 8.295L11.015 13.4325L9.08625 11.695C8.9642 11.5852 8.82172 11.5005 8.66694 11.4457C8.51216 11.391 8.3481 11.3672 8.18415 11.3759C8.0202 11.3845 7.85955 11.4254 7.71139 11.4961C7.56322 11.5669 7.43044 11.6661 7.32063 11.7881C7.21081 11.9102 7.1261 12.0527 7.07135 12.2074C7.0166 12.3622 6.99287 12.5263 7.00152 12.6902C7.01016 12.8542 7.05102 13.0148 7.12175 13.163C7.19248 13.3112 7.2917 13.4439 7.41375 13.5538L10.5388 16.3663C10.6803 16.4938 10.8492 16.5872 11.0325 16.6395C11.2157 16.6917 11.4085 16.7014 11.596 16.6678C11.7836 16.6341 11.9609 16.558 12.1146 16.4453C12.2682 16.3326 12.3941 16.1863 12.4825 16.0175L15.92 9.455C16.0738 9.16127 16.1047 8.81847 16.0057 8.502C15.9068 8.18553 15.6862 7.92133 15.3925 7.7675C15.0988 7.61367 14.756 7.58283 14.4395 7.68176C14.123 7.78068 13.8588 8.00127 13.705 8.295V8.295Z",
            fill: "currentColor"
        })
    });
};
const $aebc79ff17e3599c$export$a5a5162e21242c3c = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $NpTs5.default), {
        glyph: $aebc79ff17e3599c$var$PanelSuccessGlyph,
        ...props
    });
};

});

parcelRegister("3SfMu", function(module, exports) {

$parcel$export(module.exports, "PanelWarningIcon", () => $d8a05529a6ddda3e$export$246c5468186717b7);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $NpTs5 = parcelRequire("NpTs5");
const $d8a05529a6ddda3e$var$PanelWarningGlyph = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.4897 4.34592L21.8561 18.8611C21.9525 19.0288 22.0021 19.2181 21.9999 19.4101C21.9977 19.6021 21.9438 19.7903 21.8435 19.9559C21.7432 20.1215 21.6001 20.2588 21.4282 20.3542C21.2563 20.4497 21.0616 20.4999 20.8636 20.5H3.13707C2.93882 20.5 2.74401 20.4498 2.57196 20.3543C2.39992 20.2588 2.25663 20.1213 2.15631 19.9556C2.05598 19.7898 2.00212 19.6015 2.00006 19.4093C1.998 19.2171 2.04782 19.0278 2.14456 18.86L10.5121 4.34592C10.6602 4.08939 10.8762 3.87577 11.1377 3.72708C11.3993 3.57838 11.6971 3.5 12.0003 3.5C12.3036 3.5 12.6013 3.57838 12.8629 3.72708C13.1245 3.87577 13.3404 4.08939 13.4885 4.34592H13.4897ZM12.0003 7.82538C11.8232 7.82537 11.6482 7.86212 11.4869 7.93317C11.3257 8.00423 11.182 8.10793 11.0656 8.2373C10.9492 8.36668 10.8627 8.51872 10.8119 8.68321C10.7611 8.8477 10.7473 9.02083 10.7713 9.19093L11.3546 13.3416C11.3754 13.4933 11.4523 13.6326 11.5711 13.7334C11.6899 13.8343 11.8424 13.8899 12.0003 13.8899C12.1582 13.8899 12.3107 13.8343 12.4295 13.7334C12.5483 13.6326 12.6253 13.4933 12.6461 13.3416L13.2293 9.19093C13.2533 9.02083 13.2395 8.8477 13.1887 8.68321C13.138 8.51872 13.0515 8.36668 12.935 8.2373C12.8186 8.10793 12.6749 8.00423 12.5137 7.93317C12.3525 7.86212 12.1774 7.82537 12.0003 7.82538V7.82538ZM12.0003 17.3369C12.3395 17.3369 12.6649 17.2062 12.9047 16.9737C13.1446 16.7412 13.2793 16.4258 13.2793 16.0969C13.2793 15.7681 13.1446 15.4527 12.9047 15.2202C12.6649 14.9877 12.3395 14.857 12.0003 14.857C11.6611 14.857 11.3358 14.9877 11.0959 15.2202C10.8561 15.4527 10.7213 15.7681 10.7213 16.0969C10.7213 16.4258 10.8561 16.7412 11.0959 16.9737C11.3358 17.2062 11.6611 17.3369 12.0003 17.3369V17.3369Z",
            fill: "currentColor"
        })
    });
};
const $d8a05529a6ddda3e$export$246c5468186717b7 = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $NpTs5.default), {
        glyph: $d8a05529a6ddda3e$var$PanelWarningGlyph,
        ...props
    });
};

});


parcelRegister("5gZus", function(module, exports) {

$parcel$export(module.exports, "default", () => $1418b18f7e3bb108$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ldKsm = parcelRequire("ldKsm");

var $bVYhW = parcelRequire("bVYhW");

var $hFKXd = parcelRequire("hFKXd");

var $gJUKS = parcelRequire("gJUKS");
var $1418b18f7e3bb108$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)(function Status(props) {
    const { text: text, color: color, localId: localId } = props;
    const inlineAnnotationProps = (0, $gJUKS.useInlineAnnotationProps)(props);
    if ((0, $hFKXd.fg)('editor_inline_comments_on_inline_nodes')) return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...inlineAnnotationProps,
        role: (0, $hFKXd.fg)('editor_a11y_status_renderer_description') ? 'emphasis' : undefined,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bVYhW.FabricElementsAnalyticsContext), {
            data: {
                userContext: 'document'
            },
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ldKsm.Status), {
                text: text,
                color: color,
                localId: localId,
                role: (0, $hFKXd.fg)('editor_a11y_status_renderer_description') ? undefined : 'presentation',
                isBold: (0, $hFKXd.fg)('platform-component-visual-refresh')
            })
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bVYhW.FabricElementsAnalyticsContext), {
        data: {
            userContext: 'document'
        },
        children: (0, $hFKXd.fg)('editor_a11y_status_renderer_description') ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            role: "emphasis",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ldKsm.Status), {
                text: text,
                color: color,
                localId: localId,
                isBold: (0, $hFKXd.fg)('platform-component-visual-refresh')
            })
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ldKsm.Status), {
            text: text,
            color: color,
            localId: localId,
            role: "presentation",
            isBold: (0, $hFKXd.fg)('platform-component-visual-refresh')
        })
    });
});

});
parcelRegister("ldKsm", function(module, exports) {

$parcel$export(module.exports, "Status", () => $81072d592143647f$export$96e9906d6d93a972);
/* Status.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9SlAH = parcelRequire("9SlAH");

var $2keUK = parcelRequire("2keUK");

var $6XrVv = parcelRequire("6XrVv");

const $81072d592143647f$var$colorToLozengeAppearanceMap = {
    neutral: 'default',
    purple: 'new',
    blue: 'inprogress',
    red: 'removed',
    yellow: 'moved',
    green: 'success'
};
const $81072d592143647f$var$DEFAULT_APPEARANCE = 'default';
const $81072d592143647f$var$MAX_WIDTH = 200;
/**
 * This is to account for a bug in android chromium and should be removed
 * when the editor fixes its focus handling with respect to Status.
 *
 * See DSP-7701 for additional context.
 */ const $81072d592143647f$var$inlineBlockStyles = null;
// eg. Version/4.0 Chrome/95.0.4638.50
const $81072d592143647f$var$isAndroidChromium = typeof window !== 'undefined' && /Version\/.* Chrome\/.*/.test(window.navigator.userAgent);
class $81072d592143647f$var$StatusInternal extends (0, $5uXOq.PureComponent) {
    static{
        this.displayName = 'StatusInternal';
    }
    componentWillUnmount() {
        this.hoverStartTime = 0;
    }
    render() {
        const { text: text, color: color, style: style, role: role, onClick: onClick, isBold: isBold } = this.props;
        if (text.trim().length === 0) return null;
        const appearance = $81072d592143647f$var$colorToLozengeAppearanceMap[color] || $81072d592143647f$var$DEFAULT_APPEARANCE;
        // Note: ommitted data-local-id attribute to avoid copying/pasting the same localId
        return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $bwpsq.default)([
                $81072d592143647f$var$isAndroidChromium && "_d0dzdf4r _1k0l7vkz _1frxnkob",
                "status-lozenge-span"
            ]),
            onClick: onClick,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            "data-node-type": "status",
            "data-color": color,
            "data-style": style,
            role: role,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9SlAH.default), {
                appearance: appearance,
                maxWidth: $81072d592143647f$var$MAX_WIDTH,
                isBold: isBold,
                children: text
            })
        });
    }
    constructor(...args){
        super(...args), this.hoverStartTime = 0, this.handleMouseEnter = (_e)=>{
            this.hoverStartTime = Date.now();
        }, this.handleMouseLeave = (_e)=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $19a297a935519eaf$export$7452d7062a4d0634) && onHover) onHover();
            this.hoverStartTime = 0;
        };
    }
}
const $81072d592143647f$export$96e9906d6d93a972 = (0, $2keUK.default)({
    onClick: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $6XrVv.createStatusAnalyticsAndFire)(createEvent)({
            action: 'clicked',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    },
    onHover: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $6XrVv.createStatusAnalyticsAndFire)(createEvent)({
            action: 'hovered',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    }
})($81072d592143647f$var$StatusInternal);

});
parcelRegister("6XrVv", function(module, exports) {

$parcel$export(module.exports, "createStatusAnalyticsAndFire", () => $74d31c0d7c3d9dc6$export$aa98853957f9f5aa);
const $74d31c0d7c3d9dc6$export$d821aa4c8afb384e = 'fabric-elements';
const $74d31c0d7c3d9dc6$var$packageName = "platform-pkg";
const $74d31c0d7c3d9dc6$var$packageVersion = "0.0.0-use.local";
const $74d31c0d7c3d9dc6$export$aa98853957f9f5aa = (createAnalyticsEvent)=>(payload)=>{
        const statusPayload = {
            ...payload,
            eventType: 'ui'
        };
        if (!statusPayload.attributes) statusPayload.attributes = {};
        statusPayload.attributes.packageName = $74d31c0d7c3d9dc6$var$packageName;
        statusPayload.attributes.packageVersion = $74d31c0d7c3d9dc6$var$packageVersion;
        statusPayload.attributes.componentName = 'status';
        const event = createAnalyticsEvent(statusPayload);
        event.fire($74d31c0d7c3d9dc6$export$d821aa4c8afb384e);
        return event;
    };

});

const $19a297a935519eaf$export$7452d7062a4d0634 = 1000;



parcelRegister("1qYGk", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecb2f70162b1176b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $4b4i9 = parcelRequire("4b4i9");
var $hiA9t = parcelRequire("hiA9t");

var $dF8ox = parcelRequire("dF8ox");

var $bVYhW = parcelRequire("bVYhW");

var $jqKBT = parcelRequire("jqKBT");
class $ecb2f70162b1176b$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    constructor(props){
        super(props), // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.renderWithProvider = (providers)=>{
            const { taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider } = providers;
            const { children: children, localId: localId, state: state, rendererContext: rendererContext, disabled: disabled, dataAttributes: dataAttributes } = this.props;
            let objectAri = '';
            if (rendererContext) objectAri = rendererContext.objectAri || '';
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bVYhW.FabricElementsAnalyticsContext), {
                data: {
                    userContext: 'document'
                },
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jqKBT.TaskItemsFormatProvider), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jqKBT.TaskItemsFormatConsumer), {
                        children: ([, dispatch])=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dF8ox.default), {
                                objectAri: objectAri,
                                taskId: localId,
                                isDone: state === 'DONE',
                                isRenderer: true,
                                disabled: disabled,
                                taskDecisionProvider: taskDecisionProvider,
                                contextIdentifierProvider: contextIdentifierProvider,
                                dataAttributes: dataAttributes,
                                onChange: (_, isChecked)=>{
                                    dispatch(isChecked);
                                },
                                children: children
                            })
                    })
                })
            });
        };
        this.providerFactory = props.providers || new (0, $4b4i9.default)();
    }
    componentWillUnmount() {
        if (!this.props.providers) // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
    }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hiA9t.WithProviders), {
            providers: [
                'taskDecisionProvider',
                'contextIdentifierProvider'
            ],
            providerFactory: this.providerFactory,
            renderNode: this.renderWithProvider
        });
    }
}

});
parcelRegister("dF8ox", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb00bf8767dd9206$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6ZeGm = parcelRequire("6ZeGm");
function $fb00bf8767dd9206$export$2e2bcd8739ae039(props) {
    const { contextIdentifierProvider: contextIdentifierProvider, objectAri: objectAri, isRenderer: isRenderer, ...otherProps } = props;
    const [resolvedContextProvider, setResolvedContextProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(undefined);
    const updateContextIdentifierProvider = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(async (contextIdentifierProvider)=>{
        if (contextIdentifierProvider) try {
            const resolvedContextProvider = await contextIdentifierProvider;
            setResolvedContextProvider(resolvedContextProvider);
            return;
        } catch (err) {}
        setResolvedContextProvider(undefined);
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        updateContextIdentifierProvider(props.contextIdentifierProvider);
    }, [
        props.contextIdentifierProvider,
        updateContextIdentifierProvider
    ]);
    const resolvedObjectId = resolvedContextProvider && resolvedContextProvider.objectId || objectAri;
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6ZeGm.default), {
        ...otherProps,
        objectAri: resolvedObjectId,
        isRenderer: isRenderer
    });
}

});
parcelRegister("6ZeGm", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bc9ca0f940668e6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $j90wU = parcelRequire("j90wU");

var $bVYhW = parcelRequire("bVYhW");
class $6bc9ca0f940668e6$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            appearance: 'inline'
        };
    }
    constructor(props){
        super(props), this.mounted = false, this.onUpdate = (state)=>{
            this.setState({
                isDone: state === 'DONE'
            });
        }, this.handleOnChange = (taskId, isDone)=>{
            const { taskDecisionProvider: taskDecisionProvider, objectAri: objectAri, onChange: onChange, disableOnChange: disableOnChange } = this.props;
            if (disableOnChange) return;
            // Optimistically update the task
            this.setState({
                isDone: isDone
            });
            if (taskDecisionProvider && objectAri) // Call provider to update task
            taskDecisionProvider.then((provider)=>{
                if (!this.mounted) return;
                provider.toggleTask({
                    localId: taskId,
                    objectAri: objectAri
                }, isDone ? 'DONE' : 'TODO');
                // onChange could trigger a rerender, in order to get the correct state
                // we should only call onChange once the internal state have been modified
                if (onChange) onChange(taskId, isDone);
            });
            else // No provider - state managed by consumer
            if (onChange) onChange(taskId, isDone);
        }, this.handleOnClick = ()=>{
            const { onClick: onClick } = this.props;
            if (onClick) onClick();
        };
        this.state = {
            isDone: props.isDone
        };
    }
    componentDidMount() {
        this.mounted = true;
        this.subscribe(this.props.taskDecisionProvider, this.props.objectAri, this.props.isDone);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.isDone !== this.props.isDone) // This only occurs for Actions (DONE vs TODO), since Decisions only support DECIDED.
        // If the document is refreshed or changed, we need to reset the local state to match the new
        // source of truth from the revised data.
        this.onUpdate(nextProps.isDone ? 'DONE' : 'TODO');
        if (nextProps.taskDecisionProvider !== this.props.taskDecisionProvider || nextProps.objectAri !== this.props.objectAri) {
            this.unsubscribe();
            this.subscribe(nextProps.taskDecisionProvider, nextProps.objectAri, nextProps.isDone);
        }
    }
    componentWillUnmount() {
        this.unsubscribe();
        this.mounted = false;
    }
    subscribe(taskDecisionProvider, objectAri, isDone) {
        if (taskDecisionProvider && objectAri) taskDecisionProvider.then((provider)=>{
            if (!this.mounted) return;
            const { taskId: taskId } = this.props;
            const objectKey = {
                localId: taskId,
                objectAri: objectAri
            };
            const item = {
                ...objectKey,
                state: isDone ? 'DONE' : 'TODO',
                lastUpdateDate: new Date(),
                type: 'TASK'
            };
            provider.subscribe({
                localId: taskId,
                objectAri: objectAri
            }, this.onUpdate, item);
        });
    }
    unsubscribe() {
        const { taskDecisionProvider: taskDecisionProvider, taskId: taskId, objectAri: objectAri } = this.props;
        if (taskDecisionProvider && objectAri) taskDecisionProvider.then((provider)=>{
            provider.unsubscribe({
                localId: taskId,
                objectAri: objectAri
            }, this.onUpdate);
        });
    }
    render() {
        const { isDone: isDone } = this.state;
        const { appearance: appearance, children: children, contentRef: contentRef, objectAri: objectAri, showPlaceholder: showPlaceholder, placeholder: placeholder, taskId: taskId, disabled: disabled, dataAttributes: dataAttributes, isRenderer: isRenderer, isFocused: isFocused, inputRef: inputRef } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bVYhW.FabricElementsAnalyticsContext), {
            data: {
                objectAri: objectAri
            },
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j90wU.default), {
                isDone: isDone,
                isRenderer: isRenderer,
                isFocused: isFocused,
                taskId: taskId,
                onChange: this.handleOnChange,
                onClick: this.handleOnClick,
                appearance: appearance,
                contentRef: contentRef,
                showPlaceholder: showPlaceholder,
                placeholder: placeholder,
                disabled: disabled,
                dataAttributes: dataAttributes,
                inputRef: inputRef,
                children: children
            })
        });
    }
}

});
parcelRegister("j90wU", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d00d90e1b01e141$export$2e2bcd8739ae039);
/* TaskItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $99p6k = parcelRequire("99p6k");

var $4Ao94 = parcelRequire("4Ao94");

var $1QcGX = parcelRequire("1QcGX");

var $2keUK = parcelRequire("2keUK");

var $ay5zP = parcelRequire("ay5zP");

var $ly6Dw = parcelRequire("ly6Dw");

var $3Du7S = parcelRequire("3Du7S");
const $9d00d90e1b01e141$var$CheckboxUncheckedIcon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $99p6k.Icon), {
        dangerouslySetGlyph: `<rect width="12.5" height="12.5" x="1.75" y="1.75" stroke="currentcolor" stroke-width="1.5" rx="1.25"/>`,
        type: 'core',
        ...props
    });
/**
 * References packages/design-system/checkbox/src/checkbox.tsx
 * To be used until mobile editor does not require legacy themed() API anymore,
 * which will allow migration to use @atlaskit/checkbox instead
 */ const $9d00d90e1b01e141$var$checkboxStyles = null;
let $9d00d90e1b01e141$var$taskCount = 0;
const $9d00d90e1b01e141$var$getCheckBoxId = (localId)=>`${localId}-${$9d00d90e1b01e141$var$taskCount++}`;
const $9d00d90e1b01e141$var$TaskItemWithoutRefFix = (props)=>{
    const { appearance: appearance, isDone: isDone, isFocused: isFocused, contentRef: contentRef, children: children, placeholder: placeholder, showPlaceholder: showPlaceholder, disabled: disabled, dataAttributes: dataAttributes, taskId: taskId, onChange: onChange, onClick: onClick, createAnalyticsEvent: createAnalyticsEvent } = props;
    const inputRefFromProps = props.inputRef;
    const checkBoxId = (0, $5uXOq.useMemo)(()=>$9d00d90e1b01e141$var$getCheckBoxId(taskId), [
        taskId
    ]);
    const handleOnChange = (0, $5uXOq.useMemo)(()=>{
        return (_evt)=>{
            const newIsDone = !isDone;
            if (onChange) onChange(taskId, newIsDone);
            const action = newIsDone ? 'checked' : 'unchecked';
            if (createAnalyticsEvent) (0, $ay5zP.createAndFireEventInElementsChannel)({
                action: action,
                actionSubject: 'action',
                eventType: 'ui',
                attributes: {
                    localId: taskId
                }
            })(createAnalyticsEvent);
        };
    }, [
        onChange,
        taskId,
        isDone,
        createAnalyticsEvent
    ]);
    const handleOnKeyPress = (0, $5uXOq.useMemo)(()=>(event)=>{
            if (event.key === 'Enter') handleOnChange(event);
        }, [
        handleOnChange
    ]);
    const defaultInputRef = (0, $5uXOq.useRef)(null);
    const inputRef = inputRefFromProps ?? defaultInputRef;
    const icon = /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
        contentEditable: false,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1tcg _1bsb1tcg _4t3i1tcg _kqswh2mm _1wpzv2br _1snx1r31 _1746glyw _dx3f1o36 _1h5xidpf _sqizidpf _fs2cidpf _1smcidpf _oezm15vq _1l0615vq _1abj1mn3 _18a711so _16np1elr _a27kkb7n _q3p7usvi _qhqx1nu9 _10cr1ssb _zfav1ssb _m7eu1ooe _l9o0n7od _1efjn7od _1u2istnw _32ro1j9a _1wn015vq _den5ugt7 _zh8l1b66 _g5w3stnw _whhepxbi _1stbpxbi _18tob3bt _1awt1ule _haf81ssb _ra781ssb _cr751ooe _1q8r7vkz _9l2s7vkz _1mh7kb7n _s3uktlke _1davidpf _8bo8stnw _psnc1ssb _4k421ssb _1rvv1ooe _13vl73ad _1t711tcg _1nuz1tcg _cs4qstnw _9j2j1ssb _1mwj1ssb _19l51ooe _12yy1d5g _1miy1elr _1umo18hz _tpz25w2r _k6dg18hz _1qduewfl _q8ft1fvw _1y9t5w2r _ut031fvw _gi9hr01l _1qp6muej _wxkgr01l _wo245w2r _c8dpmuej _d2dcsyzs _1eulsyzs _1bc7syzs _16fmsyzs _bhkusyzs _czfesyzs _1gxgsyzs _19w0syzs _1x1y1lg7"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                id: checkBoxId,
                "aria-labelledby": `${checkBoxId}-wrapper`,
                name: checkBoxId,
                type: "checkbox",
                onChange: handleOnChange,
                onClick: onClick,
                checked: !!isDone,
                disabled: !!disabled,
                suppressHydrationWarning: true,
                onKeyPress: handleOnKeyPress,
                ref: inputRef
            }),
            isDone ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4Ao94))), {
                label: ""
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)($9d00d90e1b01e141$var$CheckboxUncheckedIcon, {
                label: ""
            })
        ]
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        if (isFocused && inputRef.current) {
            inputRef.current?.focus();
            inputRef.current?.blur();
            setTimeout(()=>{
                inputRef.current?.focus();
            }, 100);
        }
    }, [
        isFocused,
        inputRef
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1QcGX.default), {
        appearance: appearance,
        contentRef: contentRef,
        icon: icon,
        placeholder: placeholder,
        showPlaceholder: showPlaceholder,
        itemType: "TASK",
        dataAttributes: dataAttributes,
        checkBoxId: checkBoxId,
        children: children
    });
};
const $9d00d90e1b01e141$var$TaskItemWithRefFix = (props)=>{
    const { appearance: appearance, isDone: isDone, isFocused: isFocused, contentRef: contentRef, children: children, placeholder: placeholder, showPlaceholder: showPlaceholder, disabled: disabled, dataAttributes: dataAttributes, taskId: taskId, onChange: onChange, onClick: onClick, createAnalyticsEvent: createAnalyticsEvent, inputRef: inputRefFromProps } = props;
    const checkBoxId = (0, $5uXOq.useMemo)(()=>$9d00d90e1b01e141$var$getCheckBoxId(taskId), [
        taskId
    ]);
    const handleOnChange = (0, $5uXOq.useMemo)(()=>{
        return (_evt)=>{
            const newIsDone = !isDone;
            if (onChange) onChange(taskId, newIsDone);
            const action = newIsDone ? 'checked' : 'unchecked';
            if (createAnalyticsEvent) (0, $ay5zP.createAndFireEventInElementsChannel)({
                action: action,
                actionSubject: 'action',
                eventType: 'ui',
                attributes: {
                    localId: taskId
                }
            })(createAnalyticsEvent);
        };
    }, [
        onChange,
        taskId,
        isDone,
        createAnalyticsEvent
    ]);
    const handleOnKeyPress = (0, $5uXOq.useMemo)(()=>(event)=>{
            if (event.key === 'Enter') handleOnChange(event);
        }, [
        handleOnChange
    ]);
    const localInputRef = (0, $5uXOq.useRef)(null);
    const inputRef = (0, $3Du7S.useMergeRefs)(inputRefFromProps === undefined ? [
        localInputRef
    ] : [
        inputRefFromProps,
        localInputRef
    ]);
    const icon = /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
        contentEditable: false,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1tcg _1bsb1tcg _4t3i1tcg _kqswh2mm _1wpzv2br _1snx1r31 _1746glyw _dx3f1o36 _1h5xidpf _sqizidpf _fs2cidpf _1smcidpf _oezm15vq _1l0615vq _1abj1mn3 _18a711so _16np1elr _a27kkb7n _q3p7usvi _qhqx1nu9 _10cr1ssb _zfav1ssb _m7eu1ooe _l9o0n7od _1efjn7od _1u2istnw _32ro1j9a _1wn015vq _den5ugt7 _zh8l1b66 _g5w3stnw _whhepxbi _1stbpxbi _18tob3bt _1awt1ule _haf81ssb _ra781ssb _cr751ooe _1q8r7vkz _9l2s7vkz _1mh7kb7n _s3uktlke _1davidpf _8bo8stnw _psnc1ssb _4k421ssb _1rvv1ooe _13vl73ad _1t711tcg _1nuz1tcg _cs4qstnw _9j2j1ssb _1mwj1ssb _19l51ooe _12yy1d5g _1miy1elr _1umo18hz _tpz25w2r _k6dg18hz _1qduewfl _q8ft1fvw _1y9t5w2r _ut031fvw _gi9hr01l _1qp6muej _wxkgr01l _wo245w2r _c8dpmuej _d2dcsyzs _1eulsyzs _1bc7syzs _16fmsyzs _bhkusyzs _czfesyzs _1gxgsyzs _19w0syzs _1x1y1lg7"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                id: checkBoxId,
                "aria-labelledby": `${checkBoxId}-wrapper`,
                name: checkBoxId,
                type: "checkbox",
                onChange: handleOnChange,
                onClick: onClick,
                checked: !!isDone,
                disabled: !!disabled,
                suppressHydrationWarning: true,
                onKeyPress: handleOnKeyPress,
                ref: inputRef
            }),
            isDone ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4Ao94))), {
                label: ""
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)($9d00d90e1b01e141$var$CheckboxUncheckedIcon, {
                label: ""
            })
        ]
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        if (isFocused && inputRef.current) {
            inputRef.current?.focus();
            inputRef.current?.blur();
            setTimeout(()=>{
                inputRef.current?.focus();
            }, 100);
        }
    }, [
        isFocused,
        inputRef
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1QcGX.default), {
        appearance: appearance,
        contentRef: contentRef,
        icon: icon,
        placeholder: placeholder,
        showPlaceholder: showPlaceholder,
        itemType: "TASK",
        dataAttributes: dataAttributes,
        checkBoxId: checkBoxId,
        children: children
    });
};
var // This is to ensure that the "type" is exported, as it gets lost and not exported along with TaskItem after
// going through the high order component.
$9d00d90e1b01e141$export$2e2bcd8739ae039 = (0, $ly6Dw.componentWithFG)('platform_editor_task_item_ref_fix', (0, $2keUK.default)()($9d00d90e1b01e141$var$TaskItemWithRefFix), (0, $2keUK.default)()($9d00d90e1b01e141$var$TaskItemWithoutRefFix));

});
parcelRegister("4Ao94", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f3359cfcb124b9edec9402a579fa9711>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $356d40fa9c110a62$var$_react = $356d40fa9c110a62$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $356d40fa9c110a62$var$_baseNew = $356d40fa9c110a62$var$_interopRequireDefault((parcelRequire("9ogAd")));
function $356d40fa9c110a62$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $356d40fa9c110a62$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $356d40fa9c110a62$var$_react.default.createElement($356d40fa9c110a62$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$356d40fa9c110a62$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $356d40fa9c110a62$var$_default = module.exports.default = $356d40fa9c110a62$var$CheckboxCheckedIcon;

});

parcelRegister("ay5zP", function(module, exports) {

$parcel$export(module.exports, "createAndFireEventInElementsChannel", () => $c6f2c590dff17b42$export$53eef0dcd9611650);

var $iBouS = parcelRequire("iBouS");
const $c6f2c590dff17b42$export$7ba5d2eed2cf9f14 = 'fabric-elements';
const $c6f2c590dff17b42$export$53eef0dcd9611650 = (0, $iBouS.default)($c6f2c590dff17b42$export$7ba5d2eed2cf9f14);

});

parcelRegister("ly6Dw", function(module, exports) {

$parcel$export(module.exports, "componentWithFG", () => $ac69708986491a41$export$cf56d0f54cfcce4);

var $hFKXd = parcelRequire("hFKXd");

var $03yqe = parcelRequire("03yqe");
const $ac69708986491a41$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $03yqe.componentWithCondition)(()=>(0, $hFKXd.fg)(featureFlagName), ComponentTrue, ComponentFalse);

});
parcelRegister("03yqe", function(module, exports) {

$parcel$export(module.exports, "componentWithCondition", () => $1027f01f7514a396$export$6e8ea24b15199873);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $1027f01f7514a396$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>condition() ? /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});






parcelRegister("3uoJx", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c39ee5bc990a05e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $33Vme = parcelRequire("33Vme");
class $7c39ee5bc990a05e$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    render() {
        const { children: children, localId: localId } = this.props;
        if ((0, $5uXOq.Children).count(children) === 0) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $33Vme.default), {
            listId: localId,
            children: children
        });
    }
}

});
parcelRegister("33Vme", function(module, exports) {

$parcel$export(module.exports, "default", () => $e412d0e7ff7c4c62$export$2e2bcd8739ae039);
/* TaskList.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $bVYhW = parcelRequire("bVYhW");

var $hFKXd = parcelRequire("hFKXd");

var $nBQ2N = parcelRequire("nBQ2N");

var $koVbs = parcelRequire("koVbs");
const $e412d0e7ff7c4c62$var$listStyles = null;
const $e412d0e7ff7c4c62$var$taskListStyles = null;
const $e412d0e7ff7c4c62$var$TaskListNew = ({ listId: listId, children: children })=>{
    const listSize = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.count(children);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!children) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "group",
        "data-task-list-local-id": "",
        "aria-label": formatMessage((0, $nBQ2N.messages).fieldsetLabel),
        className: (0, $bwpsq.default)([
            "_2mzuglyw _19bvidpf"
        ]),
        children: (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (child, idx)=>{
            const { localId: localId } = child.props;
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bVYhW.FabricElementsAnalyticsContext), {
                data: {
                    listLocalId: listId,
                    listSize: listSize,
                    position: idx
                },
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    "data-task-local-id": localId || '',
                    className: (0, $bwpsq.default)([
                        "_19pk1b66"
                    ]),
                    children: child
                }, idx)
            });
        })
    });
};
class $e412d0e7ff7c4c62$var$TaskListOld extends (0, $5uXOq.PureComponent) {
    render() {
        const { listId: listId, children: children } = this.props;
        const listSize = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.count(children);
        if (!children) return null;
        // Data attributes are required for copy and paste from rendered content
        // to the editor to preserve the task.
        // This allows the editor to differentiate between numbered and ordered lists,
        // and action items, which all share the common `<li>` element.
        // The value of `data-task-local-id` should be discarded upon paste, with a
        // a new uuid generated by the editor for the cloned content.
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-task-list-local-id": "",
            className: (0, $bwpsq.default)([
                "_2mzuglyw _19bvidpf"
            ]),
            children: (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (child, idx)=>{
                const { localId: localId } = child.props;
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bVYhW.FabricElementsAnalyticsContext), {
                    data: {
                        listLocalId: listId,
                        listSize: listSize,
                        position: idx
                    },
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        "data-task-local-id": localId || '',
                        className: (0, $bwpsq.default)([
                            "_19pk1b66"
                        ]),
                        children: child
                    }, idx)
                });
            })
        });
    }
}
const $e412d0e7ff7c4c62$var$TaskListNext = (props)=>{
    if ((0, $hFKXd.fg)('editor_a11y_group_around_action_items')) return /*#__PURE__*/ (0, $2OMIu.jsx)($e412d0e7ff7c4c62$var$TaskListNew, {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($e412d0e7ff7c4c62$var$TaskListOld, {
        ...props
    });
};
var $e412d0e7ff7c4c62$export$2e2bcd8739ae039 = $e412d0e7ff7c4c62$var$TaskListNext;

});
parcelRegister("nBQ2N", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2af28b12fb1913eb$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $2af28b12fb1913eb$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    fieldsetLabel: {
        id: 'fabric.editor.fieldsetLabel',
        defaultMessage: 'Action Item List',
        description: 'Label for a list of tasks/ action items'
    }
});

});



parcelRegister("dYJ87", function(module, exports) {

$parcel$export(module.exports, "default", () => $7376fa1d48afad72$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");

var $idZJp = parcelRequire("idZJp");

var $35Qxd = parcelRequire("35Qxd");
var $jIqBR = parcelRequire("jIqBR");

var $9KcbK = parcelRequire("9KcbK");

var $rxITi = parcelRequire("rxITi");

var $hOMSp = parcelRequire("hOMSp");

var $9fYN9 = parcelRequire("9fYN9");

var $2qH5P = parcelRequire("2qH5P");

var $3ZT8o = parcelRequire("3ZT8o");

var $8RXs9 = parcelRequire("8RXs9");

var $4q2AX = parcelRequire("4q2AX");

var $bXrOd = parcelRequire("bXrOd");
function $7376fa1d48afad72$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7376fa1d48afad72$var$titleStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    outline: 'none',
    border: 'none',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: `${0.875}rem`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
    lineHeight: (0, $9KcbK.akEditorLineHeight),
    fontWeight: "var(--ds-font-weight-regular, 400)",
    display: 'flex',
    flex: 1,
    margin: 0,
    padding: `0 0 0 ${"var(--ds-space-050, 4px)"}`,
    textAlign: 'left'
});
const $7376fa1d48afad72$var$containerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'transparent',
    borderRadius: "var(--ds-border-radius-100, 4px)",
    minHeight: '25px',
    background: "var(--ds-background-neutral-subtle, transparent)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `background 0.3s ${(0, $9KcbK.akEditorSwoopCubicBezier)}, border-color 0.3s ${(0, $9KcbK.akEditorSwoopCubicBezier)}`,
    padding: "var(--ds-space-0, 0px)",
    paddingBottom: "var(--ds-space-0, 0px)",
    marginTop: "var(--ds-space-050, 0.25rem)",
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'td > :not(style):first-child, td > style:first-child + *': {
        marginTop: 0
    }
});
const $7376fa1d48afad72$var$containerStylesExpanded = {
    name: "1ynzp6s",
    styles: "background:var(--ds-surface, rgba(255, 255, 255, 0.6));padding-bottom:var(--ds-space-100, 8px);border-color:var(--ds-border, #091E4224)"
};
const $7376fa1d48afad72$var$containerStylesFocused = {
    name: "12e71wc",
    styles: "border-color:var(--ds-border-focused, #388BFF)"
};
const $7376fa1d48afad72$var$containerStylesDataNodeTypeExpand = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    marginLeft: `-${(0, $9KcbK.akLayoutGutterOffset)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    marginRight: `-${(0, $9KcbK.akLayoutGutterOffset)}px`
});
const $7376fa1d48afad72$var$titleContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    alignItems: 'flex-start',
    background: 'none',
    border: 'none',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: `${0.875}rem`,
    width: '100%',
    color: "var(--ds-text-subtle, #44546F)",
    overflow: 'hidden',
    cursor: 'pointer',
    padding: "var(--ds-space-100, 8px)",
    '&:focus': {
        outline: 0
    }
});
const $7376fa1d48afad72$var$titleContainerStylesExpanded = {
    name: "dkidh7",
    styles: "padding-bottom:var(--ds-space-0, 0px)"
};
const $7376fa1d48afad72$var$contentContainerStyles = {
    name: "288te1",
    styles: "padding-top:var(--ds-space-0, 0px);margin-left:var(--ds-space-050, 4px);padding-right:var(--ds-space-200, 16px);padding-left:var(--ds-space-400, 32px);display:flow-root;visibility:hidden;@supports not (display: flow-root){width:100%;box-sizing:border-box;}"
};
const $7376fa1d48afad72$var$contentContainerStylesExpanded = {
    name: "xhzdsf",
    styles: "padding-top:var(--ds-space-100, 8px);visibility:visible"
};
const $7376fa1d48afad72$var$contentContainerStylesNotExpanded = {
    name: "1njmbsg",
    styles: ".expand-content-wrapper, .nestedExpand-content-wrapper{width:100%;display:block;height:0;overflow:hidden;clip:rect(1px, 1px, 1px, 1px);user-select:none;}"
};
const $7376fa1d48afad72$var$clearNextSiblingMarginTopStyle = {
    name: "1f3w791",
    styles: "& + *{margin-top:0 !important;}"
};
const $7376fa1d48afad72$var$Container = (props)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $7376fa1d48afad72$var$containerStyles,
            props['data-node-type'] === 'expand' && $7376fa1d48afad72$var$containerStylesDataNodeTypeExpand,
            props.expanded && $7376fa1d48afad72$var$containerStylesExpanded,
            props.focused && $7376fa1d48afad72$var$containerStylesFocused
        ],
        ...props
    }, props.children);
};
const $7376fa1d48afad72$var$TitleContainer = (props)=>{
    const { expanded: expanded, ...buttonProps } = props;
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-button
    /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        type: "button",
        css: [
            $7376fa1d48afad72$var$titleContainerStyles,
            expanded && $7376fa1d48afad72$var$titleContainerStylesExpanded
        ],
        ...buttonProps
    }, props.children));
};
$7376fa1d48afad72$var$TitleContainer.displayName = 'TitleContainerButton';
const $7376fa1d48afad72$var$ContentContainer = (props)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $7376fa1d48afad72$var$contentContainerStyles,
            props.expanded && $7376fa1d48afad72$var$contentContainerStylesExpanded,
            !props.expanded && $7376fa1d48afad72$var$contentContainerStylesNotExpanded
        ],
        ...props
    }, props.children);
};
function $7376fa1d48afad72$var$fireExpandToggleAnalytics(nodeType, expanded, fireAnalyticsEvent) {
    if (!fireAnalyticsEvent) return;
    fireAnalyticsEvent({
        action: (0, $idZJp.ACTION).TOGGLE_EXPAND,
        actionSubject: nodeType === 'expand' ? (0, $idZJp.ACTION_SUBJECT).EXPAND : (0, $idZJp.ACTION_SUBJECT).NESTED_EXPAND,
        attributes: {
            platform: (0, $4q2AX.PLATFORM).WEB,
            mode: (0, $4q2AX.MODE).RENDERER,
            expanded: !expanded
        },
        eventType: (0, $idZJp.EVENT_TYPE).TRACK
    });
}
function $7376fa1d48afad72$var$Expand({ title: title, children: children, nodeType: nodeType, intl: intl, fireAnalyticsEvent: fireAnalyticsEvent, nestedHeaderIds: nestedHeaderIds, rendererAppearance: rendererAppearance }) {
    const [expanded, setExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(false);
    const [focused, setFocused] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(false);
    const isMobile = false;
    const label = intl.formatMessage(expanded ? (0, $35Qxd.messages).collapseNode : (0, $35Qxd.messages).expandNode);
    const { current: id } = (0, $5uXOq.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($3ZT8o)))('expand-title-'));
    const handleFocus = (0, $5uXOq.useCallback)(()=>setFocused(true), []);
    const handleBlur = (0, $5uXOq.useCallback)(()=>setFocused(false), []);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($7376fa1d48afad72$var$Container, {
        "data-testid": `expand-container-${nodeType}-${id}`,
        "data-node-type": nodeType,
        "data-title": title,
        "data-expanded": expanded,
        expanded: expanded,
        focused: focused
    }, nestedHeaderIds && nestedHeaderIds.length > 0 ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bXrOd.ActiveHeaderIdConsumer), {
        nestedHeaderIds: nestedHeaderIds,
        onNestedHeaderIdMatch: ()=>setExpanded(true)
    }) : null, /*#__PURE__*/ (0, $f8Sb3.jsx)($7376fa1d48afad72$var$TitleContainer, {
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            $7376fa1d48afad72$var$fireExpandToggleAnalytics(nodeType, expanded, fireAnalyticsEvent);
            setExpanded(!expanded);
            e.persist();
            // @ts-ignore detail doesn't exist on type
            e.detail ? handleBlur() : handleFocus();
        },
        onFocus: handleFocus,
        onBlur: handleBlur,
        "aria-labelledby": id,
        "aria-expanded": expanded,
        contentEditable: false,
        expanded: expanded
    }, isMobile ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $35Qxd.ExpandIconWrapper), {
        expanded: expanded
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hOMSp))), {
        label: label,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($rxITi))),
        spacing: "spacious"
    })) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9fYN9.default), {
        content: label,
        position: "top",
        // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        tag: (0, $35Qxd.ExpandLayoutWrapperWithRef),
        testId: 'tooltip'
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $35Qxd.ExpandIconWrapper), {
        expanded: expanded
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hOMSp))), {
        label: label,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($rxITi))),
        spacing: "spacious"
    }))), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $7376fa1d48afad72$var$titleStyles,
        id: id
    }, title || intl.formatMessage((0, $35Qxd.messages).expandDefaultTitle))), /*#__PURE__*/ (0, $f8Sb3.jsx)($7376fa1d48afad72$var$ContentContainer, {
        expanded: expanded
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        className: `${nodeType}-content-wrapper`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jIqBR.WidthProvider), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $7376fa1d48afad72$var$clearNextSiblingMarginTopStyle
    }), (0, $2qH5P.editorExperiment)('confluence_p2m_style_recalc_and_expand_joint_exp', true, {
        exposure: true
    }) ? expanded && children : children))));
}
var $7376fa1d48afad72$export$2e2bcd8739ae039 = (0, $8RXs9.default)($7376fa1d48afad72$var$Expand);

});
parcelRegister("35Qxd", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0b7b5667b70d1b1c$export$defe85febe8b728c);
$parcel$export(module.exports, "ExpandIconWrapper", () => $0b7b5667b70d1b1c$export$4eeef63d68e77552);
$parcel$export(module.exports, "expandLayoutWrapperStyle", () => $0b7b5667b70d1b1c$export$a7ed6bf20867161a);
$parcel$export(module.exports, "ExpandLayoutWrapperWithRef", () => $0b7b5667b70d1b1c$export$c67faf67c1185cba);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $7VHMR = parcelRequire("7VHMR");

var $9KcbK = parcelRequire("9KcbK");
function $0b7b5667b70d1b1c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0b7b5667b70d1b1c$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    collapseNode: {
        id: 'fabric.editor.collapseNode',
        defaultMessage: 'Collapse content',
        description: 'Collapse the node'
    },
    expandDefaultTitle: {
        id: 'fabric.editor.expandDefaultTitle',
        defaultMessage: 'Click here to expand...',
        description: 'Placeholder text for an expand node'
    },
    expandNode: {
        id: 'fabric.editor.expandNode',
        defaultMessage: 'Expand content',
        description: 'Expand the node'
    },
    expandPlaceholderText: {
        id: 'fabric.editor.expandPlaceholder',
        defaultMessage: 'Give this expand a title...',
        description: 'Placeholder text for an expand node title input field'
    },
    expandArialabel: {
        id: 'fabric.editor.expandAriaLabel',
        defaultMessage: 'Give this expand a title',
        description: 'aria label for an expand node title input field'
    }
});
const $0b7b5667b70d1b1c$export$4eeef63d68e77552 = ({ children: children, expanded: expanded })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: ()=>expanded ? [
                $0b7b5667b70d1b1c$var$expandIconWrapperStyle(),
                $0b7b5667b70d1b1c$var$expandIconWrapperExpandedStyle
            ] : $0b7b5667b70d1b1c$var$expandIconWrapperStyle()
    }, children);
};
const $0b7b5667b70d1b1c$var$expandIconWrapperStyle = ()=>/*#__PURE__*/ (0, $f8Sb3.css)({
        cursor: 'pointer',
        display: 'flex',
        color: "var(--ds-icon, #44546F)",
        borderRadius: "var(--ds-border-radius-100, 4px)",
        width: '24px',
        height: '24px',
        '&:hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        svg: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transition: `transform 0.2s ${(0, $9KcbK.akEditorSwoopCubicBezier)}`
        }
    });
const $0b7b5667b70d1b1c$var$expandIconWrapperExpandedStyle = {
    name: "1uoxr6z",
    styles: "svg{transform:rotate(90deg);}"
};
const $0b7b5667b70d1b1c$export$a7ed6bf20867161a = {
    name: "ljflj6",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
};
const $0b7b5667b70d1b1c$export$c67faf67c1185cba = /*#__PURE__*/ (0, $5uXOq.forwardRef)(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(props, ref)=>{
    const { children: children, ...rest } = props;
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $0b7b5667b70d1b1c$export$a7ed6bf20867161a,
        ...rest,
        ref: ref
    }, children));
});

});

parcelRegister("3ZT8o", function(module, exports) {

var $jJVtR = parcelRequire("jJVtR");
/** Used to generate unique IDs. */ var $2e91d6202798e8a1$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $2e91d6202798e8a1$var$uniqueId(prefix) {
    var id = ++$2e91d6202798e8a1$var$idCounter;
    return $jJVtR(prefix) + id;
}
module.exports = $2e91d6202798e8a1$var$uniqueId;

});




//# sourceMappingURL=small-nodes.9cce3500.js.map
